import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { connect } from "react-redux";
import { Link, withRouter } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import {
  PDFViewer,
  Page,
  Text,
  View,
  Document,
  StyleSheet,
  Image,
} from "@react-pdf/renderer";
// Add this near your other action imports (around line 55)
import { sendConfirmationSms } from "../../actions/smsActions";
import {
  provisionVideoSession,
  patientGenerateToken,
  doctorRejoinSession,
  getRecUrl,
} from "../../actions/videoActions";
import {
  getExerciseAssignments,
  createExerciseAssignment,
  updateExerciseAssignment,
  deleteExerciseAssignment,
} from "../../actions/exerciseAssignmentAction";
// Add these to your action imports
import { 
  getDiet, 
} from "../../actions/dietActions";
import { 
  listDietTemplates, 
  getDietTemplateById 
} from "../../actions/dietTemplateAction";
import { 
  getPatientDiet, 
  createPatientDiet, 
  updatePatientDiet, 
  deletePatientDiet 
} from "../../actions/patientDietActions"; // Ensure this path is correct
import { listExerciseTemplates , getExerciseTemplateById} from "../../actions/exerciseTemplateAction";
import { getExercise } from "../../actions/exerciseAction";
import {
  getAllAppointments,
  updateAppointment,
} from "../../actions/appointmentActions";
import { getAllPatientProfiles } from "../../actions/patientProfileActions";
import {
  createPrescription,
  getAllPrescriptions,
  updatePrescription,
  deletePrescription,
} from "../../actions/prescriptionActions";
import {
  createMedicalRecord,
  getAllMedicalRecords,
  deleteMedicalRecord,
  updateMedicalRecord,
} from "../../actions/medicalRecordActions";
import { getDoctorProfileById } from "../../actions/doctorActions";
import { listAllInvoices } from "../../actions/invoiceActions";
import { getReportSettings } from "../../actions/reportSettingsActions";
import { imgUrl } from "../../actions/types";

// Component Imports
import MessageModal from "../Pages/MessageModel";

import { useHistory } from "react-router-dom/cjs/react-router-dom.min";

// Add this helper function to check if current time is within appointment slot
const isWithinAppointmentTime = (appointmentDate, appointmentTime) => {
  const now = new Date();
  const appointmentDateTime = new Date(appointmentDate);

  // Parse the time string (format like "10:30 AM")
  const [time, modifier] = appointmentTime.split(" ");
  let [hours, minutes] = time.split(":");

  hours = parseInt(hours);
  minutes = parseInt(minutes);

  // Convert to 24-hour format
  if (modifier === "PM" && hours < 12) hours += 12;
  if (modifier === "AM" && hours === 12) hours = 0;

  // Set the time on the appointment date
  appointmentDateTime.setHours(hours, minutes, 0, 0);

  // Calculate start and end times (15 minutes before and 1 hour after)
  const startTime = new Date(appointmentDateTime.getTime() - 15 * 60 * 1000); // 15 mins before
  const endTime = new Date(appointmentDateTime.getTime() + 60 * 60 * 1000); // 1 hour after

  return now >= startTime && now <= endTime;
};
// --- Helper Functions (No Changes) ---
const calculateBmi = (weight, height) => {
  const weightKg = parseFloat(weight);
  const heightCm = parseFloat(height);
  if (!weightKg || !heightCm || weightKg <= 0 || heightCm <= 0) return "N/A";
  const heightM = heightCm / 100;
  const bmi = weightKg / (heightM * heightM);
  return bmi.toFixed(1);
};
const getBmiStatus = (bmi) => {
  const bmiValue = parseFloat(bmi);
  if (isNaN(bmiValue) || bmiValue <= 0)
    return { status: "N/A", className: "text-muted" };
  if (bmiValue < 18.5) return { status: "Underweight", className: "text-info" };
  if (bmiValue <= 24.9) return { status: "Normal", className: "text-success" };
  if (bmiValue <= 29.9)
    return { status: "Overweight", className: "text-warning" };
  return { status: "Obesity", className: "text-danger" };
};
const getInvoiceBadgeClass = (status) => {
  switch (status) {
    case "Paid":
      return "bg-success-light";
    case "Pending":
      return "bg-warning-light";
    case "Cancelled":
      return "bg-danger-light";
    default:
      return "bg-light text-dark";
  }
};

// ===================================================================
// ✅ 1. UPDATED PDF STYLES OBJECT
// New styles for lists (ul, li), h2, underline, and strikethrough.
// ===================================================================
// const professionalPdfStyles = StyleSheet.create({
//   // --- 1. General Page Layout ---
//   page: { 
//     fontFamily: "Helvetica", 
//     fontSize: 10, 
//     paddingTop: 110,    // Clinic Header ke niche jagah chhodne ke liye
//     paddingBottom: 60, 
//     paddingLeft: 40, 
//     paddingRight: 40, 
//     color: "#333" 
//   },

//   // --- 2. Professional Header (Clinic Details) ---
//   header: {
//     position: "absolute", top: 25, left: 40, right: 40,
//     flexDirection: "row", justifyContent: "space-between", alignItems: "center",
//     borderBottomWidth: 1, borderBottomColor: "#007bff", paddingBottom: 10,
//   },
//   headerCol: { width: "33.33%" },
//   headerLogo: { width: 60, height: 60, objectFit: "contain" },
//   headerTitle: { fontSize: 20, fontFamily: "Helvetica-Bold", color: "#007bff", textAlign: "center" },
//   headerDoctorDetails: { textAlign: "right" },
//   doctorName: { fontSize: 11, fontFamily: "Helvetica-Bold" },
//   doctorSubtext: { fontSize: 8, color: "#555" },

//   // --- 3. Patient Info Box (Upper section) ---
//   infoSection: {
//     flexDirection: "row", justifyContent: "space-between",
//     borderWidth: 1, borderColor: "#e0e0e0", borderRadius: 4, padding: 10,
//     marginBottom: 20, backgroundColor: "#f8f9fa",
//   },
//   infoColumn: { flexBasis: "48%" },
//   label: { fontFamily: "Helvetica-Bold", color: "#555" },

//   // --- 4. EXERCISE SPECIFIC STYLES (Blue Theme) ---
//   exerciseHeader: { 
//     backgroundColor: "#f0f7ff", 
//     padding: 8, 
//     marginBottom: 5,
//     borderBottomWidth: 1, 
//     borderBottomColor: "#007bff", // Sirf niche line, side mein nahi
//     flexDirection: "row",
//     justifyContent: "space-between"
//   },
//   exerciseTitle: { fontFamily: "Helvetica-Bold", fontSize: 11, color: "#007bff" },
//   stepBox: { 
//     flexDirection: "row", 
//     paddingVertical: 10, 
//     borderBottomWidth: 0.5, 
//     borderBottomColor: "#eeeeee",
//     marginBottom: 5 
//   },
//   stepImage: { width: "100%", height: 90, objectFit: "contain", borderRadius: 4 },

//   // --- 5. DIET SPECIFIC STYLES (Orange Theme) ---
//   dietHeader: { 
//     backgroundColor: "#fff4e6", 
//     padding: 8, 
//     marginBottom: 5,
//     borderBottomWidth: 1, 
//     borderBottomColor: "#ff8c00", // Orange color for Diet
//     flexDirection: "row",
//     justifyContent: "space-between"
//   },
//   dietTitle: { fontFamily: "Helvetica-Bold", fontSize: 11, color: "#d97706" },

//   // --- 6. COMMON TABLE STYLES (Used for Diet) ---
//   table: { 
//     width: "100%", 
//     borderWidth: 1, 
//     borderColor: "#e0e0e0", 
//     borderRadius: 4, 
//     overflow: "hidden" 
//   },
//   tableRow: { flexDirection: "row" },
//   tableHeader: { backgroundColor: "#f8f9fa", borderBottomWidth: 1, borderBottomColor: "#e0e0e0" },
//   tableColTime: { width: "25%", padding: 6, borderRightWidth: 1, borderRightColor: "#e0e0e0" },
//   tableColDetails: { width: "75%", padding: 6 },
//   tableHeaderCell: { fontFamily: "Helvetica-Bold", fontSize: 9, color: "#555" },
//   tableCell: { fontSize: 9 },

//   // --- 7. Footer ---
//   footer: { 
//     position: "absolute", bottom: 20, left: 40, right: 40, 
//     textAlign: "center", fontSize: 8, color: "#999", 
//     borderTopWidth: 0.5, borderTopColor: "#ccc", paddingTop: 5 
//   }
// });
const professionalPdfStyles = StyleSheet.create({
  // --- Page & Layout ---
  page: { 
    fontFamily: "Helvetica", fontSize: 10, color: "#333",
    paddingTop: 110, paddingBottom: 60, paddingLeft: 40, paddingRight: 40 
  },

  // --- Professional Header (Clinic Details) ---
  header: {
    position: "absolute", top: 25, left: 40, right: 40,
    flexDirection: "row", justifyContent: "space-between", alignItems: "center",
    borderBottomWidth: 1, borderBottomColor: "#007bff", paddingBottom: 10,
  },
  headerCol: { width: "33.33%" },
  headerLogo: { width: 60, height: 60, objectFit: "contain" },
  headerTitle: { fontSize: 20, fontFamily: "Helvetica-Bold", color: "#007bff", textAlign: "center" },
  headerDoctorDetails: { textAlign: "right" },
  doctorName: { fontSize: 11, fontFamily: "Helvetica-Bold" },
  doctorSubtext: { fontSize: 8, color: "#555" },

  // --- Patient Info section ---
  infoSection: {
    flexDirection: "row", justifyContent: "space-between",
    borderWidth: 1, borderColor: "#e0e0e0", borderRadius: 4, padding: 10,
    marginBottom: 20, backgroundColor: "#f8f9fa",
  },
  infoColumn: { flexBasis: "48%" },
  label: { fontFamily: "Helvetica-Bold", color: "#555" },

  // ✅ EXERCISE STYLES (Blue Theme - No Vertical Line)
  exerciseHeader: { 
    backgroundColor: "#f0f7ff", padding: 8, marginBottom: 5,
    borderBottomWidth: 1, borderBottomColor: "#007bff", // Sirf niche line
    flexDirection: "row", justifyContent: "space-between"
  },
  exerciseTitle: { fontFamily: "Helvetica-Bold", fontSize: 11, color: "#007bff" },
  stepBox: { 
    flexDirection: "row", paddingVertical: 10, 
    borderBottomWidth: 0.5, borderBottomColor: "#eeeeee", marginBottom: 5 
  },
  stepImage: { width: "100%", height: 90, objectFit: "contain", borderRadius: 4 },

  // ✅ DIET STYLES (Orange Theme)
  dietHeader: { 
    backgroundColor: "#fff4e6", padding: 8, marginBottom: 5,
    borderBottomWidth: 1, borderBottomColor: "#ff8c00",
    flexDirection: "row", justifyContent: "space-between"
  },
  dietTitle: { fontFamily: "Helvetica-Bold", fontSize: 11, color: "#d97706" },

  // ✅ TABLE STYLES (Padding aur Row lines ke liye)
  table: { 
    width: "100%", borderWidth: 1, borderColor: "#e0e0e0", 
    borderRadius: 4, overflow: "hidden" 
  },
  tableRow: { 
    flexDirection: "row",
    borderBottomWidth: 1,      // Rows ke beech gray line
    borderBottomColor: "#e0e0e0" 
  },
  tableHeader: { 
    backgroundColor: "#f8f9fa", borderBottomWidth: 1, borderBottomColor: "#e0e0e0" 
  },
  tableColTime: { 
    width: "25%", padding: 6, paddingLeft: 12, // LEFT PADDING ADDED
    borderRightWidth: 1, borderRightColor: "#e0e0e0" 
  },
  tableColDetails: { width: "75%", padding: 6, paddingLeft: 10 },
  tableHeaderCell: { fontFamily: "Helvetica-Bold", fontSize: 9, color: "#555" },
  tableCell: { fontSize: 9 },

  footer: { 
    position: "absolute", bottom: 20, left: 40, right: 40, 
    textAlign: "center", fontSize: 8, color: "#999", 
    borderTopWidth: 0.5, borderTopColor: "#ccc", paddingTop: 5 
  }
});
const pdfStyles = StyleSheet.create({
  page: {
    fontFamily: "Helvetica",
    fontSize: 10,
    padding: "120px 40px 80px 40px",
    color: "#333",
  },
  label: { fontFamily: "Helvetica-Bold", color: "#555" },
  text: { fontSize: 10, lineHeight: 1.4 },

  // Styles for HTML Rendering
  h1: { fontSize: 18, fontFamily: "Helvetica-Bold", marginBottom: 8 },
  h2_text: { fontSize: 16, fontFamily: "Helvetica-Bold", marginBottom: 6 },
  p: { marginBottom: 5 },
  bold: { fontFamily: "Helvetica-Bold" },
  italic: { fontFamily: "Helvetica-Oblique" },
  underline: { textDecoration: "underline" },
  strikethrough: { textDecoration: "line-through" },
  list: { marginBottom: 5 },
  listItem: { flexDirection: "row", marginBottom: 3 },
  bulletPoint: { width: 15, textAlign: "center" },
  listItemContent: { flex: 1 },

  // Main PDF Styles
  h2: {
    fontSize: 14,
    fontFamily: "Helvetica-Bold",
    color: "#000",
    marginBottom: 10,
    borderBottomWidth: 1,
    borderBottomColor: "#e0e0e0",
    paddingBottom: 3,
  },
  header: {
    position: "absolute",
    top: 25,
    left: 40,
    right: 40,
    borderBottomWidth: 2,
    borderBottomColor: "#007bff",
    paddingBottom: 10,
    display: "flex",
    flexDirection: "row",
    justifyContent: "space-between",
    alignItems: "center",
  },
  headerLogo: { width: 70, height: 70, objectFit: "contain" },
  headerTextContainer: { flex: 1, marginLeft: 20 },
  headerText: { fontSize: 10, color: "#444" },
  footer: {
    position: "absolute",
    bottom: 20,
    left: 40,
    right: 40,
    fontSize: 8,
    color: "#888",
  },
  footerText: { marginBottom: 2 },
  pageNumber: {
    position: "absolute",
    bottom: 0,
    right: 0,
    fontSize: 8,
    color: "#888",
  },
  section: { marginBottom: 15 },
  infoSection: {
    flexDirection: "row",
    justifyContent: "space-between",
    border: "1px solid #e0e0e0",
    borderRadius: 4,
    padding: 10,
    marginBottom: 20,
    backgroundColor: "#f8f9fa",
  },
  infoColumn: { flexBasis: "48%" },
  table: {
    display: "table",
    width: "auto",
    borderStyle: "solid",
    borderWidth: 1,
    borderColor: "#e0e0e0",
    borderRadius: 4,
    overflow: "hidden",
  },
  tableRow: { flexDirection: "row" },
  tableHeader: {
    backgroundColor: "#f0f0f0",
    borderBottomWidth: 1,
    borderBottomColor: "#e0e0e0",
  },
  tableCol: {
    padding: 6,
    borderStyle: "solid",
    borderWidth: 1,
    borderColor: "#e0e0e0",
    borderLeftWidth: 0,
    borderTopWidth: 0,
  },
  tableCell: { fontSize: 9 },
  tableHeaderCell: { fontFamily: "Helvetica-Bold", fontSize: 10 },
  signatureSection: {
    position: "absolute",
    bottom: 80,
    right: 40,
    textAlign: "center",
  },
  signatureImage: { width: 120, height: 40, objectFit: "contain" },
  signatureLine: {
    borderTopWidth: 1,
    borderTopColor: "#333",
    width: 120,
    marginTop: 40,
    marginBottom: 5,
  },
  signatureText: { fontSize: 10, fontFamily: "Helvetica-Bold", marginLeft: 10 },
});
const ProfessionalReportHeader = ({ doctor, title }) => (
  <View style={professionalPdfStyles.header} fixed>
    <View style={professionalPdfStyles.headerCol}>
      {doctor?.ClinicLogo ? (
        <Image style={professionalPdfStyles.headerLogo} src={`${imgUrl}${doctor.ClinicLogo}`} />
      ) : null}
    </View>
    <View style={professionalPdfStyles.headerCol}>
      <Text style={professionalPdfStyles.headerTitle}>{title}</Text>
    </View>
    <View style={[professionalPdfStyles.headerCol, professionalPdfStyles.headerDoctorDetails]}>
      <Text style={professionalPdfStyles.doctorName}>Dr. {doctor?.firstName} {doctor?.lastName}</Text>
      <Text style={professionalPdfStyles.doctorSubtext}>{doctor?.Specializations?.[0]?.Specialization || "Specialist"}</Text>
      <Text style={professionalPdfStyles.doctorSubtext}>Reg: {doctor?.hospitalID}</Text>
    </View>
  </View>
);
// ===================================================================
// ✅ 2. NEW & IMPROVED HTML PARSER COMPONENT
// This recursive component correctly handles nested tags and lists.
// ===================================================================
const Html = ({ children: htmlString }) => {
  if (typeof htmlString !== "string" || !htmlString.trim()) {
    return <Text>{htmlString || ""}</Text>;
  }

  const cleanedHtml = htmlString.replace(/[\r\n\t]+/g, "").trim();

  // --- RENDER LOGIC ---
  const renderNode = (nodeHtml, key) => {
    // Match block-level tags first
    const blockMatch = nodeHtml.match(/^<(ul|p|h1|h2)>(.*)<\/\1>$/);
    if (blockMatch) {
      const tagName = blockMatch[1];
      const content = blockMatch[2];

      if (tagName === "ul") {
        const liMatches = content.match(/<li>(.*?)<\/li>/g) || [];
        return (
          <View key={key} style={pdfStyles.list}>
            {liMatches.map((liHtml, index) => {
              const liContent = liHtml.substring(4, liHtml.length - 5);
              return (
                <View key={index} style={pdfStyles.listItem}>
                  <Text style={pdfStyles.bulletPoint}>•</Text>
                  <Text style={pdfStyles.listItemContent}>
                    <Html>{liContent}</Html>
                  </Text>
                </View>
              );
            })}
          </View>
        );
      }
      const style =
        tagName === "h1"
          ? pdfStyles.h1
          : tagName === "h2"
            ? pdfStyles.h2_text
            : pdfStyles.p;
      return (
        <Text key={key} style={style}>
          <Html>{content}</Html>
        </Text>
      );
    }

    // Match inline tags
    const inlineMatch = cleanedHtml.match(/<(strong|em|b|i|u|s)>(.*?)<\/\1>/);
    if (inlineMatch) {
      const before = cleanedHtml.substring(0, inlineMatch.index);
      const tag = inlineMatch[1];
      const content = inlineMatch[2];
      const after = cleanedHtml.substring(
        inlineMatch.index + inlineMatch[0].length,
      );

      const style =
        tag === "strong" || tag === "b"
          ? pdfStyles.bold
          : tag === "em" || tag === "i"
            ? pdfStyles.italic
            : tag === "u"
              ? pdfStyles.underline
              : pdfStyles.strikethrough;

      return (
        <Text key={key}>
          <Html>{before}</Html>
          <Text style={style}>
            <Html>{content}</Html>
          </Text>
          <Html>{after}</Html>
        </Text>
      );
    }

    // Base case: plain text
    return <Text key={key}>{nodeHtml}</Text>;
  };

  return renderNode(cleanedHtml, "root");
};

// ===================================================================
// ✅ 3. UPDATED HEADER, FOOTER, AND PDF COMPONENTS
// Calls to <Html> are no longer wrapped in <Text> to allow lists (<View>) to render.
// ===================================================================
const ReportHeader = ({ settings }) => {
  const logoAlign = settings?.HeaderLogoAlign || "left";
  const textAlign = settings?.HeaderTextAlign || "left";
  const logoFirst = logoAlign === "left";
  const LogoComponent = settings?.HeaderLogo ? (
    <Image
      style={pdfStyles.headerLogo}
      src={
        `${imgUrl}${settings.HeaderLogo}` || `${imgUrl}${settings.HeaderLogo}`
      }
    />
  ) : null;
  const TextComponent = settings?.HeaderText ? (
    <View style={[pdfStyles.headerTextContainer, { textAlign: textAlign }]}>
      <Html>{settings.HeaderText}</Html>
    </View>
  ) : null;
  return (
    <View style={pdfStyles.header} fixed>
      {logoFirst ? (
        <>
          {LogoComponent}
          {TextComponent}
        </>
      ) : (
        <>
          {TextComponent}
          {LogoComponent}
        </>
      )}
    </View>
  );
};

const ReportFooter = ({ settings }) => {
  const textAlign = settings?.FooterTextAlign || "center";
  return (
    <View style={[pdfStyles.footer, { textAlign: textAlign }]} fixed>
      {settings?.FooterText && (
        <View>
          <Html>{settings.FooterText}</Html>
        </View>
      )}
      <Text
        style={pdfStyles.pageNumber}
        render={({ pageNumber, totalPages }) =>
          `Page ${pageNumber} / ${totalPages}`
        }
      />
    </View>
  );
};

// --- PDF Document Templates ---
const DietChartPDF = ({ diets, patient, doctor, appointmentId }) => (
  <Document title={`Diet Chart - ${patient?.firstName}`}>
    <Page size="A4" style={professionalPdfStyles.page}>
      <ProfessionalReportHeader doctor={doctor} title="Diet Plan" />
      {/* ... InfoSection same rahega ... */}
      {diets.map((asgn) => (
        <View key={asgn.id} style={{ marginBottom: 15 }}>
          {asgn.assigned_diets?.map((plan, pIdx) => (
            <View key={pIdx} style={{ marginBottom: 15 }} wrap={false}>
              <View style={professionalPdfStyles.dietHeader}>
                <Text style={professionalPdfStyles.dietTitle}>{plan.title} ({plan.diet_type})</Text>
                <Text style={{ fontSize: 8 }}>{asgn.start_date} to {asgn.end_date || "Next Advice"}</Text>
              </View>
              <View style={professionalPdfStyles.table}>
                <View style={[professionalPdfStyles.tableRow, professionalPdfStyles.tableHeader]}>
                  <View style={professionalPdfStyles.tableColTime}><Text style={professionalPdfStyles.tableHeaderCell}>Time</Text></View>
                  <View style={professionalPdfStyles.tableColDetails}><Text style={professionalPdfStyles.tableHeaderCell}>Details</Text></View>
                </View>
                {plan.meals?.map((meal, mIdx) => (
                  <View key={mIdx} style={professionalPdfStyles.tableRow}>
                    <View style={professionalPdfStyles.tableColTime}>
                      <Text style={[professionalPdfStyles.tableCell, { fontFamily: "Helvetica-Bold" }]}>{meal.meal_type}</Text>
                    </View>
                    <View style={professionalPdfStyles.tableColDetails}>
                      <Text style={[professionalPdfStyles.tableCell, { fontFamily: "Helvetica-Bold" }]}>{meal.food_items}</Text>
                      <Text style={{ fontSize: 8, color: "#666" }}>{meal.instructions}</Text>
                    </View>
                  </View>
                ))}
              </View>
            </View>
          ))}
        </View>
      ))}
    </Page>
  </Document>
);

const ExerciseChartPDF = ({ exercises, patient, doctor, appointmentId }) => (
  <Document title={`Exercise Chart - ${patient?.firstName}`}>
    <Page size="A4" style={professionalPdfStyles.page}>
      <ProfessionalReportHeader doctor={doctor} title="Exercise Chart" />
      
      <View style={professionalPdfStyles.infoSection}>
        <View style={professionalPdfStyles.infoColumn}>
          <Text><Text style={professionalPdfStyles.label}>Patient:</Text> {patient?.firstName} {patient?.lastName}</Text>
          <Text><Text style={professionalPdfStyles.label}>Patient ID:</Text> {patient?.PatientID}</Text>
        </View>
        <View style={[professionalPdfStyles.infoColumn, { textAlign: "right" }]}>
          <Text><Text style={professionalPdfStyles.label}>Appt ID:</Text> #{appointmentId}</Text>
          <Text><Text style={professionalPdfStyles.label}>Date:</Text> {new Date().toLocaleDateString()}</Text>
        </View>
      </View>

      <Text style={{ fontSize: 14, fontFamily: "Helvetica-Bold", color: "#007bff", marginBottom: 10 }}>
        Exercise / Physiotherapy Chart
      </Text>

      {exercises.map((asgn) => (
        <View key={asgn.id} style={{ marginBottom: 15 }}>
          {asgn.assigned_exercises?.map((ex, exIdx) => (
            // YAHAN SE wrap={false} HATA DIYA HAI (Remove wrap from here)
            <View key={exIdx} style={{ marginBottom: 15 }}>
              
              <View style={professionalPdfStyles.exerciseHeader}>
                <Text style={professionalPdfStyles.exerciseTitle}>{ex.exercise_title}</Text>
                <Text style={{ fontSize: 9 }}>{asgn.frequency} - {asgn.time_of_day}</Text>
              </View>

              <Text style={{ fontSize: 8, color: "#666", marginBottom: 8, fontStyle: 'italic' }}>
                Instruction: {ex.description}
              </Text>
              
              {ex.steps?.map((step, sIdx) => (
                // SIRF STEP PAR wrap={false} RAKHEIN (Keep wrap only here)
                <View key={sIdx} style={professionalPdfStyles.stepBox} wrap={false}>
                  <View style={{ width: "30%", marginRight: 15 }}>
                    {step.image && step.image !== "null" && step.image !== "" ? (
                      <Image 
                        style={professionalPdfStyles.stepImage} 
                        src={`${imgUrl}${step.image}?t=${new Date().getTime()}`} 
                      />
                    ) : (
                      <View style={[professionalPdfStyles.stepImage, { backgroundColor: "#f9f9f9", border: '1px solid #ddd' }]} />
                    )}
                  </View>

                  <View style={{ width: "65%" }}>
                    <Text style={{ fontFamily: "Helvetica-Bold", fontSize: 10, color: "#007bff" }}>
                      Step {step.step_number}: {step.step_title}
                    </Text>
                    <Text style={{ fontSize: 9, color: "#333", marginTop: 4, lineHeight: 1.4 }}>
                      {step.description}
                    </Text>
                    <Text style={{ fontSize: 8, color: "#888", marginTop: 6 }}>
                        Duration: {step.duration_seconds} Seconds
                    </Text>
                  </View>
                </View>
              ))}
            </View>
          ))}
        </View>
      ))}
      <View style={professionalPdfStyles.footer} fixed>
         <Text>Generated by Medisevas Health Portal</Text>
         <Text render={({ pageNumber, totalPages }) => `Page ${pageNumber} of ${totalPages}`} />
      </View>
    </Page>
  </Document>
);
const PrescriptionPDF = ({
  prescriptions,
  patient,
  doctor,
  appointmentId,
  settings,
}) => {
  const signatureFileName = prescriptions.find((p) => p.signature)?.signature;
  return (
    <Document title={`Prescription - ${patient?.firstName}`}>
      <Page size="A4" style={pdfStyles.page}>
        <ReportHeader settings={settings} />
        <View style={pdfStyles.infoSection}>
          <View style={pdfStyles.infoColumn}>
            <Text>
              <Text style={pdfStyles.label}>Patient:</Text> {patient?.firstName}{" "}
              {patient?.lastName}
            </Text>
            <Text>
              <Text style={pdfStyles.label}>Dob:</Text> {patient?.dateOfBirth}
            </Text>
            <Text>
              <Text style={pdfStyles.label}>Gender:</Text> {patient?.gender}
            </Text>
            <Text>
              <Text style={pdfStyles.label}>Patient ID:</Text>{" "}
              {patient?.PatientID}
            </Text>
          </View>
          <View style={[pdfStyles.infoColumn, { textAlign: "right" }]}>
            <Text>
              <Text style={pdfStyles.label}>Appointment ID:</Text> #
              {appointmentId}
            </Text>
            <Text>
              <Text style={pdfStyles.label}>Date:</Text>{" "}
              {new Date().toLocaleDateString()}
            </Text>
          </View>
        </View>
        <View style={pdfStyles.section}>
          <Text style={pdfStyles.h2}>Prescription</Text>
          <View style={pdfStyles.table}>
            <View style={[pdfStyles.tableRow, pdfStyles.tableHeader]}>
              <View style={[pdfStyles.tableCol, { width: "35%" }]}>
                <Text style={pdfStyles.tableHeaderCell}>Medicine</Text>
              </View>
              <View style={[pdfStyles.tableCol, { width: "20%" }]}>
                <Text style={pdfStyles.tableHeaderCell}>Frequency</Text>
              </View>
              <View style={[pdfStyles.tableCol, { width: "20%" }]}>
                <Text style={pdfStyles.tableHeaderCell}>Duration</Text>
              </View>
              <View style={[pdfStyles.tableCol, { width: "25%" }]}>
                <Text style={pdfStyles.tableHeaderCell}>Timing</Text>
              </View>
            </View>
            {prescriptions.map((p, i) => (
              <View
                style={[
                  pdfStyles.tableRow,
                  i % 2 !== 0 && { backgroundColor: "#fafafa" },
                ]}
                key={i}
              >
                <View style={[pdfStyles.tableCol, { width: "35%" }]}>
                  <Text style={pdfStyles.tableCell}>{p.name}</Text>
                </View>
                <View style={[pdfStyles.tableCol, { width: "20%" }]}>
                  <Text style={pdfStyles.tableCell}>{p.quantity}</Text>
                </View>
                <View style={[pdfStyles.tableCol, { width: "20%" }]}>
                  <Text style={pdfStyles.tableCell}>{p.days}</Text>
                </View>
                <View style={[pdfStyles.tableCol, { width: "25%" }]}>
                  <Text style={pdfStyles.tableCell}>
                    {Array.isArray(p.time) ? p.time.join(", ") : p.time}
                  </Text>
                </View>
              </View>
            ))}
          </View>
        </View>
        {signatureFileName && (
          <View style={pdfStyles.signatureSection}>
            <Image
              style={pdfStyles.signatureImage}
              src={`${imgUrl}${signatureFileName}`}
            />
            <View style={pdfStyles.signatureLine} />
            <Text style={pdfStyles.signatureText}>
              Dr. {doctor?.firstName} {doctor?.lastName}
            </Text>
          </View>
        )}
        <ReportFooter settings={settings} />
      </Page>
    </Document>
  );
};
const MedicalRecordPDF = ({ record, patient, doctor, settings }) => (
  <Document title={`Medical Record - ${patient?.firstName}`}>
    <Page size="A4" style={pdfStyles.page}>
      <ReportHeader settings={settings} />
      <View style={pdfStyles.infoSection}>
        <View style={pdfStyles.infoColumn}>
          <Text>
            <Text style={pdfStyles.label}>Patient:</Text> {patient?.firstName}{" "}
            {patient?.lastName}
          </Text>
          <Text>
            <Text style={pdfStyles.label}>Patient ID:</Text>{" "}
            {patient?.PatientID}
          </Text>
        </View>
        <View style={[pdfStyles.infoColumn, { textAlign: "right" }]}>
          <Text>
            <Text style={pdfStyles.label}>Record ID:</Text> #{record.id}
          </Text>
          <Text>
            <Text style={pdfStyles.label}>Date:</Text>{" "}
            {new Date(record.date).toLocaleDateString()}
          </Text>
        </View>
      </View>
      <Text style={pdfStyles.h2}>Medical Record</Text>
      {record && (
        <View style={pdfStyles.section} wrap={false}>
          <Text style={pdfStyles.h2}>Vitals</Text>
          <View style={{ flexDirection: "row", flexWrap: "wrap", gap: 10 }}>
            <Text style={{ width: "48%" }}>
              <Text style={pdfStyles.label}>BP:</Text> {record?.BP || "N/A"}
            </Text>
            <Text style={{ width: "48%" }}>
              <Text style={pdfStyles.label}>Heart Rate:</Text>{" "}
              {record?.heartRate || "N/A"} BPM
            </Text>
            <Text style={{ width: "48%" }}>
              <Text style={pdfStyles.label}>SPO2:</Text> {record?.SPO || "N/A"}{" "}
              %
            </Text>
            <Text style={{ width: "48%" }}>
              <Text style={pdfStyles.label}>Blood Sugar:</Text>{" "}
              {record?.sugar || "N/A"}
            </Text>
            <Text style={{ width: "48%" }}>
              <Text style={pdfStyles.label}>Height:</Text>{" "}
              {record?.height ? `${record.height} cm` : "N/A"}
            </Text>
            <Text style={{ width: "48%" }}>
              <Text style={pdfStyles.label}>Weight:</Text>{" "}
              {record?.weight ? `${record.weight} kg` : "N/A"}
            </Text>
            <Text style={{ width: "48%" }}>
              <Text style={pdfStyles.label}>BMI:</Text>{" "}
              {calculateBmi(record?.weight, record?.height)}
            </Text>
          </View>
          <Text style={[pdfStyles.h2, { marginTop: 20 }]}>Clinical Notes</Text>
          <Text style={pdfStyles.label}>Diagnosis:</Text>
          <View style={{ marginBottom: 10 }}>
            <Html>{record?.diagnosis || "N/A"}</Html>
          </View>
          <Text style={pdfStyles.label}>Treatment:</Text>
          <View>
            <Html>{record?.treatment || "N/A"}</Html>
          </View>

          {/* {record?.uploadFile && (
            <>
              <Text style={[pdfStyles.h2, { marginTop: 20 }]}>Attachment</Text>
              <Text style={pdfStyles.text}>File: {record.uploadFile}</Text>
            </>
          )} */}
        </View>
      )}
      {/* {doctor?.signature && (
        <View style={pdfStyles.signatureSection}>
          <Image
            style={pdfStyles.signatureImage}
            src={`${imgUrl}${doctor.signature}`}
          />
          <View style={pdfStyles.signatureLine} />
          <Text style={pdfStyles.signatureText}>
            Dr. {doctor?.firstName} {doctor?.lastName}
          </Text>
        </View>
      )} */}
      {record?.uploadFile && (
        <View style={pdfStyles.signatureSection}>
 
          <Image
            style={pdfStyles.signatureImage}
            src={`${imgUrl}${record.uploadFile}`}
          />
          <View style={pdfStyles.signatureLine} />
      
          <Text style={pdfStyles.signatureText}>
            Dr. {doctor?.firstName} {doctor?.lastName}
          </Text>
        </View>
      )}
      <ReportFooter settings={settings} />
    </Page>
  </Document>
);
const InvoicePDF = ({ invoice, patient, doctor, settings }) => (
  <Document title={`Invoice - ${patient?.firstName}`}>
    <Page size="A4" style={pdfStyles.page}>
      <ReportHeader settings={settings} />
      <View style={pdfStyles.infoSection}>
        <View style={pdfStyles.infoColumn}>
          <Text>
            <Text style={pdfStyles.label}>Billed To:</Text> {patient?.firstName}{" "}
            {patient?.lastName}
          </Text>
          <Text>
            <Text style={pdfStyles.label}>Patient ID:</Text>{" "}
            {patient?.PatientID}
          </Text>
        </View>
        <View style={[pdfStyles.infoColumn, { textAlign: "right" }]}>
          <Text>
            <Text style={pdfStyles.label}>Invoice ID:</Text> INV-{invoice?.id}
          </Text>
          <Text>
            <Text style={pdfStyles.label}>Date Issued:</Text>{" "}
            {new Date(invoice?.date).toLocaleDateString()}
          </Text>
          <Text>
            <Text style={pdfStyles.label}>Status:</Text> {invoice?.Status}
          </Text>
        </View>
      </View>
      <Text style={pdfStyles.h2}>Invoice</Text>
      <View style={pdfStyles.section}>
        <Text style={pdfStyles.h2}>Payment Summary</Text>
        <View style={pdfStyles.table}>
          <View style={[pdfStyles.tableRow, pdfStyles.tableHeader]}>
            <View style={[pdfStyles.tableCol, { width: "75%" }]}>
              <Text style={pdfStyles.tableHeaderCell}>Description</Text>
            </View>
            <View
              style={[pdfStyles.tableCol, { width: "25%", textAlign: "right" }]}
            >
              <Text style={pdfStyles.tableHeaderCell}>Amount</Text>
            </View>
          </View>
          <View style={pdfStyles.tableRow}>
            <View style={[pdfStyles.tableCol, { width: "75%" }]}>
              <Text style={pdfStyles.tableCell}>
                Doctor Consultation Fee for Appointment #
                {invoice?.appointmentId}
              </Text>
            </View>
            <View
              style={[pdfStyles.tableCol, { width: "25%", textAlign: "right" }]}
            >
              <Text style={pdfStyles.tableCell}>₹{invoice?.TotalAmount}</Text>
            </View>
          </View>
        </View>
      </View>
      <View
        style={{
          flexDirection: "row",
          justifyContent: "flex-end",
          marginTop: 20,
        }}
      >
        <View style={{ width: "40%" }}>
          <View
            style={{
              flexDirection: "row",
              justifyContent: "space-between",
              borderBottomWidth: 1,
              borderColor: "#eee",
              paddingBottom: 5,
              marginBottom: 5,
            }}
          >
            <Text>Subtotal:</Text>
            <Text>₹{invoice?.TotalAmount}</Text>
          </View>
          <View
            style={{ flexDirection: "row", justifyContent: "space-between" }}
          >
            <Text style={pdfStyles.label}>Total Amount:</Text>
            <Text style={pdfStyles.label}>₹{invoice?.TotalAmount}</Text>
          </View>
        </View>
      </View>
      <ReportFooter settings={settings} />
    </Page>
  </Document>
);

// --- MAIN REACT COMPONENT ---
const PatientProfilePage = ({
  // Props from withRouter
  history,
  // Props from Redux (connect)
  video,
  provisionVideoSession,
  patientGenerateToken,
  doctorRejoinSession,
}) => {
  const dispatch = useDispatch();
  const { id } = useParams();

  // Redux state selectors
  const { profileData, loading: doctorLoading } = useSelector(
    (state) => state.doctorProfile || {},
  );
  const { templates } = useSelector((state) => state.exerciseTemplates);
const profiles = useSelector((state) => state.patientProfile?.profiles) || [];
const appointments = useSelector((state) => state.appointment?.all) || [];
  const prescriptionsList = useSelector(
    (state) => state.prescription?.prescriptions || [],
  );
  const { dietList } = useSelector((state) => state.diet);
const { templates: dietTemplates } = useSelector((state) => state.dietTemplates);
const { patientDietList } = useSelector((state) => state.patientDiet);
  const medicalRecords = useSelector(
    (state) => state.medicalRecord?.records || [],
  );
  const invoices = useSelector((state) => state.invoice?.invoices || []);
  const reportSettings = useSelector(
    (state) => state.reportSettings?.settings || {},
  );
  const exerciseList = useSelector(
    (state) => state.exercise?.exerciseList || [],
  );
  const assignmentList = useSelector(
    (state) => state.exerciseAssignment?.assignmentList || [],
  );
  const [expandedExerciseRowId, setExpandedExerciseRowId] = useState(null);
  const [expandedDietRowId, setExpandedDietRowId] = useState(null);
const [dietSearchTerm, setDietSearchTerm] = useState("");
const [showDietPdfModal, setShowDietPdfModal] = useState(false); // Fixes Line 1474
const [showViewDietModal, setShowViewDietModal] = useState(false); // Fixes Line 2119
const [selectedDietIds, setSelectedDietIds] = useState([]);
const [dietMode, setDietMode] = useState("individual"); // 'individual' or 'template'
const [templateDietSelections, setTemplateDietSelections] = useState({});
const [selectedDietTemplateIds, setSelectedDietTemplateIds] = useState([]);
const [viewingDietPlan, setViewingDietPlan] = useState(null);
const [isEditingDiet, setIsEditingDiet] = useState(false);
const [currentDietAssignmentId, setCurrentDietAssignmentId] = useState(null);

const [dietForm, setDietForm] = useState({
  start_date: new Date().toISOString().split("T")[0],
  end_date: "",
  notes: "",
});
  // Local state management
  const [joinCooldown, setJoinCooldown] = useState(false);
  const [showExercisePdfModal, setShowExercisePdfModal] = useState(false);
  const [exerciseSearchTerm, setExerciseSearchTerm] = useState(""); // Filter ke liye
  const [selectedExerciseIds, setSelectedExerciseIds] = useState([]); // Bulk selection ke liye
  const [individualSettings, setIndividualSettings] = useState({});
  const [showViewPlanModal, setShowViewPlanModal] = useState(false);
  
const [viewingAssignmentPlan, setViewingAssignmentPlan] = useState(null);
  const [showExerciseModal, setShowExerciseModal] = useState(false);
  const [assignmentMode, setAssignmentMode] = useState("individual"); 
const [selectedTemplateIds, setSelectedTemplateIds] = useState([]); 
const [templateExerciseSelections, setTemplateExerciseSelections] = useState({}); //
  const [exercisePreview, setExercisePreview] = useState(null);
  const [assignmentForm, setAssignmentForm] = useState({
  exercise_ids: "",
    start_date: new Date().toISOString().split("T")[0],
    end_date: "",
    frequency: "Daily",
    time_of_day: "Morning",
    appointment_id: "",
  });
  const [selectedViewExercise, setSelectedViewExercise] = useState(null);
  const [isEditingAssignment, setIsEditingAssignment] = useState(false);
  const [currentAssignmentId, setCurrentAssignmentId] = useState(null);
  const [patient, setPatient] = useState(null);
  const [currentDoctor, setCurrentDoctor] = useState(null);
  const [viewingRecord, setViewingRecord] = useState(null);
  const [expandedSection, setExpandedSection] = useState({
    id: null,
    type: null,
  });
  const [modalShow, setModalShow] = useState(false);
  const [modalTitle, setModalTitle] = useState("");
  const [modalMessage, setModalMessage] = useState("");
  const [modalVariant, setModalVariant] = useState("info");
  const [groupedData, setGroupedData] = useState([]);
  const [expandedRowId, setExpandedRowId] = useState(null);
  const [currentAppointmentId, setCurrentAppointmentId] = useState(null);
  const [viewingInvoice, setViewingInvoice] = useState(null);
  const [pdfData, setPdfData] = useState({
    prescriptions: [],
    record: null,
    appointmentId: null,
    settings: {},
  });
  const [showPrescriptionPdfModal, setShowPrescriptionPdfModal] =
    useState(false);
  const [showMedicalRecordPdfModal, setShowMedicalRecordPdfModal] =
    useState(false);
  const [showInvoicePdfModal, setShowInvoicePdfModal] = useState(false);
  const [updatingApptId, setUpdatingApptId] = useState(null);
  const [isSaving, setIsSaving] = useState(false);
  const [deletingPrescriptionId, setDeletingPrescriptionId] = useState(null);
  const [deletingRecordId, setDeletingRecordId] = useState(null);
  const [prescriptions, setPrescriptions] = useState([
    { name: "", quantity: "", days: "", time: [] },
  ]);
  const [signature, setSignature] = useState(null);
  const [editSignature, setEditSignature] = useState(null);
  const [editingPrescription, setEditingPrescription] = useState(null);
  const [showPrescriptionModal, setShowPrescriptionModal] = useState(false);
  const [editModalOpen, setEditModalOpen] = useState(false);
  const [showMedicalRecordModal, setShowMedicalRecordModal] = useState(false);
  const [newRecordData, setNewRecordData] = useState({
    date: new Date().toISOString().split("T")[0],
    heartRate: "",
    SPO: "",
    BP: "",
    sugar: "",
    height: "",
    weight: "",
    diagnosis: "",
    treatment: "",
    follow_up_date: "",
  });
  const [newRecordFile, setNewRecordFile] = useState(null);
  const [showEditMedicalRecordModal, setShowEditMedicalRecordModal] =
    useState(false);
  const [editingMedicalRecord, setEditingMedicalRecord] = useState(null);
  const [editRecordFile, setEditRecordFile] = useState(null);
  const doctorID = localStorage.getItem("hospitalCode");
  const [isJoining, setIsJoining] = useState(null);

  const [playingVideoUrl, setPlayingVideoUrl] = useState(null);
  const [videoSessions, setVideoSessions] = useState([]);
  const [videoSessionsLoading, setVideoSessionsLoading] = useState(true);
  const [videoSessionsError, setVideoSessionsError] = useState(null); // New state for   // Data fetching and processing effects
  const hospitalID = localStorage.getItem("hospitalCode");
  console.log("gggggggggggggggg", hospitalID);
  useEffect(() => {
  if (showExerciseModal) {
    dispatch(getExercise()); // Saari exercises
    dispatch(listExerciseTemplates({ hospital_id: hospitalID })); // Saare templates
  }
}, [showExerciseModal, hospitalID, dispatch]);
useEffect(() => {
  dispatch(getDiet()); 
  dispatch(listDietTemplates({ hospital_id: hospitalID }));
  dispatch(getPatientDiet({ PatientID: id })); // Load assigned diets for this patient
}, [dispatch, hospitalID, id]);
  useEffect(() => {
    dispatch(getAllPatientProfiles());
    dispatch(getAllAppointments(hospitalID));
    dispatch(getAllPrescriptions(hospitalID));
    dispatch(getAllMedicalRecords(hospitalID));
    dispatch(listAllInvoices(hospitalID));
     dispatch(getExerciseAssignments({ PatientID: id })); 
  dispatch(getExercise()); 
    if (doctorID) {
      dispatch(getDoctorProfileById(doctorID));
      dispatch(getReportSettings(doctorID));
    }
    // --- NEW: Fetch video sessions ---
    const fetchAndSetVideoSessions = async () => {
      try {
        setVideoSessionsLoading(true);
        setVideoSessionsError(null); // Clear previous errors
        const data = await getRecUrl(hospitalID); // Call your action creator
        if (data) {
          setVideoSessions(data);
        }
      } catch (error) {
        console.error("Failed to fetch video sessions:", error);
        setVideoSessionsError(
          error.message ||
            "An unknown error occurred while fetching video sessions.",
        );
        showErrorModal(
          "Video Sessions Error",
          error.message || "Could not load video session data.",
        );
      } finally {
        setVideoSessionsLoading(false);
      }
    };
    fetchAndSetVideoSessions();
    // --- END MODIFIED ---
  }, [dispatch, doctorID, id]);

  useEffect(() => {
    if (profiles.length > 0) {
      const found = profiles.find((p) => String(p.PatientID) === String(id));
      setPatient(found || null);
    }
  }, [profiles, id]);

  useEffect(() => {
    if (profileData) {
      setCurrentDoctor(profileData);
    }
  }, [profileData]);

  // Modify your existing useEffect for groupedData
  useEffect(() => {
    if (
      appointments.length === 0 ||
      profiles.length === 0 ||
      videoSessionsLoading
    ) {
      // Wait until video sessions are loaded as well
      return;
    }

    const patientAppointments = (appointments || []).filter(
      (a) =>
        String(a.PatientID) === String(id) &&
        String(a.hospitalID) === String(doctorID),
    );
    const patientPrescriptions = prescriptionsList || [];
    const patientMedicalRecords = medicalRecords || [];
    const patientInvoices = invoices || [];
    const invoiceMap = patientInvoices.reduce((acc, inv) => {
      acc[String(inv.appointmentId)] = inv;
      return acc;
    }, {});

    // --- NEW: Map latest recorded video session to appointmentId ---
    const videoSessionMap = videoSessions.reduce((acc, session) => {
      // Only consider completed and recorded sessions
      if (
        session.status === "completed" &&
        session.was_recorded === 1 &&
        session.recording_url
      ) {
        const appointmentId = String(session.appointmentId);
        // Keep the latest session if multiple exist for the same appointmentId
        if (
          !acc[appointmentId] ||
          new Date(session.actual_end_time) >
            new Date(acc[appointmentId].actual_end_time)
        ) {
          acc[appointmentId] = session;
        }
      }
      return acc;
    }, {});
    // --- END NEW ---

    const grouped = patientAppointments
      .map((apt) => ({
        ...apt,
        prescriptions: patientPrescriptions.filter(
          (p) => String(p.appointmentId) === String(apt.appointmentId),
        ),
        medicalRecord:
          patientMedicalRecords.find(
            (r) => String(r.appointmentId) === String(apt.appointmentId),
          ) || null,
        invoice: invoiceMap[String(apt.appointmentId)] || null,
        // --- NEW: Add video session data ---
        videoSession: videoSessionMap[String(apt.appointmentId)] || null,
        exercises: assignmentList.filter(
          (asgn) => String(asgn.appointment_id) === String(apt.appointmentId),
        ),
        dietAssignments: patientDietList.filter(
  (pd) => String(pd.Appoinment_Id) === String(apt.appointmentId)
),
      }))
      .sort(
        (a, b) => new Date(b.appointmentDate) - new Date(a.appointmentDate),
      );
    grouped.sort((a, b) => Number(b.appointmentId) - Number(a.appointmentId));

    setGroupedData(grouped);
  }, [
    appointments,
    prescriptionsList,
    medicalRecords,
    invoices,
    id,
    doctorID,
    videoSessions,
    videoSessionsLoading,
    assignmentList 
  ]); // Add videoSessions and videoSessionsLoading to dependencies
  // --- NEW: useEffect to handle video token events ---
  const { token, roomName, loading: videoLoading, error: videoError } = video; // Destructure roomName as well
  // Replace your current useEffect with this:
  useEffect(() => {
    console.log("Video state changed:", {
      token: !!token,
      roomName: roomName,
      videoError,
      isJoining,
      videoLoading,
    });

    if (token && roomName && isJoining && !videoLoading) {
      console.log(
        "Navigating to video page:",
        `/doctorvideopage/${roomName}/60`,
      );
      history.push(`/doctorvideopage/${roomName}/60`);
      setIsJoining(null);
    }

    if (videoError) {
      console.error("Video error occurred:", videoError);
      // showErrorModal('Could Not Join Call', videoError);
      setIsJoining(null);
    }
  }, [token, roomName, videoError, history, isJoining, videoLoading]);

  // Modal and action handlers
  const showSuccessModal = (title, message) => {
    setModalTitle(title);
    setModalMessage(message);
    setModalVariant("success");
    setModalShow(true);
  };
 const toggleDietExpansion = (appointmentId) => {
  setExpandedRowId(null);
  setExpandedExerciseRowId(null);
  setExpandedSection({ id: null, type: null });
  
  setExpandedDietRowId((prev) => (prev === appointmentId ? null : appointmentId));
  setCurrentAppointmentId(appointmentId);
};

const handleDeleteDietAssignment = async (assignmentId) => {
  if (window.confirm("Are you sure you want to delete this diet plan?")) {
    try {
      await dispatch(deletePatientDiet({ id: assignmentId }));
      dispatch(getPatientDiet({ PatientID: id }));
      showSuccessModal("Deleted", "Diet plan has been removed.");
    } catch (err) {
      showErrorModal("Error", "Failed to delete diet plan.");
    }
  }
};
const handleEditDietPlan = (asgn, appointmentId) => {
  // 1. Set basic form data
  setDietForm({
    start_date: asgn.start_date,
    end_date: asgn.end_date || "",
    notes: asgn.notes || "",
  });
  const existingId = Number(asgn.diet_id);
  setSelectedDietIds([existingId]);

  setCurrentDietAssignmentId(asgn.id);
  setIsEditingDiet(true);
  setCurrentAppointmentId(appointmentId);
  setDietMode("individual"); // Default to individual tab for editing
};
const handleSelectDietTemplate = (template) => {
  const isSelected = selectedDietTemplateIds.includes(template.id);
  if (isSelected) {
    setSelectedDietTemplateIds(prev => prev.filter(id => id !== template.id));
    const newSelections = { ...templateDietSelections };
    delete newSelections[template.id];
    setTemplateDietSelections(newSelections);
  } else {
    setSelectedDietTemplateIds(prev => [...prev, template.id]);
    const allDietIds = template.diet_plans?.map(d => Number(d.diet_id)) || [];
    setTemplateDietSelections(prev => ({
      ...prev,
      [template.id]: allDietIds
    }));
  }
};
const toggleDietInTemplate = (templateId, dietId) => {
  const currentSelections = templateDietSelections[templateId] || [];
  const targetId = Number(dietId);

  if (currentSelections.includes(targetId)) {
    setTemplateDietSelections(prev => ({
      ...prev,
      [templateId]: currentSelections.filter(id => id !== targetId)
    }));
  } else {
    setTemplateDietSelections(prev => ({
      ...prev,
      [templateId]: [...currentSelections, targetId]
    }));
  }
};

  
const handleFinalDietAssignment = async () => {
  // 1. Merge IDs from both Individual and Template selections
  let finalMergedIds = [...selectedDietIds];
  Object.values(templateDietSelections).forEach(idArray => {
    finalMergedIds = [...finalMergedIds, ...idArray];
  });

  // 2. Create a unique array of Numbers
  const uniqueDietIds = Array.from(new Set(finalMergedIds.map(id => Number(id))));

  // Validation: Ensure at least one diet is selected
  if (uniqueDietIds.length === 0) {
    return showErrorModal("Error", "Select at least one diet plan.");
  }

  // Validation: Prevent End Date being before Start Date
  if (dietForm.end_date && dietForm.end_date < dietForm.start_date) {
    return showErrorModal("Date Error", "End Date cannot be earlier than Start Date.");
  }

  setIsSaving(true);
  try {
    const payload = {
      ...(isEditingDiet && { id: currentDietAssignmentId }), // Include ID only if editing
      PatientID: id, // Keeping as string to match your requirement "60"
      assigned_by: localStorage.getItem("hospitalCode"), // "168"
      assigned_date: new Date().toISOString().split("T")[0],
      start_date: dietForm.start_date,
      end_date: dietForm.end_date || null,
      Appoinment_Id: String(currentAppointmentId), // "364"
      diet_ids: uniqueDietIds, // CHANGED: Now sending the full array [11, 10]
      status: "Active" // ADDED: Based on your requirement
    };

    if (isEditingDiet) {
      await dispatch(updatePatientDiet(payload));
      showSuccessModal("Success", "Diet Plan updated successfully!");
    } else {
      await dispatch(createPatientDiet(payload));
      showSuccessModal("Success", "New Diet Plan assigned!");
    }
    
    // Cleanup and Refresh
    setIsEditingDiet(false);
    setCurrentDietAssignmentId(null);
    setSelectedDietIds([]);
    setTemplateDietSelections({});
    setSelectedDietTemplateIds([]);
    dispatch(getPatientDiet({ PatientID: id }));
  } catch (err) {
    showErrorModal("Error", "Failed to save diet plan. Please check date logic.");
  } finally {
    setIsSaving(false);
  }
};
const showErrorModal = (title, message) => {
    setModalTitle(title);
    setModalMessage(message);
    setModalVariant("danger");
    setModalShow(true);
  };

  const handleOpenInvoicePdf = (invoiceData) => {
    const settings = reportSettings.invoice || {};
    setViewingInvoice({ ...invoiceData, settings });
    setShowInvoicePdfModal(true);
  };
// 1. Jab doctor poora template select kare (Default saari exercises select ho jayengi)
const handleSelectTemplate = (template) => {
  const isSelected = selectedTemplateIds.includes(template.id);
  if (isSelected) {
    // Unselect template
    setSelectedTemplateIds(prev => prev.filter(id => id !== template.id));
    const newSelections = { ...templateExerciseSelections };
    delete newSelections[template.id];
    setTemplateExerciseSelections(newSelections);
  } else {
    // Select template
    setSelectedTemplateIds(prev => [...prev, template.id]);
    // Template ke andar ki sari exercise IDs ko array mein store karein
    const allExIds = template.exercises?.map(ex => Number(ex.exercise_id || ex.id)) || [];
    setTemplateExerciseSelections(prev => ({
      ...prev,
      [template.id]: allExIds
    }));
  }
};

// 2. Template ke andar kisi specific exercise ko OFF karna (accidents/heavy lifting case)
const toggleExerciseInTemplate = (templateId, exerciseId) => {
  const currentSelections = templateExerciseSelections[templateId] || [];
  const targetId = Number(exerciseId);

  if (currentSelections.includes(targetId)) {
    setTemplateExerciseSelections(prev => ({
      ...prev,
      [templateId]: currentSelections.filter(id => id !== targetId)
    }));
  } else {
    setTemplateExerciseSelections(prev => ({
      ...prev,
      [templateId]: [...currentSelections, targetId]
    }));
  }
};
const handleEditPlan = (asgn, appointmentId) => {
  setAssignmentForm({
    appointment_id: appointmentId,
    frequency: asgn.frequency,
    time_of_day: asgn.time_of_day,
    start_date: asgn.start_date,
    end_date: asgn.end_date || "",
  });

  // Purane assigned data ko individual list mein TICK mark karein
  const existingIds = asgn.assigned_exercises?.map(ex => Number(ex.exercise_id)) || [];
  setSelectedExerciseIds(existingIds);

  setCurrentAssignmentId(asgn.id);
  setIsEditingAssignment(true);
  setCurrentAppointmentId(appointmentId);
  setAssignmentMode("individual"); 
};
// const handleFinalAssignment = async () => {
//   // A. Individual tab se selected IDs
//   let mergedIds = [...selectedExerciseIds];

//   // B. Template tab se selected IDs (jo doctor ne customize ki hain)
//   Object.values(templateExerciseSelections).forEach(ids => {
//     mergedIds = [...mergedIds, ...ids];
//   });

//   // Unique IDs nikalen (taaki duplicate na ho)
//   const uniqueExerciseIds = Array.from(new Set(mergedIds.map(id => Number(id))));

//   if (uniqueExerciseIds.length === 0) return showErrorModal("Error", "Please select at least one exercise.");

//   setIsSaving(true);
//   try {
//     await Promise.all(
//       uniqueExerciseIds.map((exId) => {
//         const settings = individualSettings[exId] || {}; // Dates/Frequency fetch
//         return dispatch(createExerciseAssignment({
//           PatientID: parseInt(id),
//         exercise_ids: parseInt(exId),
//           assigned_by: parseInt(localStorage.getItem("hospitalCode")),
//           assigned_date: new Date().toISOString().split("T")[0],
//           start_date: settings.start_date || new Date().toISOString().split("T")[0],
//           end_date: settings.end_date || "", 
//           frequency: settings.frequency || "Daily",
//           time_of_day: settings.time_of_day || "Morning",
//           appointment_id: String(currentAppointmentId),
//         }));
//       })
//     );
//     showSuccessModal("Success", "Exercise Plan assigned successfully!");
//     setShowExerciseModal(false);
//     // Reset Everything
//     setSelectedExerciseIds([]);
//     setTemplateExerciseSelections({});
//     setSelectedTemplateIds([]);
//     dispatch(getExerciseAssignments({ PatientID: id })); // List refresh
//   } catch (err) {
//     showErrorModal("Error", "Check End Dates for all exercises.");
//   } finally {
//     setIsSaving(false);
//   }
// };
  // const handleOpenPdf = (type, item) => {
  //   const reportTypeKey = type === 'record' ? 'medicalRecord' : type;
  //   const settings = reportSettings[reportTypeKey] || {};
  //   setPdfData({
  //     prescriptions: item.prescriptions,
  //     record: item.medicalRecord,
  //     appointmentId: item.appointmentId,
  //     settings: settings,
  //   });
  //   if (type === 'prescription') {
  //     if (item.prescriptions.length > 0) setShowPrescriptionPdfModal(true);
  //     else showErrorModal("No Data", "No prescriptions are available to print for this appointment.");
  //   }
  //   if (type === 'record') {
  //     if (item.medicalRecord) setShowMedicalRecordPdfModal(true);
  //     else showErrorModal("No Data", "No medical record is available to print for this appointment.");
  //   }
  // };
const handleFinalAssignment = async () => {
  // 1. Individual tab se selected IDs lein
  let finalMergedIds = [...selectedExerciseIds];

  // 2. Template tab se har selected template ki customised exercises merge karein
  Object.values(templateExerciseSelections).forEach(exerciseIdArray => {
    if (Array.isArray(exerciseIdArray)) {
      finalMergedIds = [...finalMergedIds, ...exerciseIdArray];
    }
  });

  // 3. Unique IDs nikalen (Case 5 handle karne ke liye: agar ek hi exercise dono jagah se select ho gayi ho)
  const uniqueExerciseIds = Array.from(new Set(finalMergedIds.map(id => Number(id))));

  if (uniqueExerciseIds.length === 0) {
    return showErrorModal("Error", "Please select at least one exercise from either Individual or Template tab.");
  }

  setIsSaving(true);

  const payload = {
    id: isEditingAssignment ? currentAssignmentId : undefined,
    PatientID: parseInt(id),
    assigned_by: parseInt(localStorage.getItem("hospitalCode")),
    assigned_date: new Date().toISOString().split("T")[0],
    start_date: assignmentForm.start_date,
    end_date: assignmentForm.end_date || null,
    frequency: assignmentForm.frequency,
    time_of_day: assignmentForm.time_of_day,
    appointment_id: parseInt(currentAppointmentId),
    exercise_ids: uniqueExerciseIds // Flat list of all IDs (Case 1 to 5 handled)
  };

  try {
    if (isEditingAssignment) {
      await dispatch(updateExerciseAssignment(payload));
      showSuccessModal("Success", "Plan updated successfully!");
    } else {
      await dispatch(createExerciseAssignment(payload));
      showSuccessModal("Success", "New Plan assigned successfully!");
    }

    // Cleanup states
    setIsEditingAssignment(false);
    setCurrentAppointmentId(null);
    setSelectedExerciseIds([]);
    setTemplateExerciseSelections({});
    setSelectedTemplateIds([]);
    dispatch(getExerciseAssignments({ PatientID: id })); 
  } catch (err) {
    showErrorModal("Error", "Failed to save the plan.");
  } finally {
    setIsSaving(false);
  }
};
  // const handleOpenPdf = (type, item) => {
  //   const reportTypeKey = type === "record" ? "medicalRecord" : type;
  //   const settings = reportSettings[reportTypeKey] || {};

  //   setPdfData({
  //     prescriptions: item.prescriptions,
  //     record: item.medicalRecord,
  //     exercises: item.exercises, // Naya field
  //     appointmentId: item.appointmentId,
  //     settings: settings,
  //   });

  //   if (type === "prescription") {
  //     if (item.prescriptions.length > 0) setShowPrescriptionPdfModal(true);
  //     else showErrorModal("No Data", "No prescriptions found.");
  //   }
  //   if (type === "record") {
  //     if (item.medicalRecord) setShowMedicalRecordPdfModal(true);
  //     else showErrorModal("No Data", "No medical record found.");
  //   }
  //   // NAYA CASE:
  //   if (type === "exercise") {
  //     if (item.exercises && item.exercises.length > 0)
  //       setShowExercisePdfModal(true);
  //     else
  //       showErrorModal(
  //         "No Data",
  //         "No exercises assigned for this appointment.",
  //       );
  //   }
  // };
  const handleOpenPdf = (type, item) => {
  const reportTypeKey = type === "record" ? "medicalRecord" : type;
  const settings = reportSettings[reportTypeKey] || {};

  // PDF Data set karna
  setPdfData({
    prescriptions: item.prescriptions || [],
    record: item.medicalRecord || null,
    exercises: item.exercises || [], // Nested assignments array pass ho raha hai
    appointmentId: item.appointmentId,
     dietAssignments: item.dietAssignments || [], 
    settings: settings,
  });

  // Modals open karne ki logic
  if (type === "prescription") {
    if (item.prescriptions && item.prescriptions.length > 0) {
      setShowPrescriptionPdfModal(true);
    } else {
      showErrorModal("No Data", "No prescriptions found for this appointment.");
    }
  } 
  else if (type === "record") {
    if (item.medicalRecord) {
      setShowMedicalRecordPdfModal(true);
    } else {
      showErrorModal("No Data", "No medical record found for this appointment.");
    }
  } 
  else if (type === "exercise") {
    if (item.exercises && item.exercises.length > 0) {
      setShowExercisePdfModal(true);
    } else {
      showErrorModal("No Data", "No exercises assigned for this appointment.");
    }
  }
  else if (type === "diet") {
  if (item.dietAssignments && item.dietAssignments.length > 0) {
    setShowDietPdfModal(true); // Iska state add karna hoga
  } else {
    showErrorModal("No Data", "No diet plan found.");
  }}
};

const toggleExerciseExpansion = (appointmentId) => {
  setExpandedRowId(null);
  setExpandedDietRowId(null); // <--- Yeh line miss thi
  setExpandedSection({ id: null, type: null });

  setExpandedExerciseRowId((prevId) =>
    prevId === appointmentId ? null : appointmentId,
  );
  setCurrentAppointmentId(appointmentId);
  dispatch(getExercise());
};

const toggleRowExpansion = (appointmentId) => {
  // Baaki sab band karne ke liye
  setExpandedExerciseRowId(null);
  setExpandedDietRowId(null);
  setExpandedSection({ id: null, type: null });

  setExpandedRowId((prevId) =>
    prevId === appointmentId ? null : appointmentId,
  );
};
  const handleViewExerciseSteps = (exerciseId) => {
    const foundExercise = exerciseList.find(
      (ex) => String(ex.id) === String(exerciseId),
    );
    if (foundExercise) {
      setSelectedViewExercise(foundExercise);
    } else {
      showErrorModal("Error", "Exercise details not found.");
    }
  };
  const handleOpenPrescriptionModal = (appointmentId) => {
    setCurrentAppointmentId(appointmentId);
    setPrescriptions([{ name: "", quantity: "", days: "", time: [] }]);
    setSignature(null);
    setShowPrescriptionModal(true);
  };

  const handleOpenExerciseModal = (appointmentId) => {
    setCurrentAppointmentId(appointmentId);
    setAssignmentForm((prev) => ({
      ...prev,
      appointment_id: appointmentId,
    }));
    
    // In teeno actions ko call karna zaroori hai
    dispatch(getExercise()); 
    dispatch(listExerciseTemplates({ hospital_id: hospitalID })); // Templates load honge
    dispatch(getExerciseAssignments({ PatientID: id }));
    
    setShowExerciseModal(true); // Modal open karne ki command
};
  const handleOpenExercisePreview = (exerciseId) => {
    const matchedEx = exerciseList.find(
      (ex) => String(ex.id) === String(exerciseId),
    );
    if (matchedEx) {
      setExercisePreview(matchedEx); // Ab ye 'exercisePreview' state set karega
    } else {
      showErrorModal("Error", "Exercise data is missing.");
    }
  };
  const handleBulkApplyExercises = async () => {
    if (selectedExerciseIds.length === 0)
      return showErrorModal("Error", "Please select at least one exercise.");

    setIsSaving(true);
    try {
      await Promise.all(
        selectedExerciseIds.map((exId) => {
          const settings = individualSettings[exId] || {};
       
            const payload = {
  PatientID: parseInt(id),
  assigned_by: parseInt(localStorage.getItem("hospitalCode")),
  assigned_date: new Date().toISOString().split("T")[0],
  start_date: settings.start_date || new Date().toISOString().split("T")[0],
  end_date: settings.end_date || null, // Use null instead of ""
  frequency: settings.frequency || "Daily",
  time_of_day: settings.time_of_day || "Morning",
  appointment_id: parseInt(currentAppointmentId), // Fixed typo and converted to Number
  exercise_ids: parseInt(exId) 
};
          if (!payload.end_date)
            throw new Error(`End date missing for exercise ID: ${exId}`);
          return dispatch(createExerciseAssignment(payload));
        }),
      );

      showSuccessModal(
        "Success",
        "Selected exercises assigned with individual schedules!",
      );
      dispatch(getExerciseAssignments({ PatientID: id }));
      setShowExerciseModal(false);
      setSelectedExerciseIds([]);
    } catch (err) {
      showErrorModal("Error", err.message || "Failed to assign exercises.");
    } finally {
      setIsSaving(false);
    }
  };
  const handleSettingChange = (exId, field, value) => {
    setIndividualSettings((prev) => ({
      ...prev,
      [exId]: {
        ...prev[exId],
        [field]: value,
      },
    }));
  };
  const handleDeleteAssignment = async (assignmentId) => {
    if (window.confirm("Delete this assignment?")) {
      await dispatch(deleteExerciseAssignment({ id: assignmentId }));
      dispatch(getExerciseAssignments({ PatientID: id }));
    }
  };

  const resetAssignmentForm = () => {
    setAssignmentForm({
    exercise_ids: "",
      start_date: new Date().toISOString().split("T")[0],
      end_date: "",
      frequency: "Daily",
      time_of_day: "Morning",
    });
    setIsEditingAssignment(false);
  };
const toggleSection = (id, type) => {
  setExpandedRowId(null);
  setExpandedExerciseRowId(null);
  setExpandedDietRowId(null); 

  if (expandedSection.id === id && expandedSection.type === type) {
    setExpandedSection({ id: null, type: null });
  } else {
    setExpandedSection({ id: id, type: type });
    setCurrentAppointmentId(id);
  }
};
  const handleSavePrescription = async () => {
    if (!currentAppointmentId || !patient || !doctorID) {
      showErrorModal("Error", "Missing critical information.");
      return;
    }
    if (!signature) {
      showErrorModal("Warning", "Doctor signature is required.");
      return;
    }
    const validPrescriptions = prescriptions.filter(
      (item) => item.name && item.quantity && item.days,
    );
    if (validPrescriptions.length === 0) {
      showErrorModal("Warning", "Please add at least one valid prescription.");
      return;
    }
    setIsSaving(true);
    try {
      await Promise.all(
        validPrescriptions.map((item) => {
          const formData = new FormData();
          Object.entries({
            appointmentId: currentAppointmentId,
            PatientID: patient.PatientID,
            hospitalID: doctorID,
            name: item.name,
            quantity: item.quantity,
            days: item.days,
            time: item.time.join(", "),
            signature,
          }).forEach(([key, value]) => formData.append(key, value));
          return dispatch(createPrescription(formData));
        }),
      );
      await dispatch(getAllPrescriptions(hospitalID));
      setShowPrescriptionModal(false);
      showSuccessModal("Success", "Prescription(s) saved successfully!");
    } catch (err) {
      showErrorModal(
        "Error",
        `Failed to save prescription(s). ${err.message || ""}`,
      );
    } finally {
      setIsSaving(false);
    }
  };

const handleUpdatePrescription = async () => {
  if (!editingPrescription || !patient)
    return showErrorModal("Error", "Missing critical information.");
  
  setIsSaving(true);
  try {
    const formData = new FormData();
    
    // 1. Basic Data Append
    const updateData = {
      id: editingPrescription.id,
      appointmentId: editingPrescription.appointmentId,
      PatientID: patient.PatientID,
      hospitalID: doctorID,
      name: editingPrescription.name,
      quantity: editingPrescription.quantity,
      days: editingPrescription.days,
      time: Array.isArray(editingPrescription.time) 
            ? editingPrescription.time.join(", ") 
            : (editingPrescription.time || ""),
    };

    Object.entries(updateData).forEach(([key, value]) => formData.append(key, value));

    // 2. SIGNATURE LOGIC (FIX): 
    // Check karein 'editSignature' (Modal wala) ya 'signature' (Inline Card wala)
    // Jo bhi file available hogi wo append ho jayegi
    const finalSignature = editSignature || signature;

    if (finalSignature) {
      formData.append("signature", finalSignature);
      console.log("Signature found and appended:", finalSignature.name);
    } else {
      console.log("No new signature file selected");
    }
    
    // 3. Dispatch and Refresh
    await dispatch(updatePrescription(formData));
    await dispatch(getAllPrescriptions(hospitalID));
    
    // 4. Close Modals and Reset Files
    setEditModalOpen(false);
    setShowPrescriptionModal(false);
    setEditSignature(null); // Reset after update
    setSignature(null);     // Reset after update
    
    showSuccessModal("Success", "Prescription updated successfully!");
  } catch (err) {
    showErrorModal("Error", `Failed to update prescription. ${err.message || ""}`);
  } finally {
    setIsSaving(false);
  }
};
  const handleDeletePrescription = async (prescriptionId) => {
    if (window.confirm("Are you sure you want to delete this prescription?")) {
      setDeletingPrescriptionId(prescriptionId);
      try {
        await dispatch(deletePrescription(prescriptionId));
        await dispatch(getAllPrescriptions(hospitalID));
        showSuccessModal("Success", "Prescription deleted.");
      } catch (err) {
        showErrorModal(
          "Error",
          `Failed to delete prescription. ${err.message || ""}`,
        );
      } finally {
        setDeletingPrescriptionId(null);
      }
    }
  };

  const handleOpenMedicalRecordModal = (appointmentId) => {
    setCurrentAppointmentId(appointmentId);
    setNewRecordData({
      date: new Date().toISOString().split("T")[0],
      heartRate: "",
      SPO: "",
      BP: "",
      sugar: "",
      height: "",
      weight: "",
      diagnosis: "",
      treatment: "",
    });
    setNewRecordFile(null);
    setShowMedicalRecordModal(true);
  };

  const handleSaveMedicalRecord = async () => {
    if (!currentAppointmentId || !patient || !doctorID)
      return showErrorModal("Error", "Missing critical information.");
    if (!newRecordData.diagnosis || !newRecordData.treatment)
      return showErrorModal("Warning", "Diagnosis and Treatment are required.");
    setIsSaving(true);
    try {
      const formData = new FormData();
      Object.entries({
        appointmentId: currentAppointmentId,
        PatientID: patient.PatientID,
        hospitalID: doctorID,
        ...newRecordData,
      }).forEach(([key, value]) => formData.append(key, value));
      if (newRecordFile) formData.append("uploadFile", newRecordFile);
      await dispatch(createMedicalRecord(formData));
      await dispatch(getAllMedicalRecords(hospitalID));
      setShowMedicalRecordModal(false);
      showSuccessModal("Success", "Medical record added.");
    } catch (err) {
      showErrorModal("Error", `Failed to add record. ${err.message || ""}`);
    } finally {
      setIsSaving(false);
    }
  };

  const handleDeleteMedicalRecord = async (recordId) => {
    if (
      window.confirm("Are you sure you want to delete this medical record?")
    ) {
      setDeletingRecordId(recordId);
      try {
        await dispatch(deleteMedicalRecord(recordId));
        await dispatch(getAllMedicalRecords(hospitalID));
        showSuccessModal("Success", "Record deleted.");
      } catch (err) {
        showErrorModal(
          "Error",
          `Failed to delete record. ${err.message || ""}`,
        );
      } finally {
        setDeletingRecordId(null);
      }
    }
  };

  const handleOpenEditMedicalRecordModal = (record) => {
    setEditingMedicalRecord({ ...record });
    setEditRecordFile(null);
    setShowEditMedicalRecordModal(true);
  };

  const handleEditRecordInputChange = (e) => {
    const { name, value } = e.target;
    setEditingMedicalRecord((prev) => ({ ...prev, [name]: value }));
  };
  // Replace the existing handleJoinVideo function with this:
  // Replace the existing handleJoinVideo function with this:
  const handleJoinVideo = async (appointmentId) => {
    if (joinCooldown) {
      console.log("Join button in cooldown, please wait");
      return;
    }

    setIsJoining(appointmentId);
    setJoinCooldown(true);

    setTimeout(() => setJoinCooldown(false), 5000);

    const currentDoctorId = localStorage.getItem("hospitalCode");
    if (!currentDoctorId) {
      showErrorModal(
        "Authentication Error",
        "Could not identify the current doctor.",
      );
      setIsJoining(null);
      setJoinCooldown(false);
      return;
    }

    const appointment = groupedData.find(
      (item) => item.appointmentId === appointmentId,
    );
    if (!appointment) {
      showErrorModal("Error", "Could not find appointment details.");
      setIsJoining(null);
      setJoinCooldown(false);
      return;
    }

    // Parse appointment time for payload
    const timeRange = appointment.appointmentTime;
    const [startTimeStr, endTimeStr] = timeRange.split(" - ");
    if (!startTimeStr || !endTimeStr) {
      showErrorModal("Error", "Invalid appointment time format.");
      setIsJoining(null);
      setJoinCooldown(false);
      return;
    }

    const [startTime, startModifier] = startTimeStr.split(" ");
    let [startHours, startMinutes] = startTime.split(":").map(Number);
    if (startModifier === "PM" && startHours < 12) startHours += 12;
    if (startModifier === "AM" && startHours === 12) startHours = 0;

    const [endTime, endModifier] = endTimeStr.split(" ");
    let [endHours, endMinutes] = endTime.split(":").map(Number);
    if (endModifier === "PM" && endHours < 12) endHours += 12;
    if (endModifier === "AM" && endHours === 12) endHours = 0;

    const startTotalMinutes = startHours * 60 + startMinutes;
    const endTotalMinutes = endHours * 60 + endMinutes;
    const durationMinutes = endTotalMinutes - startTotalMinutes;

    const scheduledDate = new Date(appointment.appointmentDate);
    const formattedDateTime = `${scheduledDate.getFullYear()}-${String(scheduledDate.getMonth() + 1).padStart(2, "0")}-${String(scheduledDate.getDate()).padStart(2, "0")} ${String(startHours).padStart(2, "0")}:${String(startMinutes).padStart(2, "0")}:00`;
    // No room exists - create a new session
    console.log(
      `No room exists for appointment ${appointmentId}. Creating new session.`,
    );
    const initiatePayload = {
      appointmentId: appointmentId,
      scheduled_start_time: formattedDateTime,
      scheduled_duration_minutes: durationMinutes,
    };
    // Call the action directly (no dispatch since it's passed as prop)
    provisionVideoSession(initiatePayload);
  };
  // Enhanced useEffect for video state handling
  // In your video state handling useEffect:
  useEffect(() => {
    console.log("Video state changed:", {
      token: !!token,
      roomName: roomName,
      videoError,
      isJoining,
      videoLoading,
    });

    if (token && roomName && isJoining && !videoLoading) {
      const currentPath = history.location.pathname;
      const targetPath = `/doctorvideopage/${roomName}/60`;

      // Only navigate if we're not already on the target page
      if (currentPath !== targetPath) {
        console.log("Navigating to video page:", targetPath);
        history.push(targetPath);
        setIsJoining(null);
      }
    }

    if (videoError) {
      console.error("Video error occurred:", videoError);
      showErrorModal("Could Not Join Call", videoError);
      setIsJoining(null);
    }
  }, [token, roomName, videoError, history, isJoining, videoLoading]);

  const handleUpdateMedicalRecord = async () => {
    if (!editingMedicalRecord)
      return showErrorModal("Error", "No record selected for editing.");
    setIsSaving(true);
    try {
      const formData = new FormData();
      Object.keys(editingMedicalRecord).forEach((key) => {
        if (editingMedicalRecord[key] !== null && key !== "uploadFile") {
          formData.append(key, editingMedicalRecord[key]);
        }
      });
      if (editRecordFile) {
        formData.append("uploadFile", editRecordFile);
      }
      await dispatch(updateMedicalRecord(formData));
      await dispatch(getAllMedicalRecords(hospitalID));
      setShowEditMedicalRecordModal(false);
      setEditingMedicalRecord(null);
      showSuccessModal("Success", "Medical record updated successfully!");
    } catch (err) {
      showErrorModal("Error", `Failed to update record. ${err.message || ""}`);
    } finally {
      setIsSaving(false);
    }
  };

  // const handleUpdateAppointmentStatus = async (appointmentId, status) => {
  //   if (updatingApptId) return;
  //   setUpdatingApptId(appointmentId);
  //   try {
  //     await dispatch(updateAppointment({ appointmentId, status }));
  //     await dispatch(getAllAppointments(hospitalID));
  //     showSuccessModal("Success", `Appointment has been marked as ${status}.`);
  //   } catch (err) {
  //     showErrorModal(
  //       "Error",
  //       `Failed to update appointment. ${err.message || ""}`,
  //     );
  //   } finally {
  //     setUpdatingApptId(null);
  //   }
  // };
const handleUpdateAppointmentStatus = async (appointmentId, status) => {
  if (updatingApptId) return;
  setUpdatingApptId(appointmentId);

  try {
    // 1. Database mein status update karein
    await dispatch(updateAppointment({ appointmentId, status }));
    
    // List ko refresh karein
    await dispatch(getAllAppointments(hospitalID));

    // 2. Agar status "Complete" hai, toh SMS bhejein (SQL Row No. 6)
    if (status === "Complete" && patient?.phoneNumber) {
      const smsPayload = {
        hid: "2", // Aapke system ke according hid: "2"
        recipientPhone: patient.phoneNumber,
        eventId: "MEDISEVAS_APP_PATIENT_VISIT_COMPLETION",
        templateData: {
          // Template: Thank you for your consultation with Dr. {{doctorName}}...
          doctorName: ` ${currentDoctor?.firstName} ${currentDoctor?.lastName}`,
        },
      };
      
      // SMS Dispatch karein
      await dispatch(sendConfirmationSms(smsPayload));
      console.log("Visit Completion SMS sent to patient");
    }

    showSuccessModal("Success", `Appointment has been marked as ${status}.`);
  } catch (err) {
    showErrorModal(
      "Error",
      `Failed to update appointment. ${err.message || ""}`
    );
  } finally {
    setUpdatingApptId(null);
  }
};
  const handlePrescriptionChange = (index, field, value) => {
    const updated = [...prescriptions];
    updated[index][field] = value;
    setPrescriptions(updated);
  };
  const handleTimeToggle = (index, time) => {
    const updated = [...prescriptions];
    const times = updated[index].time;
    updated[index].time = times.includes(time)
      ? times.filter((t) => t !== time)
      : [...times, time];
    setPrescriptions(updated);
  };
  const addPrescriptionItem = () =>
    setPrescriptions([
      ...prescriptions,
      { name: "", quantity: "", days: "", time: [] },
    ]);
  const removePrescriptionItem = (index) =>
    setPrescriptions(prescriptions.filter((_, i) => i !== index));
  const handleEditFormChange = (field, value) => {
    setEditingPrescription((prev) => ({ ...prev, [field]: value }));
  };
  const handleEditTimeToggle = (time) => {
    const currentTimes = editingPrescription.time;
    const newTimes = currentTimes.includes(time)
      ? currentTimes.filter((t) => t !== time)
      : [...currentTimes, time];
    setEditingPrescription((prev) => ({ ...prev, time: newTimes }));
  };
  const handlePreviewSingleDiet = (diet) => {
  // Purana modal 'assigned_diets' array expect karta hai
  // Isliye hum single diet ko ek temporary object mein wrap karenge
  const previewData = {
    start_date: "Preview",
    end_date: "Mode",
    assigned_diets: [diet] // Diet ko array mein dala
  };
  setViewingDietPlan(previewData);
  setShowViewDietModal(true);
};
  const handleRecordInputChange = (e) => {
    const { name, value } = e.target;
    setNewRecordData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };
  const patientInvoices = (invoices || [])
    .filter(
      (inv) =>
        String(inv.PatientID) === String(id) &&
        String(inv.hospitalID) === String(doctorID),
    )
    .sort((a, b) => new Date(b.date) - new Date(a.date));
  const filteredExercises = exerciseList.filter(
    (ex) =>
      ex.title.toLowerCase().includes(exerciseSearchTerm.toLowerCase()) ||
      (ex.exercise_type &&
        ex.exercise_type
          .toLowerCase()
          .includes(exerciseSearchTerm.toLowerCase())),
  );

  const handleSelectAll = (e) => {
    if (e.target.checked) {
      const visibleIds = filteredExercises.map((ex) => ex.id);
      setSelectedExerciseIds((prev) =>
        Array.from(new Set([...prev, ...visibleIds])),
      );
    } else {
      const visibleIds = filteredExercises.map((ex) => ex.id);
      setSelectedExerciseIds((prev) =>
        prev.filter((id) => !visibleIds.includes(id)),
      );
    }
  };

  const isAllVisibleSelected =
    filteredExercises.length > 0 &&
    filteredExercises.every((ex) => selectedExerciseIds.includes(ex.id));
  // Before your main return, or within your loading checks:
  if (!patient || !currentDoctor || doctorLoading || videoSessionsLoading) {
    // Add videoSessionsLoading
    return (
      <div
        style={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          height: "80vh",
        }}
      >
        <div
          className="spinner-border text-primary"
          style={{ width: "3rem", height: "3rem" }}
          role="status"
        ></div>
        {videoSessionsLoading && (
          <span className="sr-only ml-2">Loading video sessions...</span>
        )}
      </div>
    );
  }

  // You could also add a dedicated error message if needed:
  if (videoSessionsError) {
    return (
      <div className="alert alert-danger" role="alert">
        Error loading video sessions: {videoSessionsError}
      </div>
    );
  }
const renderDietDetails = (item) => {
  const assignedDiets = patientDietList.filter(
    (pd) => String(pd.Appoinment_Id) === String(item.appointmentId)
  );
  const hasDiets = assignedDiets.length > 0;
  const isDesigning = (isEditingDiet || !hasDiets) && String(currentAppointmentId) === String(item.appointmentId);

  const filteredDiets = dietList.filter(d =>
    d.title.toLowerCase().includes(dietSearchTerm.toLowerCase())
  );

  const filteredDietTemplates = dietTemplates?.filter(temp => 
    temp.status === "Active" && 
    temp.template_name.toLowerCase().includes(dietSearchTerm.toLowerCase())
  );

  return (
    <div className="w-100 border-top shadow-inner" style={{ backgroundColor: "#fcfcfc" }}>
      
      {/* CASE A: HISTORY (Rehab History jaisa) */}
      {!isDesigning && (
        <div className="p-3 p-md-4 bg-white border-bottom">
          <div className="d-flex flex-column flex-sm-row justify-content-between align-items-sm-center gap-3 mb-3">
            <h5 className="mb-0 font-weight-bold" style={{ color: '#ff8c00' }}>
              <i className="fas fa-utensils me-2"></i> Nutrition History
            </h5>
            <button className="btn btn-sm btn-warning text-white rounded-pill px-4 shadow-sm" onClick={() => {
                setCurrentAppointmentId(item.appointmentId);
                setIsEditingDiet(false);
                setSelectedDietIds([]); 
                setTemplateDietSelections({});
                setSelectedDietTemplateIds([]);
            }}>
               <i className="fas fa-plus me-1"></i> New Diet Plan
            </button>
          </div>

          {hasDiets ? (
            <div className="table-responsive shadow-sm rounded border">
              <table className="table table-rounded align-middle mb-0" style={{ minWidth: '600px' }}>
                <thead className="table-warning small">
                  <tr>
                    <th>Date</th>
                    <th>Diet Plan Summary</th>
                    <th>Period</th>
                    <th className="text-center">Action</th>
                  </tr>
                </thead>
                <tbody>
                  {assignedDiets.map((asgn) => (
                   <tr key={asgn.id}>
  <td className="small text-nowrap">{asgn.assigned_date}</td>
  <td>
    <div className="text-truncate fw-bold text-dark" style={{ maxWidth: "300px" }}>
      {/* Yahan map use karein kyunki multiple diets ho sakte hain */}
      {asgn.assigned_diets?.map(d => d.title).join(", ") || "No Title"}
    </div>
  </td>
  <td>
    <span className="badge bg-light text-warning border me-1">{asgn.start_date}</span>
    <span className="text-muted">to</span>
    <span className="badge bg-light text-warning border ms-1">{asgn.end_date}</span>
  </td>
                      <td className="text-center">
                        <div className="d-flex justify-content-center gap-2">
                          <button className="btn btn-sm btn-success" onClick={() => handleOpenPdf("diet", { ...item, dietAssignments: [asgn] })}><i className="fas fa-print"></i></button>
                          <button className="btn btn-sm btn-info" onClick={() => { setViewingDietPlan(asgn); setShowViewDietModal(true); }}><i className="fas fa-eye"></i></button>
                           <button className="btn btn-sm btn-warning text-white" title="Edit Plan" onClick={() => handleEditDietPlan(asgn, item.appointmentId)}><i className="fas fa-edit"></i></button>
                          <button className="btn btn-sm btn-danger" onClick={() => handleDeleteDietAssignment(asgn.id)}><i className="fas fa-trash-alt"></i></button>
                        </div>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          ) : (
            <div className="text-center py-4 text-muted small border rounded bg-light">No Diet Plan assigned. Click "New Diet Plan" to start.</div>
          )}
        </div>
      )}

      {/* CASE B: DESIGNER (Design Rehab Plan jaisa) */}
      {isDesigning && (
        <div className="design-plan-inline animate__animated animate__fadeIn border-bottom shadow-sm">
          
          <div className="bg-warning text-white p-3 p-md-4 d-flex justify-content-between align-items-center">
            <div className="d-flex align-items-center">
              <div className="bg-white text-warning rounded-circle d-flex align-items-center justify-content-center d-none d-sm-flex me-3" style={{ width: '40px', height: '40px' }}>
                <i className="fas fa-utensils fa-lg"></i>
              </div>
              <div>
                 <h5 className="modal-title fw-bold mb-0">
    {isEditingDiet ? `Edit Diet Plan #${currentDietAssignmentId}` : "Design Nutrition Plan"}
  </h5>
                <small className="opacity-75 d-none d-md-block">
    {isEditingDiet ? "Modify existing selections and dates" : "Select individual diets or templates"}
  </small>
              </div>
            </div>
            <button type="button" className="btn-close btn-close-white" onClick={() => { setIsEditingDiet(false); setCurrentAppointmentId(null); }}></button>
          </div>

          <div style={{ backgroundColor: "#fdfdfd" }}>
            <div className="bg-white shadow-sm px-3 px-md-4 py-3 border-bottom sticky-top" style={{ top: 0, zIndex: 10 }}>
              <div className="row g-3 align-items-center">
                <div className="col-12 col-xl-3">
                  <div className="nav nav-pills gap-1">
                    <button className={`nav-link rounded-pill py-1 px-3 small fw-bold ${dietMode === 'individual' ? 'active bg-warning shadow-sm' : 'text-secondary bg-light'}`} onClick={() => setDietMode('individual')}>Individual</button>
                    <button className={`nav-link rounded-pill py-1 px-3 small fw-bold ${dietMode === 'template' ? 'active bg-warning shadow-sm' : 'text-secondary bg-light'}`} onClick={() => setDietMode('template')}>Templates</button>
                  </div>
                </div>
                <div className="col-12 col-md-4 col-xl-3">
                  <input type="text" className="form-control form-control-sm rounded-pill" placeholder="Search..." value={dietSearchTerm} onChange={(e) => setDietSearchTerm(e.target.value)} />
                </div>
                <div className="col-12 col-xl-6 d-flex gap-2">
                   <input type="date" className="form-control form-control-sm rounded-pill" value={dietForm.start_date} onChange={(e) => setDietForm({...dietForm, start_date: e.target.value})} />
                   <input type="date" className="form-control form-control-sm rounded-pill" value={dietForm.end_date} onChange={(e) => setDietForm({...dietForm, end_date: e.target.value})} />
                </div>
              </div>
            </div>

            <div className="p-3 p-md-4" style={{ maxHeight: "400px", overflowY: "auto" }}>
              {dietMode === "individual" && (
                <div className="table-responsive rounded shadow-sm border bg-white">
                  <table className="table table-hover align-middle mb-0">
                    <thead className="bg-light small fw-bold">
                      <tr>
                        <th width="60" className="text-center">Select</th>
                        <th>Diet Title</th>
                        <th>Type</th>
                        <th className="text-center">Preview</th>
                      </tr>
                    </thead>
                    <tbody>
                      {filteredDiets.map((d) => (
                        <tr key={d.id} className={selectedDietIds.includes(d.id) ? "table-warning" : ""}>
                          <td className="text-center">
                            <input type="checkbox" checked={selectedDietIds.includes(d.id)} onChange={() => {
                              setSelectedDietIds(prev => prev.includes(d.id) ? prev.filter(i => i !== d.id) : [...prev, d.id]);
                            }} />
                          </td>
                          <td className="small fw-bold">{d.title}</td>
                          <td><span className="badge bg-info-light text-info">{d.diet_type}</span></td>
                         
                        
<td className="text-center">
  <i 
    className="fas fa-eye text-info cursor-pointer" 
    onClick={() => handlePreviewSingleDiet(d)} // Call the new function
  ></i>
</td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
              )}

              {dietMode === "template" && (
                <div className="row g-3">
                  {filteredDietTemplates?.map((temp) => {
                    const isSelected = selectedDietTemplateIds.includes(temp.id);
                    return (
                      <div className="col-12 col-md-6" key={temp.id}>
                        <div className={`card h-100 border-0 shadow-sm rounded-4 overflow-hidden`} style={{ border: isSelected ? '2px solid #ff8c00' : '1px solid #eee' }}>
                          <div className={`card-header p-3 d-flex justify-content-between align-items-center ${isSelected ? 'bg-warning text-white' : 'bg-white'}`}>
                            <div className="form-check m-0">
                              <input type="checkbox" className="form-check-input" checked={isSelected} onChange={() => handleSelectDietTemplate(temp)} />
                              <label className="fw-bold ms-2 mb-0 small">{temp.template_name}</label>
                            </div>
                            <span className="badge bg-light text-dark">{temp.diet_plans?.length} Plans</span>
                          </div>
                          {isSelected && (
                            <div className="card-body p-0 animate__animated animate__fadeIn">
                              <div className="list-group list-group-flush" style={{ maxHeight: "150px", overflowY: "auto" }}>
                                {temp.diet_plans?.map((dp, idx) => (
                                  <div key={idx} className="list-group-item d-flex align-items-center py-2 px-3 small">
                                    <input type="checkbox" className="me-2" checked={templateDietSelections[temp.id]?.includes(Number(dp.diet_id))} onChange={() => toggleDietInTemplate(temp.id, dp.diet_id)} />
                                    <span>{dp.title}</span>
                                  </div>
                                ))}
                              </div>
                            </div>
                          )}
                        </div>
                      </div>
                    );
                  })}
                </div>
              )}
            </div>

            <div className="bg-white border-top px-3 py-3 d-flex justify-content-between align-items-center">
              <div className="small fw-bold text-muted">Selected Plans: {new Set([...selectedDietIds, ...(Object.values(templateDietSelections).flat())]).size}</div>
              <div className="d-flex gap-2">
                <button className="btn btn-outline-secondary rounded-pill btn-sm px-4" onClick={() => { setIsEditingDiet(false); setCurrentAppointmentId(null); }}>Cancel</button>
                <button className="btn btn-warning text-white rounded-pill btn-sm px-4 shadow fw-bold" onClick={handleFinalDietAssignment} disabled={isSaving}>
                  {isSaving ? "Saving..." : "Confirm Diet Plan"}
                </button>
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};
const renderExerciseDetails = (item) => {
  const hasAssignments = item.exercises && item.exercises.length > 0;
  const isDesigning = (isEditingAssignment || !hasAssignments) && String(currentAppointmentId) === String(item.appointmentId);

  // --- UPDATED SEARCH LOGIC ---
  const filteredExercises = exerciseList.filter(ex =>
    ex.title.toLowerCase().includes(exerciseSearchTerm.toLowerCase()) ||
    (ex.exercise_type && ex.exercise_type.toLowerCase().includes(exerciseSearchTerm.toLowerCase()))
  );

  const filteredTemplates = templates?.filter(temp => 
    temp.status === "Active" && 
    temp.template_name.toLowerCase().includes(exerciseSearchTerm.toLowerCase())
  );

  return (
    <div className="w-100 border-top shadow-inner" style={{ backgroundColor: "#fcfcfc" }}>
      
      {/* --- CASE A: HISTORY LIST (Medical Record Style) --- */}
      {!isDesigning && (
        <div className="p-3 p-md-4 bg-white border-bottom">
          <div className="d-flex flex-column flex-sm-row justify-content-between align-items-sm-center gap-3 mb-3">
            <h5 className="mb-0 font-weight-bold" style={{ color: '#6f42c1' }}>
              <i className="fas fa-clipboard-list me-2"></i> Rehab History
            </h5>
            <button className="btn btn-sm btn-success rounded-pill px-4 shadow-sm" onClick={() => {
                setCurrentAppointmentId(item.appointmentId);
                setIsEditingAssignment(false);
                setSelectedExerciseIds([]); 
                setTemplateExerciseSelections({});
                setSelectedTemplateIds([]);
            }}>
               <i className="fas fa-plus me-1"></i> New Plan
            </button>
          </div>

          {hasAssignments ? (
            <div className="table-responsive shadow-sm rounded border">
              <table className="table table-rounded align-middle mb-0" style={{ minWidth: '600px' }}>
                <thead className="table-secondary small">
                  <tr>
                    <th>Date</th>
                    <th>Plan Summary</th>
                    <th>Schedule</th>
                    <th className="text-center">Action</th>
                  </tr>
                </thead>
                <tbody>
                  {item.exercises.map((asgn) => (
                    <tr key={asgn.id}>
                      <td className="small text-nowrap">{asgn.assigned_date}</td>
                      <td>
                        <div className="text-truncate fw-bold text-dark" style={{ maxWidth: "250px" }} title={asgn.assigned_exercises?.map(ex => ex.exercise_title).join(", ")}>
                           ID: #{asgn.id} - {asgn.assigned_exercises?.map(ex => ex.exercise_title).join(", ")}
                        </div>
                      </td>
                      <td>
                        <span className="badge bg-light text-primary border me-1">{asgn.frequency}</span>
                        <span className="badge bg-light text-info border">{asgn.time_of_day}</span>
                      </td>
                      <td className="text-center">
                        <div className="d-flex justify-content-center gap-2">
                          <button className="btn btn-sm btn-success" onClick={() => handleOpenPdf("exercise", item)}><i className="fas fa-print"></i></button>
                          <button className="btn btn-sm btn-info" onClick={() => { setViewingAssignmentPlan(asgn); setShowViewPlanModal(true); }}><i className="fas fa-eye"></i></button>
                          <button className="btn btn-sm btn-warning" onClick={() => handleEditPlan(asgn, item.appointmentId)}><i className="fas fa-edit"></i></button>
                          <button className="btn btn-sm btn-danger" onClick={() => handleDeleteAssignment(asgn.id)}><i className="fas fa-trash-alt"></i></button>
                        </div>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          ) : (
            <div className="text-center py-4 text-muted small border rounded bg-light">No Plan assigned. Click "New Plan" to start.</div>
          )}
        </div>
      )}

      {/* --- CASE B: DESIGN REHAB PLAN (RESPONSIVE INLINE UI) --- */}
      {isDesigning && (
        <div className="design-plan-inline animate__animated animate__fadeIn border-bottom shadow-sm">
          
          {/* HEADER */}
          <div className="bg-info text-white p-3 p-md-4 d-flex justify-content-between align-items-center">
            <div className="d-flex align-items-center">
              <div className="bg-white text-info rounded-circle d-flex align-items-center justify-content-center d-none d-sm-flex me-3" style={{ width: '40px', height: '40px' }}>
                <i className="fas fa-file-medical-alt fa-lg"></i>
              </div>
              <div>
                <h5 className="modal-title fw-bold mb-0" style={{ fontSize: '1.1rem' }}>
                  {isEditingAssignment ? `Editing Plan #${currentAssignmentId}` : "Design Rehab Plan"}
                </h5>
                <small className="opacity-75 d-none d-md-block">Select individual exercises or templates to create a plan</small>
              </div>
            </div>
            <button type="button" className="btn-close btn-close-white" onClick={() => { setIsEditingAssignment(false); setCurrentAppointmentId(null); }}></button>
          </div>

          <div style={{ backgroundColor: "#f4f7f6" }}>
            
            {/* STICKY TOP: CONTROLS & SEARCH */}
            <div className="bg-white shadow-sm px-3 px-md-4 py-3 border-bottom sticky-top" style={{ top: 0, zIndex: 10 }}>
              <div className="row g-3 align-items-center">
                
                {/* 1. Tabs Switcher */}
                <div className="col-12 col-xl-3">
                  <div className="nav nav-pills gap-1 flex-nowrap overflow-auto hide-scrollbar pb-1">
                    <button className={`nav-link rounded-pill py-1 px-3 small fw-bold flex-shrink-0 ${assignmentMode === 'individual' ? 'active bg-info shadow-sm' : 'text-secondary bg-light border'}`} onClick={() => setAssignmentMode('individual')}>
                      <i className="fas fa-dumbbell me-2"></i> Individual
                    </button>
                    <button className={`nav-link rounded-pill py-1 px-3 small fw-bold flex-shrink-0 ${assignmentMode === 'template' ? 'active bg-info shadow-sm' : 'text-secondary bg-light border'}`} onClick={() => setAssignmentMode('template')}>
                      <i className="fas fa-layer-group me-2"></i> Templates
                    </button>
                  </div>
                </div>

                {/* 2. Global Search (Both Exercise & Templates) */}
                <div className="col-12 col-md-6 col-xl-3">
                  <div className="input-group input-group-sm">
                    <span className="input-group-text bg-light border-end-0 text-muted rounded-start-pill"><i className="fas fa-search"></i></span>
                    <input type="text" className="form-control bg-light border-start-0 rounded-end-pill shadow-none" 
                      placeholder={assignmentMode === 'individual' ? "Search Exercises..." : "Search Templates..."} 
                      value={exerciseSearchTerm}
                      onChange={(e) => setExerciseSearchTerm(e.target.value)} 
                    />
                  </div>
                </div>

                {/* 3. Dates & Schedule Controls */}
                <div className="col-12 col-xl-6">
                  <div className="row g-2 align-items-center">
                    <div className="col-6 col-sm-3">
                      <input type="date" className="form-control form-control-sm rounded-pill" value={assignmentForm.start_date} onChange={(e) => setAssignmentForm({...assignmentForm, start_date: e.target.value})} title="Start Date" />
                    </div>
                    <div className="col-6 col-sm-3">
                      <input type="date" className="form-control form-control-sm rounded-pill" value={assignmentForm.end_date} onChange={(e) => setAssignmentForm({...assignmentForm, end_date: e.target.value})} title="End Date" />
                    </div>
                    <div className="col-6 col-sm-3">
                      <select className="form-select form-select-sm rounded-pill" value={assignmentForm.frequency} onChange={(e) => setAssignmentForm({...assignmentForm, frequency: e.target.value})}>
                        <option value="Daily">Daily</option>
                        <option value="Twice Daily">2x Daily</option>
                      </select>
                    </div>
                    {/* ADDED: Time of Day field */}
                    <div className="col-6 col-sm-3">
                      <select className="form-select form-select-sm rounded-pill" value={assignmentForm.time_of_day} onChange={(e) => setAssignmentForm({...assignmentForm, time_of_day: e.target.value})}>
                        <option value="Morning">Morning</option>
                        <option value="Afternoon">Afternoon</option>
                        <option value="Evening">Evening</option>
                        <option value="Night">Night</option>
                      </select>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            {/* SELECTION AREA (Scrollable) */}
            <div className="p-3 p-md-4" style={{ maxHeight: "450px", overflowY: "auto" }}>
              
              {/* INDIVIDUAL EXERCISES VIEW */}
             {assignmentMode === "individual" && (
  <div className="table-responsive rounded-4 shadow-sm border bg-white overflow-hidden">
    <table className="table table-hover align-middle mb-0">
      <thead className="bg-light small fw-bold text-muted">
        <tr>
          {/* ps-4 hataya aur text-center add kiya */}
          <th width="60" className="text-center">
            <input 
              type="checkbox" 
              className="form-check-input" 
              checked={isAllVisibleSelected} 
              onChange={handleSelectAll} 
            />
          </th>
          <th>Exercise Title</th>
          <th>Description</th>
          <th className="text-center">Preview</th>
        </tr>
      </thead>
      <tbody>
        {filteredExercises.map((ex) => (
          <tr key={ex.id} className={selectedExerciseIds.includes(ex.id) ? "table-light border-start border-info border-3" : ""}>
            {/* Yaha bhi ps-4 hatakar text-center kiya */}
            <td className="text-center">
              <input 
                type="checkbox" 
                className="form-check-input" 
                checked={selectedExerciseIds.includes(ex.id)}
                onChange={() => {
                  const newIds = selectedExerciseIds.includes(ex.id) ? selectedExerciseIds.filter(id => id !== ex.id) : [...selectedExerciseIds, ex.id];
                  setSelectedExerciseIds(newIds);
                }}
              />
            </td>
            <td>
              <div className="fw-bold text-dark mb-0 small">{ex.title}</div>
            </td>
            <td>
              <div className="text-muted x-small text-truncate" style={{ maxWidth: '400px' }}>{ex.description}</div>
              <span className="badge bg-info-light text-info rounded-pill px-2 mt-1" style={{ fontSize: '9px' }}>{ex.exercise_type || 'General'}</span>
            </td>
            <td className="text-center">
              <button className="btn btn-sm btn-info text-white rounded-circle shadow-sm" onClick={() => handleOpenExercisePreview(ex.id)}>
                <i className="fas fa-eye small"></i>
              </button>
            </td>
          </tr>
        ))}
      </tbody>
    </table>
  </div>
)}

              {/* TEMPLATES GRID VIEW */}
              {assignmentMode === "template" && (
                <div className="row g-3 g-md-4">
                  {filteredTemplates?.map((temp) => {
                    const isTemplateSelected = selectedTemplateIds.includes(temp.id);
                    return (
                      <div className="col-12 col-md-6 col-xxl-4" key={temp.id}>
                         <div className={`card h-100 border-0 shadow-sm rounded-4 overflow-hidden ${isTemplateSelected ? 'ring-active' : ''}`} 
                              style={{ border: isTemplateSelected ? '2px solid #0dcaf0' : '1px solid #eee' }}>
                           
                           {/* Template Card Header */}
                           <div className={`card-header p-3 border-0 d-flex justify-content-between align-items-center ${isTemplateSelected ? 'bg-info text-white' : 'bg-white'}`}>
                             <div className="form-check d-flex align-items-center mb-0">
                               <input type="checkbox" className="form-check-input" checked={isTemplateSelected} onChange={() => handleSelectTemplate(temp)} />
                               <label className="fw-bold ms-2 mb-0 small">{temp.template_name}</label>
                             </div>
                             <span className={`badge rounded-pill ${isTemplateSelected ? 'bg-white text-info' : 'bg-light text-muted border'}`}>{temp.exercises?.length || 0} Ex.</span>
                           </div>

                           {/* Exercises inside Template */}
                           {isTemplateSelected && (
                             <div className="card-body p-0 border-top animate__animated animate__fadeIn">
                               <div className="list-group list-group-flush" style={{ maxHeight: "180px", overflowY: "auto" }}>
                                 {temp.exercises?.map((ex, idx) => {
                                   const exId = Number(ex.exercise_id || ex.id);
                                   const isIncluded = templateExerciseSelections[temp.id]?.includes(exId);
                                   return (
                                     <div key={idx} className="list-group-item d-flex align-items-center justify-content-between py-2 px-3 small">
                                       <div className="form-check d-flex align-items-center">
                                         <input type="checkbox" className="form-check-input me-2" checked={isIncluded} onChange={() => toggleExerciseInTemplate(temp.id, exId)} />
                                         <span className={isIncluded ? "text-dark fw-medium" : "text-muted text-decoration-line-through"}>
                                           {ex.exercise_title || ex.title}
                                         </span>
                                       </div>
                                       <button className="btn btn-xs btn-link p-0" onClick={() => handleOpenExercisePreview(exId)}><i className="fas fa-eye text-info"></i></button>
                                     </div>
                                   );
                                 })}
                               </div>
                             </div>
                           )}
                         </div>
                      </div>
                    );
                  })}
                </div>
              )}
            </div>

            {/* DESIGNER FOOTER (Buttons Section) */}
            <div className="bg-white border-top px-3 px-md-4 py-3 d-flex flex-column flex-sm-row justify-content-between align-items-center gap-3">
              <div className="bg-secondary bg-opacity-10 text-secondary fw-bold rounded-pill px-4 py-2 small shadow-sm">
                 <i className="fas fa-check-circle me-2"></i>
                 {new Set([...selectedExerciseIds, ...(Object.values(templateExerciseSelections).flat())]).size} Exercises Ready
              </div>
              <div className="d-flex gap-2 w-100 w-sm-auto">
                <button className="btn btn-outline-secondary rounded-pill px-4 flex-grow-1" onClick={() => { setIsEditingAssignment(false); setCurrentAppointmentId(null); }}>Cancel</button>
                <button className="btn btn-info text-white rounded-pill px-4 px-md-5 shadow fw-bold flex-grow-1" onClick={handleFinalAssignment} disabled={isSaving}>
                  {isSaving ? <><span className="spinner-border spinner-border-sm me-2"></span>Saving...</> : (isEditingAssignment ? "Update Plan" : "Confirm Plan")}
                </button>
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};
const renderMedicalRecordSection = (item) => {
    const rec = item.medicalRecord;
    const isEditingInline =
      editingMedicalRecord &&
      String(editingMedicalRecord.appointmentId) === String(item.appointmentId);

    return (
      <div
        className="p-4"
        style={{
          backgroundColor: "#ffff",
          borderTop: "3px solid #198754",
          borderBottom: "1px solid #dee2e6",
        }}
      >
        <div className="d-flex justify-content-between align-items-center mb-3">
          <h5 className="text-success mb-0 font-weight-bold">
            <i className="fas fa-file-medical me-2"></i> Medical Record & Notes
          </h5>
        </div>

        {/* CASE 1 : SHOW RECORD */}
        {rec && !isEditingInline ? (
          <div className="table-responsive shadow-sm rounded bg-white">
            <table className="table table-rounded align-middle mb-0">
              <thead className="table-secondary small ">
                <tr>
                  <th>Date</th>
                  <th>Diagnosis Summary</th>
                  <th>Vitals (BP / SPO2)</th>
                  <th className="text-center">Action</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td>{new Date(rec.date).toLocaleDateString()}</td>
                  <td>
                    <div
                      className="text-truncate"
                      style={{ maxWidth: "250px" }}
                    >
                      {rec.diagnosis}
                    </div>
                  </td>
                  <td>
                    <span className="badge bg-light text-dark border me-1">
                      BP: {rec.BP || "--"}
                    </span>
                    <span className="badge bg-light text-dark border">
                      O2: {rec.SPO || "--"}%
                    </span>
                  </td>
                  <td className="text-center">
                    <div className="d-flex justify-content-center gap-2">
                      <button
                        className="btn btn-sm btn-success"
                        title="Print Report"
                        onClick={() => handleOpenPdf("record", item)}
                      >
                        <i className="fas fa-print"></i>
                      </button>

                      <button
                        className="btn btn-sm btn-info text-white"
                        title="View Details"
                        onClick={() => {
                          setViewingRecord(rec); // Naya state set karein
                          setShowEditMedicalRecordModal(true);
                        }}
                      >
                        <i className="fas fa-eye"></i>
                      </button>
                      <button
                        className="btn btn-sm btn-warning text-white"
                        title="Edit Inline"
                        onClick={() => setEditingMedicalRecord({ ...rec })}
                      >
                        <i className="fas fa-edit"></i>
                      </button>

                      <button
                        className="btn btn-sm btn-danger"
                        title="Delete"
                        onClick={() => handleDeleteMedicalRecord(rec.id)}
                      >
                        <i className="fas fa-trash-alt"></i>
                      </button>
                    </div>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        ) : (
          /* CASE 2 : INLINE ADD / EDIT FORM */
          <div className="card shadow-sm border-0 mb-3 overflow-hidden">
            {/* Sleek Compact Header */}
            <div
              className="card-header bg-info text-white d-flex justify-content-between align-items-center py-2"
              style={{ backgroundColor: "#007bff" }}
            >
              <h6 className="mb-0 fw-bold small text-uppercase">
                <i className="fas fa-edit me-2"></i>
                {isEditingInline
                  ? `Edit Medical Record #${editingMedicalRecord.id}`
                  : "Add New Medical Record"}
              </h6>
              <button
                type="button"
                className="btn-close btn-close-white"
                style={{ fontSize: "0.8rem" }}
                onClick={() =>
                  isEditingInline
                    ? setEditingMedicalRecord(null)
                    : setExpandedSection({ id: null, type: null })
                }
              ></button>
            </div>

            <div className="card-body p-3">
              {/* Dates Row - Compact */}
              <div className="row g-2 mb-3">
                <div className="col-md-6">
                  <label className="fw-bold small text-muted mb-1">Date</label>
                  <input
                    type="date"
                    className="form-control form-control-sm"
                    name="date"
                    value={
                      isEditingInline
                        ? editingMedicalRecord.date?.split("T")[0]
                        : newRecordData.date
                    }
                    onChange={
                      isEditingInline
                        ? handleEditRecordInputChange
                        : handleRecordInputChange
                    }
                  />
                </div>
                <div className="col-md-6">
                  <label className="fw-bold small text-muted mb-1">
                    Follow-up Date
                  </label>
                  <input
                    type="date"
                    className="form-control form-control-sm"
                    name="follow_up_date"
                    value={
                      isEditingInline
                        ? editingMedicalRecord.follow_up_date || ""
                        : newRecordData.follow_up_date
                    }
                    onChange={
                      isEditingInline
                        ? handleEditRecordInputChange
                        : handleRecordInputChange
                    }
                  />
                </div>
              </div>

              <div className="border-top pt-2 mt-2">
                <label className="fw-bold small text-dark mb-2">Vitals</label>
                <div className="row g-2">
                  {[
                    {
                      label: "Blood Pressure",
                      name: "BP",
                      value: isEditingInline
                        ? editingMedicalRecord.BP
                        : newRecordData.BP,
                    },
                    {
                      label: "Heart Rate (BPM)",
                      name: "heartRate",
                      value: isEditingInline
                        ? editingMedicalRecord.heartRate
                        : newRecordData.heartRate,
                    },
                    {
                      label: "SPO (%)",
                      name: "SPO",
                      value: isEditingInline
                        ? editingMedicalRecord.SPO
                        : newRecordData.SPO,
                    },
                    {
                      label: "Blood Sugar",
                      name: "sugar",
                      value: isEditingInline
                        ? editingMedicalRecord.sugar
                        : newRecordData.sugar,
                    },
                    {
                      label: "Height (cm)",
                      name: "height",
                      value: isEditingInline
                        ? editingMedicalRecord.height
                        : newRecordData.height,
                    },
                    {
                      label: "Weight (kg)",
                      name: "weight",
                      value: isEditingInline
                        ? editingMedicalRecord.weight
                        : newRecordData.weight,
                    },
                  ].map((vital, idx) => (
                    <div className="col-md-4 col-6" key={idx}>
                      <div className="form-group">
                        <label
                          className="x-small-label text-muted mb-0"
                          style={{ fontSize: "11px" }}
                        >
                          {vital.label}
                        </label>
                        <input
                          type="text"
                          name={vital.name}
                          placeholder="---"
                          className="form-control form-control-sm bg-light-focus"
                          value={vital.value || ""}
                          onChange={
                            isEditingInline
                              ? handleEditRecordInputChange
                              : handleRecordInputChange
                          }
                        />
                      </div>
                    </div>
                  ))}
                </div>
              </div>

              <div className="row  g-2">
                <div className="col-12 mt-0">
                  <label className="fw-bold small text-muted mb-1">
                    Diagnosis
                  </label>
                  <textarea
                    name="diagnosis"
                    rows="2"
                    className="form-control form-control-sm"
                    placeholder="Enter diagnosis..."
                    value={
                      isEditingInline
                        ? editingMedicalRecord.diagnosis
                        : newRecordData.diagnosis
                    }
                    onChange={
                      isEditingInline
                        ? handleEditRecordInputChange
                        : handleRecordInputChange
                    }
                  ></textarea>
                </div>
                <div className="col-12 mt-0">
                  <label className="fw-bold small text-muted mb-1">
                    Treatment
                  </label>
                  <textarea
                    name="treatment"
                    rows="2"
                    className="form-control form-control-sm"
                    placeholder="Enter treatment..."
                    value={
                      isEditingInline
                        ? editingMedicalRecord.treatment
                        : newRecordData.treatment
                    }
                    onChange={
                      isEditingInline
                        ? handleEditRecordInputChange
                        : handleRecordInputChange
                    }
                  ></textarea>
                </div>
              </div>

              {/* Attachment & Action Row */}
              <div className="row mt-3 align-items-center g-2 border-top pt-3">
                {/* Left Side: Preview + Upload Input (Combined) */}
                <div className="col-md-7 d-flex align-items-center gap-2">
                  {/* Preview Slot (Col-1 equivalent) */}
                  <div style={{ width: "45px", flexShrink: 0 }}>
                    {(
                      isEditingInline
                        ? editRecordFile || editingMedicalRecord?.uploadFile
                        : newRecordFile
                    ) ? (
                      <img
                        src={
                          isEditingInline
                            ? editRecordFile
                              ? URL.createObjectURL(editRecordFile)
                              : `${imgUrl}${editingMedicalRecord.uploadFile}`
                            : newRecordFile
                              ? URL.createObjectURL(newRecordFile)
                              : ""
                        }
                        alt="Preview"
                        className="rounded border shadow-sm"
                        style={{
                          width: "45px",
                          height: "45px",
                          objectFit: "cover",
                          cursor: "pointer",
                        }}
                        onClick={() => {
                          const src = isEditingInline
                            ? editRecordFile
                              ? URL.createObjectURL(editRecordFile)
                              : `${imgUrl}${editingMedicalRecord.uploadFile}`
                            : newRecordFile
                              ? URL.createObjectURL(newRecordFile)
                              : "";
                          window.open(src, "_blank");
                        }}
                      />
                    ) : (
                      <div
                        className="rounded border bg-light d-flex align-items-center justify-content-center shadow-sm"
                        style={{ width: "45px", height: "45px" }}
                      >
                        <i className="fas fa-camera text-muted small"></i>
                      </div>
                    )}
                  </div>

                  {/* Upload Input Slot */}
                  <div className="flex-grow-1">
                    {/* Actual input ko hide kar diya */}
                    <input
                      type="file"
                      id="inline-file-upload"
                      accept="image/*"
                      className="d-none"
                      onChange={(e) =>
                        isEditingInline
                          ? setEditRecordFile(e.target.files[0])
                          : setNewRecordFile(e.target.files[0])
                      }
                    />

                    {/* Ye raha aapka Upload Button */}
                    <label
                      htmlFor="inline-file-upload"
                      className="btn btn-info btn-sm rounded-pill px-3 mb-0"
                      style={{ fontSize: "11px", cursor: "pointer" }}
                    >
                      <i className="fas fa-upload me-1"></i>
                      {(
                        isEditingInline
                          ? editRecordFile || editingMedicalRecord?.uploadFile
                          : newRecordFile
                      )
                        ? "Change Image"
                        : "Upload Image"}
                    </label>
                  </div>
                </div>

                {/* Right Side: Action Buttons */}
                <div className="col-md-5 text-end">
                  <button
                    type="button"
                    className="btn btn-outline-secondary btn-sm rounded-pill px-3 me-2"
                    style={{ fontSize: "12px" }}
                    onClick={() =>
                      isEditingInline
                        ? setEditingMedicalRecord(null)
                        : setExpandedSection({ id: null, type: null })
                    }
                  >
                    Cancel
                  </button>

                  <button
                    className={`btn ${isEditingInline ? "btn-success" : "btn-success"} btn-sm rounded-pill px-4 text-white shadow-sm`}
                    style={{ fontSize: "12px" }}
                    disabled={isSaving}
                    onClick={
                      isEditingInline
                        ? handleUpdateMedicalRecord
                        : () => {
                            setCurrentAppointmentId(item.appointmentId);
                            handleSaveMedicalRecord();
                          }
                    }
                  >
                    {isSaving ? (
                      <span className="spinner-border spinner-border-sm"></span>
                    ) : (
                      <>{isEditingInline ? "Update" : "Save"}</>
                    )}
                  </button>
                </div>
              </div>
            </div>
          </div>
        )}
      </div>
    );
  };
const renderPrescriptionSection = (item) => {
  const hasPrescriptions = item.prescriptions && item.prescriptions.length > 0;
  
  // States to track which mode we are in
  const isAddingNow = showPrescriptionModal && String(currentAppointmentId) === String(item.appointmentId);
  const isEditingNow = editingPrescription && !editingPrescription.viewOnly && String(currentAppointmentId) === String(item.appointmentId);

  return (
    <div className="w-100 p-4" style={{ backgroundColor: "#ffff", borderTop: "3px solid #0dcaf0", borderBottom: "1px solid #dee2e6" }}>
      
      {/* 1. CENTRALIZED HEADER */}
      <div className="d-flex justify-content-between align-items-center mb-3">
        <h5 className="mb-0 font-weight-bold" style={{ color: '#0dcaf0' }}>
          <i className="fas fa-prescription me-2"></i> Prescription Set
        </h5>
        
        <div className="d-flex justify-content-center gap-2">
          {hasPrescriptions ? (
            <>
              {/* PRINT: PDF Viewer */}
              <button className="btn btn-sm btn-success" 
              title="Print"
              onClick={() => handleOpenPdf("prescription", item)}>
                <i className="fas fa-print "></i> 
              </button>

              {/* VIEW: Read-Only Modal */}
              <button
                className="btn btn-sm btn-info text-white "
                title="View"
                onClick={() => {
                  setEditingPrescription({
                    viewOnly: true,
                    allMedicines: item.prescriptions,
                    signature: item.prescriptions[0]?.signature,
                  });
                  setEditModalOpen(true);
                }}
              >
                <i className="fas fa-eye "></i> 
              </button>

              {/* EDIT ALL: Inline Form with Existing Data */}
            <button 
  className="btn btn-sm btn-warning text-white" 
  title="Edit"
  onClick={() => {
    // 1. Pehle saari prescriptions ko format karein (taaki time hamesha array rahe)
    const formatted = item.prescriptions.map(p => ({
      ...p, 
      time: typeof p.time === 'string' 
        ? p.time.split(',').map(t => t.trim()) // String ko array mein badle
        : (Array.isArray(p.time) ? p.time : []) // Agar pehle se array hai toh wahi rakhe
    }));

    // 2. Table rows ke liye state set karein
    setPrescriptions(formatted);
    setCurrentAppointmentId(item.appointmentId);

    // 3. FIX: editingPrescription ko poore data ke saath initialize karein
    // Isse handleUpdatePrescription ko 'time.join' karne ke liye array mil jayega
    if (formatted.length > 0) {
      setEditingPrescription({
        ...formatted[0], // Pehli medicine ka data le lein (taaki properties undefined na hon)
        viewOnly: false
      });
    } else {
      setEditingPrescription({ 
        appointmentId: item.appointmentId, 
        time: [], // Default empty array taaki crash na ho
        viewOnly: false 
      });
    }

    setShowPrescriptionModal(true); 
  }}
>
  <i className="fas fa-edit"></i> 
</button>

              {/* DELETE ALL */}
              <button className="btn btn-sm btn-danger" 
              title="Delete"
              onClick={() => {
                if(window.confirm("Delete entire prescription set?")) {
                  item.prescriptions.forEach(p => handleDeletePrescription(p.id));
                }
              }}>
                <i className="fas fa-trash-alt "></i> 
              </button>
            </>
          ) : (
            /* ADD NEW: Only shown if no prescription exists */
            <button className="btn btn-sm btn-success rounded-pill px-3" onClick={() => handleOpenPrescriptionModal(item.appointmentId)}>
              <i className="fas fa-plus me-1"></i> {isAddingNow ? "Adding..." : "Add New Prescription"}
            </button>
          )}
        </div>
      </div>
      {/* 2. INLINE ADD / EDIT FORM (Modal UI inside the row) */}
      {(isAddingNow || isEditingNow) ? (
          <div className="card shadow-sm border-0 mt-3 animate__animated animate__fadeIn overflow-hidden">
          {/* Modal Header style in Card */}
          <div className="card-header bg-info text-white py-2 d-flex justify-content-between align-items-center">
            <h6 className="mb-0 fw-bold small text-uppercase">
              <i className="fas fa-edit me-2"></i>
              {isEditingNow ? `Edit Prescription for Appt #${currentAppointmentId}` : `Add Prescription for Appt #${currentAppointmentId}`}
            </h6>
            <button
              type="button"
              className="btn-close btn-close-white"
              style={{ fontSize: "0.8rem" }}
              onClick={() => {
                setShowPrescriptionModal(false);
                setEditingPrescription(null);
              }}
            ></button>
          </div>

          <div className="card-body p-3">
            {/* Add Item Button - Exactly as in Modal Body */}
            <div className="text-end mb-2">
              <button
                className="btn btn-info rounded-pill btn-sm"
                onClick={addPrescriptionItem}
              >
                <i className="fas fa-plus-circle me-1"></i> Add Item
              </button>
            </div>

            {/* Table - Exactly matching Modal Table styling */}
            <div className="table-responsive">
              <table className="table table-bordered align-middle text-center">
                <thead className="table-light">
                  <tr>
                    <th>Medicine Name</th>
                    <th>Quantity</th>
                    <th>Days</th>
                    <th>Time</th>
                    <th>Action</th>
                  </tr>
                </thead>
                <tbody>
                  {prescriptions.map((item, index) => (
                    <tr key={index}>
                      <td>
                        <input
                          type="text"
                          className="form-control"
                          placeholder="e.g., Paracetamol"
                          value={item.name}
                          onChange={(e) =>
                            handlePrescriptionChange(index, "name", e.target.value)
                          }
                        />
                      </td>
                      <td>
                        <input
                          type="text"
                          className="form-control"
                          placeholder="e.g., 1-1-1"
                          value={item.quantity}
                          onChange={(e) =>
                            handlePrescriptionChange(index, "quantity", e.target.value)
                          }
                        />
                      </td>
                      <td>
                        <input
                          type="text"
                          className="form-control"
                          placeholder="e.g., 5 Days"
                          value={item.days}
                          onChange={(e) =>
                            handlePrescriptionChange(index, "days", e.target.value)
                          }
                        />
                      </td>
                      <td>
                        {["Morning", "Afternoon", "Evening", "Night"].map((time) => (
                          <div key={time} className="form-check form-check-inline">
                            <input
                              className="form-check-input"
                              type="checkbox"
                              checked={item.time.includes(time)}
                              onChange={() => handleTimeToggle(index, time)}
                              id={`time-${index}-${time}`}
                            />
                            <label
                              className="form-check-label small"
                              htmlFor={`time-${index}-${time}`}
                            >
                              {time}
                            </label>
                          </div>
                        ))}
                      </td>
                      <td>
                        <button
                          className="btn btn-sm btn-danger"
                          onClick={() => removePrescriptionItem(index)}
                        >
                          <i className="far fa-trash-alt"></i>
                        </button>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>

            {/* Signature Section - Exactly matching Modal Styling */}
            <div className="form-group mt-3">
              <label className="form-label fw-bold small text-muted">Doctor Signature</label>
              <input
                type="file"
                required
                accept="image/*"
                className="form-control"
                onChange={(e) => {
                  const file = e.target.files[0];
                  if (file) setSignature(file);
                }}
              />
              {signature && (
                <div className="mt-3">
                  <label className="form-label small text-muted">Preview:</label>
                  <img
                    src={URL.createObjectURL(signature)}
                    alt="Signature Preview"
                    style={{ height: 60 }}
                    className="d-block mt-2 border rounded"
                  />
                </div>
              )}
            </div>
          </div>

          {/* Modal Footer Style in Card */}
          <div className="card-footer bg-white border-top-0 text-end pb-3">
            <hr className="mt-0 mb-3" />
            <button
              type="button"
              className="btn btn-secondary rounded-pill px-4 me-2"
              disabled={isSaving}
              onClick={() => {
                setShowPrescriptionModal(false);
                setEditingPrescription(null);
              }}
            >
              Cancel
            </button>
            <button
              type="button"
              className="btn btn-info text-white rounded-pill px-4"
              disabled={isSaving}
              onClick={isEditingNow ? handleUpdatePrescription : handleSavePrescription}
            >
              {isSaving ? (
                <>
                  <span className="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
                  {" Saving..."}
                </>
              ) : (
                isEditingNow ? "Update Prescription" : "Save Prescription"
              )}
            </button>
          </div>
        </div>
      ) : (
        /* 3. STATIC LIST (SADAH TABLE) */
        hasPrescriptions ? (
          <div className="table-responsive shadow-sm rounded bg-white">
            <table className="table table-sm table-bordered mb-0">
              <thead className="table-light small">
                <tr>
                  <th>Medicine</th>
                  <th>Quantity</th>
                  <th>Duration</th>
                  <th>Timing</th>
                </tr>
              </thead>
              <tbody>
                {item.prescriptions.map((p) => (
                  <tr key={p.id}>
                    <td className="fw-bold">{p.name}</td>
                    <td>{p.quantity}</td>
                    <td>{p.days} Days</td>
                    <td><span className="badge bg-light text-info border">{Array.isArray(p.time) ? p.time.join(", ") : p.time}</span></td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        ) : (
          <div className="text-center p-3 border rounded bg-light">
            <span className="text-muted small italic">No medicines assigned yet.</span>
          </div>
        )
      )}
    </div>
  );
};
  const renderAppointmentDetails = (item) => {
    const rec = item.medicalRecord;
    const bmi = rec ? calculateBmi(rec.weight, rec.height) : "N/A";
    const bmiStatus = rec
      ? getBmiStatus(bmi)
      : { status: "N/A", className: "text-muted" };

    return (
      <div
        className=" w-100"
        style={{ backgroundColor: "#f8f9fa", borderTop: "2px solid #dee2e6" }}
      >
        <div className="d-flex justify-content-between align-items-center mb-3">
          <h5 className="card-title mb-0 text-info">
            Details for Appointment #{item.appointmentId}
          </h5>
          <div>
            <button
              type="button"
              className="btn btn-info rounded-pill btn-sm mt-2"
              onClick={() => handleOpenPdf("prescription", item)}
            >
              <i className="fas fa-print me-1"></i> Print Prescriptions
            </button>
            <button
              type="button"
              className="btn btn-info rounded-pill btn-sm ml-2 mt-2"
              onClick={() => handleOpenPdf("record", item)}
            >
              <i className="fas fa-print me-1"></i> Print Record
            </button>
            <button
              type="button"
              className="btn btn-info rounded-pill btn-sm mt-2 ml-2 mr-1"
              onClick={() => handleOpenPdf("exercise", item)}
            >
              <i className="fas fa-print me-1"></i> Print Exercise Chart
            </button>
            <button
  type="button"
  className="btn btn-info text-white rounded-pill btn-sm mt-2 ml-2 mr-1"
  onClick={() => handleOpenPdf("diet", item)}
>
  <i className="fas fa-print me-1"></i> Print Diet Chart
</button>
          </div>
        </div>
        <h6 className="text-dark">Prescriptions</h6>
        {item.prescriptions.length > 0 ? (
          <div className="table-responsive">
            <table className="table table-bordered table-sm bg-white">
              <thead className="table-light">
                <tr>
                  <th>Date</th>
                  <th>Medicine</th>
                  <th>Frequency</th>
                  <th>Days</th>
                  <th>Time</th>
                  <th>Action</th>
                </tr>
              </thead>
              <tbody>
                {item.prescriptions.map((p) => (
                  <tr key={`view-p-${p.id}`}>
                    <td>{new Date(p.date).toLocaleDateString()}</td>
                    <td>{p.name}</td>
                    <td>{p.quantity}</td>
                    <td>{p.days}</td>
                    <td>
                      {Array.isArray(p.time) ? p.time.join(", ") : p.time}
                    </td>
                    <td>
                      <button
                        className="btn btn-sm btn-warning m-1 text-white"
                        title="Edit Prescription"
                        onClick={() => {
                          setEditingPrescription({
                            ...p,
                            time:
                              typeof p.time === "string"
                                ? p.time.split(",").map((t) => t.trim())
                                : p.time || [],
                          });
                          setEditModalOpen(true);
                        }}
                      >
                        <i className="fas fa-edit"></i>
                      </button>
                      <button
                        className="btn btn-sm btn-danger m-1"
                        title="Delete Prescription"
                        onClick={() => handleDeletePrescription(p.id)}
                        disabled={deletingPrescriptionId === p.id}
                      >
                        {deletingPrescriptionId === p.id ? (
                          <span className="spinner-border spinner-border-sm"></span>
                        ) : (
                          <i className="fas fa-trash-alt"></i>
                        )}
                      </button>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        ) : (
          <p className="text-muted">No prescriptions for this appointment.</p>
        )}
        <hr className="my-4" />
        <h6 className="text-dark">Medical Record</h6>
        {rec ? (
          <div className="card mb-3 bg-white">
            <div className="card-header d-flex justify-content-between align-items-center">
              <span>
                Record ID: #{rec.id} - {new Date(rec.date).toLocaleDateString()}
              </span>
              <div>
                <button
                  className="btn btn-sm btn-warning text-white"
                  title="Edit Record"
                  onClick={() => handleOpenEditMedicalRecordModal(rec)}
                >
                  <i className="fas fa-edit"></i>
                </button>
                <button
                  className="btn btn-sm bg-danger text-white ml-2"
                  title="Delete Record"
                  onClick={() => handleDeleteMedicalRecord(rec.id)}
                  disabled={deletingRecordId === rec.id}
                >
                  {deletingRecordId === rec.id ? (
                    <span className="spinner-border spinner-border-sm"></span>
                  ) : (
                    <i className="fas fa-trash-alt"></i>
                  )}
                </button>
              </div>
            </div>
            <div className="card-body ml-2">
              <div className="record-section">
                <h6 className="text-secondary">Vitals</h6>
                <div className="row">
                  <div className="col-6 col-md-3 mb-2">
                    <strong>BP:</strong> {rec.BP || "N/A"}
                  </div>
                  <div className="col-6 col-md-3 mb-2">
                    <strong>Heart Rate:</strong> {rec.heartRate || "N/A"}
                  </div>
                  <div className="col-6 col-md-3 mb-2">
                    <strong>SPO2:</strong> {rec.SPO || "N/A"}
                  </div>
                  <div className="col-6 col-md-3 mb-2">
                    <strong>Blood Sugar:</strong> {rec.sugar || "N/A"}
                  </div>
                  <div className="col-6 col-md-3 mb-2">
                    <strong>Height:</strong>{" "}
                    {rec.height ? `${rec.height} cm` : "N/A"}
                  </div>
                  <div className="col-6 col-md-3 mb-2">
                    <strong>Weight:</strong>{" "}
                    {rec.weight ? `${rec.weight} kg` : "N/A"}
                  </div>
                  <div className="col-12 col-md-6 mb-2">
                    <strong>BMI:</strong>{" "}
                    <span className={bmiStatus.className}>
                      {bmi} ({bmiStatus.status})
                    </span>
                  </div>
                </div>
              </div>
              <hr />
              <div className="record-section">
                <h6 className="text-secondary">Diagnosis</h6>
                <p style={{ whiteSpace: "pre-wrap" }}>
                  {rec.diagnosis || "N/A"}
                </p>
              </div>
              <hr />
              <div className="record-section">
                <h6 className="text-secondary">Treatment</h6>
                <p style={{ whiteSpace: "pre-wrap" }}>
                  {rec.treatment || "N/A"}
                </p>
              </div>
              <div className="record-section">
                <h6 className="text-secondary">follow_up_date</h6>
                <p style={{ whiteSpace: "pre-wrap" }}>
                  {rec.follow_up_date || "No Need for followUp"}
                </p>
              </div>

              {rec.uploadFile && (
                <>
                  <hr />
                  <div className="record-section">
                    <h6 className="text-secondary">Attachment</h6>
                    <a
                      href={`${imgUrl}${rec.uploadFile}`}
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      View File
                    </a>
                  </div>
                </>
              )}
            </div>
          </div>
        ) : (
          <p className="text-muted">No medical record for this appointment.</p>
        )}
        <div className="col-12 mb-4">
          <h6 className="text-dark fw-bold border-bottom pb-1">
            <i className="fas fa-running me-2"></i>Exercise Chart
          </h6>
          {item.exercises && item.exercises.length > 0 ? (
            <div className="table-responsive">
              <table className="table table-bordered table-sm bg-white">
                <thead className="table-light">
                  <tr>
                    <th>Exercise Title</th>
                    <th>Dates</th>
                    <th>Schedule</th>
                    <th>Action</th>
                  </tr>
                </thead>
                <tbody>
                  {item.exercises.map((ex) => {
                    const exerciseName =
                      exerciseList.find((e) => e.id == ex.exercise_id)?.title ||
                      "Exercise";
                    return (
                      <tr key={`ex-view-${ex.id}`}>
                        <td>
                          <strong>{exerciseName}</strong>
                        </td>
                        <td>
                          {ex.start_date} to {ex.end_date}
                        </td>
                        <td>
                          <span className="badge bg-light text-info border">
                            {ex.frequency} ({ex.time_of_day})
                          </span>
                        </td>
                        <td>
                          <button
                            className="btn btn-sm btn-info text-white m-1"
                            title="View Steps"
                            onClick={() =>
                              handleOpenExercisePreview(ex.exercise_id)
                            } // Function wahi hai, state change ho gayi
                          >
                            <i className="fas fa-eye"></i>
                          </button>
                          <button
                            className="btn btn-sm btn-warning text-white m-1"
                            title="Edit"
                            onClick={() => {
                              setAssignmentForm(ex);
                              setIsEditingAssignment(true);
                              setCurrentAssignmentId(ex.id);
                              setCurrentAppointmentId(item.appointmentId);
                              setShowExerciseModal(true);
                            }}
                          >
                            <i className="fas fa-edit"></i>
                          </button>
                          <button
                            className="btn btn-sm btn-danger text-white m-1"
                            title="Delete"
                            onClick={() => handleDeleteAssignment(ex.id)}
                          >
                            <i className="fas fa-trash-alt"></i>
                          </button>
                        </td>
                      </tr>
                    );
                  })}
                </tbody>
              </table>
            </div>
          ) : (
            <p className="text-muted small">
              No exercises assigned for this appointment.
            </p>
          )}
        </div>
        <div className="col-12 mb-4 mt-3">
  <h6 className="text-dark fw-bold border-bottom pb-1" style={{ color: '#ff8c00' }}>
    <i className="fas fa-utensils me-2"></i>Diet Plan / Nutrition Chart
  </h6>
  {item.dietAssignments && item.dietAssignments.length > 0 ? (
    <div className="table-responsive">
      <table className="table table-bordered table-sm bg-white">
        <thead className="table-light">
          <tr>
            <th>Diet Title</th>
            <th>Validity Period</th>
            <th>Status</th>
            <th>Action</th>
          </tr>
        </thead>
        <tbody>
          {item.dietAssignments.map((diet) => (
            <tr key={`diet-view-${diet.id}`}>
              <td>
                {/* Agar multiple plans hain toh comma se join karein */}
                <strong>{diet.assigned_diets?.map(d => d.title).join(", ") || "Diet Plan"}</strong>
              </td>
              <td className="small">{diet.start_date} to {diet.end_date || "Next Advice"}</td>
              <td><span className="badge bg-success-light text-success">{diet.status}</span></td>
              <td>
                <button 
                  className="btn btn-sm btn-info text-white m-1" 
                  onClick={() => { setViewingDietPlan(diet); setShowViewDietModal(true); }}
                >
                  <i className="fas fa-eye"></i>
                </button>
                 <button 
      className="btn btn-sm btn-warning text-white m-1" 
      title="Edit Diet Plan"
      onClick={() => handleEditDietPlan(diet, item.appointmentId)}
    >
      <i className="fas fa-edit"></i>
    </button>
                <button 
                  className="btn btn-sm btn-danger text-white m-1" 
                  onClick={() => handleDeleteDietAssignment(diet.id)}
                >
                  <i className="fas fa-trash-alt"></i>
                </button>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  ) : (
    <p className="text-muted small italic">No diet plan assigned for this appointment.</p>
  )}
</div>
      </div>
    );
  };

  return (
    <>
      <style>
        {`
          .form-control-xs { height: calc(1.5em + 0.25rem + 2px); padding: 0.125rem 0.25rem; font-size: 0.75rem; }
          .form-select-xs { height: calc(1.5em + 0.25rem + 2px); padding: 0.125rem 0.25rem; font-size: 0.75rem; }
          .fade-in { animation: fadeIn 0.3s ease-in; }
          @keyframes fadeIn { from { opacity: 0; } to { opacity: 1; } }
          `}
      </style>

      <div className="content pt-5 mt-5">
        <div className="container-fluid">
          <div className="row">
            <div className="col-md-5 col-lg-4 col-xl-3 no-print">
              <div className="card widget-profile pat-widget-profile">
                <div className="card-body">
                  <div className="pro-widget-content">
                    <div className="profile-info-widget">
                      <a href="#!" className="booking-doc-img">
                        <img
                          src={
                            patient?.uploadPhoto
                              ? `${imgUrl}${patient.uploadPhoto}`
                              : "/assets/img/patients/patient.jpg"
                          }
                          alt="User"
                        />
                      </a>
                      <div className="profile-det-info">
                        <h3>
                          {patient?.firstName} {patient?.lastName}
                        </h3>
                        <div className="patient-details">
                          <h5>
                            <b>Patient ID :</b> {patient?.PatientID}
                          </h5>
                          <h5>
                            <i className="fas fa-map-marker-alt" />{" "}
                            {patient?.city || "Unknown"},{" "}
                            {patient?.country || "Unknown"}
                          </h5>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="patient-info">
                    <ul>
                      <li>
                        Phone <span>{patient?.phoneNumber || "N/A"}</span>
                      </li>
                      <li>
                        DOB <span>{patient?.dateOfBirth || "N/A"}</span>
                      </li>
                      <li>
                        Blood Group <span>{patient?.bloodGrp || "N/A"}</span>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
              <div className="card">
                <div className="card-header">
                  <h4 className="card-title">Doctor Information</h4>
                </div>
                <div className="card-body">
                  {currentDoctor ? (
                    <div className="doctor-widget">
                      <div className="media align-items-center">
                        <div className="me-3">
                          <img
                            className="avatar-lg rounded-circle"
                            src={
                              currentDoctor.uploadPhoto
                                ? `${imgUrl}${currentDoctor.uploadPhoto}`
                                : "/assets/img/doctors/doctor-thumb-02.jpg"
                            }
                            alt="Doctor"
                          />
                        </div>
                        <div className="media-body">
                          <h5 className="mb-0">
                            Dr. {currentDoctor.firstName}{" "}
                            {currentDoctor.lastName}
                          </h5>
                          <p className="text-muted mb-0">
                            {currentDoctor.Specializations?.[0]
                              ?.Specialization || "Specialist"}
                          </p>
                        </div>
                      </div>
                    </div>
                  ) : (
                    <p>Could not load doctor details.</p>
                  )}
                </div>
              </div>
            </div>
            <div className="col-md-7 col-lg-8 col-xl-9">
              <div className="card">
                <div className="card-body pt-0">
                  <div className="user-tabs no-print">
                    <ul className="nav nav-tabs nav-tabs-bottom nav-justified flex-wrap">
                      <li className="nav-item">
                        <a
                          className="nav-link active"
                          data-toggle="tab"
                          href="#overview"
                        >
                          Overview
                        </a>
                      </li>
                      <li className="nav-item">
                        <a
                          className="nav-link"
                          data-toggle="tab"
                          href="#billing"
                        >
                          Billing
                        </a>
                      </li>
                    </ul>
                  </div>
                  <div className="tab-content pt-3">
                    <div id="overview" className="tab-pane fade show active">
                      <div className="card card-table mb-0">
                        <div className="card-body">
                          <div className="table-responsive">
                            <table className="table table-hover table-center mb-0">
                              <thead>
                                <tr>
                                  <th className="text-center">Appt ID</th>{" "}
                                  <th className="text-center">Patient Name</th>
                                  <th className="text-center">Date</th>
                                  <th className="text-center">Appt Status</th>
                                  <th className="text-center">Trans Status</th>
                                  <th className="text-center">Paid Ammount</th>
                                  <th className="text-center">Action</th>
                                </tr>
                              </thead>
                              <tbody>
                                {groupedData.length > 0 ? (
                                  groupedData.map((item) => {
                                    const transactionAmmount = item.invoice
                                      ? item.invoice.TotalAmount
                                      : "N/A";
                                    const transactionStatus = item.invoice
                                      ? item.invoice.Status
                                      : "Not Billed";
                                    const transactionBadge =
                                      getInvoiceBadgeClass(transactionStatus);
                                    const isJoiningThisCall =
                                      isJoining === item.appointmentId; // For spinner logic
                                    const patient_name = item.patiemt_name;
                                    return (
                                      <React.Fragment key={item.appointmentId}>
                                        <tr
                                          className={
                                            expandedRowId === item.appointmentId
                                              ? "table-info"
                                              : ""
                                          }
                                        >
                                          <td className="text-center">
                                            #{item.appointmentId}
                                          </td>
                                          <td className="text-center">
                                            {item.patient_name ||
                                              patient.firstName}
                                          </td>
                                          <td className="text-center">
                                            {new Date(
                                              item.appointmentDate,
                                            ).toLocaleDateString()}
                                            <span className="d-block text-info">
                                              {item.appointmentTime}
                                            </span>
                                          </td>
                                          <td className="text-center">
                                            <span
                                              className={
                                                item.status === "Complete"
                                                  ? "complete-label bg-success"
                                                  : item.status === "Pending"
                                                    ? "pending-label"
                                                    : "failed-label"
                                              }
                                            >
                                              {item.status}
                                            </span>
                                          </td>
                                          <td className="text-center">
                                            <span
                                              className={
                                                transactionStatus === "Paid"
                                                  ? "paid-label"
                                                  : transactionStatus ===
                                                      "Pending"
                                                    ? "pending-label"
                                                    : "failed-label"
                                              }
                                            >
                                              {transactionStatus}
                                            </span>{" "}
                                          </td>
                                          <td className="text-center">
                                            <span>{transactionAmmount}</span>
                                          </td>

                                          <td className="text-center">
                                            {/* Countdown banner above buttons (only before meeting) */}
                                            {(() => {
                                              const now = new Date();
                                              const appointmentDate = new Date(
                                                item.appointmentDate,
                                              );
                                              const [time, modifier] =
                                                item.appointmentTime.split(" ");
                                              let [hours, minutes] =
                                                time.split(":");
                                              hours = parseInt(hours);
                                              minutes = parseInt(minutes || 0);
                                              if (
                                                modifier === "PM" &&
                                                hours < 12
                                              )
                                                hours += 12;
                                              if (
                                                modifier === "AM" &&
                                                hours === 12
                                              )
                                                hours = 0;
                                              appointmentDate.setHours(
                                                hours,
                                                minutes,
                                                0,
                                                0,
                                              );

                                              const durationMinutes =
                                                item.duration || 60;
                                              const appointmentEndTime =
                                                new Date(
                                                  appointmentDate.getTime() +
                                                    durationMinutes * 60000,
                                                );

                                              let meetState = "before";
                                              if (
                                                now >= appointmentDate &&
                                                now <= appointmentEndTime
                                              )
                                                meetState = "during";
                                              else if (now > appointmentEndTime)
                                                meetState = "after";

                                              if (meetState === "before") {
                                                const msRemaining =
                                                  appointmentDate - now;

                                                const daysRemaining =
                                                  Math.floor(
                                                    msRemaining /
                                                      (24 * 60 * 60 * 1000),
                                                  );
                                                const hoursRemaining =
                                                  Math.floor(
                                                    (msRemaining %
                                                      (24 * 60 * 60 * 1000)) /
                                                      (60 * 60 * 1000),
                                                  );
                                                const minutesRemaining =
                                                  Math.floor(
                                                    (msRemaining %
                                                      (60 * 60 * 1000)) /
                                                      (60 * 1000),
                                                  );

                                                let timeLabel = "";
                                                if (daysRemaining > 0)
                                                  timeLabel += `${daysRemaining}d `;
                                                if (hoursRemaining > 0)
                                                  timeLabel += `${hoursRemaining}h `;
                                                timeLabel += `${minutesRemaining}m`;

                                                return (
                                                  <div
                                                    style={{
                                                      marginBottom: "6px",
                                                      fontSize: "0.9rem",
                                                      fontWeight: "600",
                                                      color: "#6c757d",
                                                      textAlign: "center",
                                                    }}
                                                  >
                                                    <small>
                                                      Starts in {timeLabel}
                                                    </small>
                                                  </div>
                                                );
                                              }
                                              return null;
                                            })()}

                                            {/* Buttons in flex row */}
                                            <div className="d-flex align-items-center justify-content-center  gap-1 flex-wrap">
                                              {/* Meeting / Recording Button */}
                                              {(() => {
                                                const now = new Date();
                                                const appointmentDate =
                                                  new Date(
                                                    item.appointmentDate,
                                                  );
                                                const [time, modifier] =
                                                  item.appointmentTime.split(
                                                    " ",
                                                  );
                                                let [hours, minutes] =
                                                  time.split(":");
                                                hours = parseInt(hours);
                                                minutes = parseInt(
                                                  minutes || 0,
                                                );
                                                if (
                                                  modifier === "PM" &&
                                                  hours < 12
                                                )
                                                  hours += 12;
                                                if (
                                                  modifier === "AM" &&
                                                  hours === 12
                                                )
                                                  hours = 0;
                                                appointmentDate.setHours(
                                                  hours,
                                                  minutes,
                                                  0,
                                                  0,
                                                );

                                                const durationMinutes =
                                                  item.duration || 60;
                                                const appointmentEndTime =
                                                  new Date(
                                                    appointmentDate.getTime() +
                                                      durationMinutes * 60000,
                                                  );

                                                let meetState = "before";
                                                if (
                                                  now >= appointmentDate &&
                                                  now <= appointmentEndTime
                                                )
                                                  meetState = "during";
                                                else if (
                                                  now > appointmentEndTime
                                                )
                                                  meetState = "after";

                                                if (meetState === "before") {
                                                  return (
                                                    <button
                                                      className="btn btn-sm rounded-circle d-flex align-items-center justify-content-center"
                                                      style={{
                                                        width: 32,
                                                        height: 32,
                                                        backgroundColor:
                                                          "#adb5bd",
                                                        color: "#fff",
                                                        opacity: 0.5,
                                                        border: "none",
                                                        cursor: "not-allowed",
                                                      }}
                                                      disabled
                                                      title="Meeting not started"
                                                    >
                                                      <i className="fas fa-video-slash" />
                                                    </button>
                                                  );
                                                }
                                                if (meetState === "during") {
                                                  return (
                                                    <button
                                                      className="btn btn-sm rounded-circle d-flex align-items-center justify-content-center"
                                                      style={{
                                                        width: 32,
                                                        height: 32,
                                                        backgroundColor:
                                                          "#28a745",
                                                        color: "#fff",
                                                        margin: 2,
                                                        border: "none",
                                                        cursor: "pointer",
                                                      }}
                                                      title="Join Meeting"
                                                      onClick={() =>
                                                        handleJoinVideo(
                                                          item.appointmentId,
                                                        )
                                                      }
                                                    >
                                                      <i className="fas fa-video" />
                                                    </button>
                                                  );
                                                }
                                                if (meetState === "after") {
                                                  if (
                                                    item.videoSession
                                                      ?.recording_url
                                                  ) {
                                                    return (
                                                      <button
                                                        className="btn btn-sm rounded-circle d-flex align-items-center justify-content-center"
                                                        style={{
                                                          width: 32,
                                                          height: 32,
                                                          backgroundColor:
                                                            "#dc3545",
                                                          color: "#fff",
                                                          margin: 2,
                                                          border: "none",
                                                          cursor: "pointer",
                                                        }}
                                                        title="View Recording"
                                                        onClick={() =>
                                                          setPlayingVideoUrl(
                                                            item.videoSession
                                                              .recording_url,
                                                          )
                                                        }
                                                      >
                                                        <i className="fas fa-play" />
                                                      </button>
                                                    );
                                                  }
                                                  return (
                                                    <button
                                                      className="btn btn-sm  d-flex align-items-center justify-content-center"
                                                      style={{
                                                        width: 32,
                                                        height: 32,
                                                        backgroundColor:
                                                          "#adb5bd",
                                                        color: "#fff",
                                                        opacity: 0.5,
                                                        border: "none",
                                                        cursor: "not-allowed",
                                                      }}
                                                      disabled
                                                      title="No Recording Available"
                                                    >
                                                      <i className="fas fa-play" />
                                                    </button>
                                                  );
                                                }
                                                return null;
                                              })()}

                                              {/* Medical Record Button */}
                                              <button
                                                className={`btn btn-sm d-flex align-items-center justify-content-center ${expandedSection.id === item.appointmentId && expandedSection.type === "record" ? "btn-success" : "btn-success"}`}
                                                title="Medical Record"
                                                onClick={() =>
                                                  toggleSection(
                                                    item.appointmentId,
                                                    "record",
                                                  )
                                                } // Ab ye error nahi dega
                                                style={{
                                                  width: "32px",
                                                  height: "32px",
                                                }}
                                              >
                                                <i className="fas fa-file-medical"></i>
                                              </button>
                                              {/* Prescription Button */}
                                              <button
  className={`btn btn-sm d-flex align-items-center justify-content-center ${expandedSection.id === item.appointmentId && expandedSection.type === "prescription" ? "btn-info" : "btn-info"}`}
  title="Prescriptions"
  onClick={() => toggleSection(item.appointmentId, "prescription")}
  style={{ width: "32px", height: "32px", }}
>
  <i className="fas fa-stethoscope"></i>
</button>
                                              {/* NEW: Exercise Assignment Button */}
                                              <button
                                                className="btn btn-sm d-flex align-items-center justify-content-center ml-1"
                                                title="Manage Exercises"
                                                onClick={() =>
                                                  toggleExerciseExpansion(
                                                    item.appointmentId,
                                                  )
                                                } // Expansion trigger
                                                style={{
                                                  width: "32px",
                                                  height: "32px",
                                                  padding: "0",
                                                  backgroundColor: "#6f42c1",
                                                  borderColor: "#6f42c1",
                                                  color: "white",
                                                }}
                                              >
                                                <i
                                                  className="fas fa-running"
                                                  style={{ fontSize: "0.8rem" }}
                                                ></i>
                                              </button>
                                              <button
  className="btn btn-sm d-flex align-items-center justify-content-center ml-1"
  title="Manage Diet"
  onClick={() => toggleDietExpansion(item.appointmentId)}
  style={{
    width: "32px",
    height: "32px",
    backgroundColor: "#ff8c00", // Orange color to distinguish from purple exercise
    borderColor: "#ff8c00",
    color: "white",
  }}
>
  <i className="fas fa-utensils" style={{ fontSize: "0.8rem" }}></i>
</button>
                                              {/* Complete Appointment Button */}
                                              {/* <button
                                                className={`btn btn-sm  d-flex align-items-center justify-content-center ${item.status === "Complete" ? "btn-secondary" : "btn-warning"}`}
                                                title={
                                                  item.status === "Complete"
                                                    ? "Appointment Completed"
                                                    : "Mark as Complete"
                                                }
                                                disabled={
                                                  item.status === "Complete" ||
                                                  !!updatingApptId
                                                }
                                                onClick={() =>
                                                  handleUpdateAppointmentStatus(
                                                    item.appointmentId,
                                                    "Complete",
                                                  )
                                                }
                                                style={{
                                                  width: "32px",
                                                  height: "32px",
                                                  padding: "0",
                                                  transition: "all 0.2s ease",
                                                }}
                                              >
                                                {updatingApptId ===
                                                item.appointmentId ? (
                                                  <span
                                                    className="spinner-border spinner-border-sm"
                                                    style={{
                                                      width: "0.8rem",
                                                      height: "0.8rem",
                                                    }}
                                                  ></span>
                                                ) : (
                                                  <i
                                                    className="fas fa-check-double"
                                                    style={{
                                                      fontSize: "0.8rem",
                                                    }}
                                                  ></i>
                                                )}
                                              </button> */}
                                              {/* Complete Appointment Button */}
<button
  className={`btn btn-sm d-flex align-items-center justify-content-center ${
    item.status === "Complete" ? "btn-secondary" : "btn-warning"
  }`}
  title={
    item.status === "Complete"
      ? "Appointment Completed"
      : "Mark as Complete"
  }
  disabled={
    item.status === "Complete" ||
    !!updatingApptId // This will be true during API and SMS calls
  }
  onClick={() =>
    handleUpdateAppointmentStatus(item.appointmentId, "Complete")
  }
  style={{
    width: "32px",
    height: "32px",
    padding: "0",
    transition: "all 0.2s ease",
  }}
>
  {updatingApptId === item.appointmentId ? (
    <span
      className="spinner-border spinner-border-sm"
      style={{
        width: "0.8rem",
        height: "0.8rem",
      }}
    ></span>
  ) : (
    <i
      className="fas fa-check-double"
      style={{
        fontSize: "0.8rem",
      }}
    ></i>
  )}
</button>

                                              {/* View Details Button */}
                                              <button
                                                className="btn btn-sm btn-info d-flex align-items-center justify-content-center"
                                                title={
                                                  expandedRowId ===
                                                  item.appointmentId
                                                    ? "Hide Details"
                                                    : "View Details"
                                                }
                                                onClick={() =>
                                                  toggleRowExpansion(
                                                    item.appointmentId,
                                                  )
                                                }
                                                style={{
                                                  width: "32px",
                                                  height: "32px",
                                                  padding: "0",
                                                  transition: "all 0.2s ease",
                                                }}
                                              >
                                                <i
                                                  className={`far ${expandedRowId === item.appointmentId ? "fa-eye-slash" : "fa-eye"}`}
                                                  style={{ fontSize: "0.8rem" }}
                                                ></i>
                                              </button>
                                            </div>
                                          </td>
                                        </tr>
                                        {expandedSection.id ===
                                          item.appointmentId && (
                                          <tr>
                                            <td
                                              colSpan="7"
                                              className="p-0 border-0"
                                            >
                                              {/* 1. Summary View */}
                                                                                     {expandedRowId === item.appointmentId && (<tr><td colSpan="7" className="p-0">{renderAppointmentDetails(item)}</td></tr>)}

                                                   {/* NAYA: Prescription Case */}
      {expandedSection.type === "prescription" && renderPrescriptionSection(item)}
                                              {/* 3. Medical Record View */}
                                              {expandedSection.type ===
                                                "record" &&
                                                renderMedicalRecordSection(
                                                  item,
                                                )}
                                            </td>
                                          </tr>
                                        )}
                                        {/* Diet Details Block */}
{expandedDietRowId === item.appointmentId && (
  <tr className="fade-in">
    <td colSpan="7" className="p-0 border-0">
      {renderDietDetails(item)}
    </td>
  </tr>
)}
                                        {/* --- Dusra Block: Jo aapne abhi manga (Exercise Details ke liye) --- */}
                                        {expandedExerciseRowId ===
                                          item.appointmentId && (
                                          <tr className="fade-in">
                                            <td
                                              colSpan="7"
                                              className="p-0 border-0"
                                            >
                                              {renderExerciseDetails(item)}
                                            </td>
                                          </tr>
                                        )}

                                {expandedRowId === item.appointmentId && (<tr><td colSpan="7" className="p-0">{renderAppointmentDetails(item)}</td></tr>)}
                              {/* {expandedExerciseRowId === item.appointmentId && (
                                <tr className="fade-in">
                                  <td colSpan="7" className="p-0 border-0">
                                    {renderExerciseDetails(item)}
                                  </td>
                                </tr>
                              )} */}
                                      </React.Fragment>
                                    );
                                  })
                                ) : (
                                  <tr>
                                    <td
                                      colSpan="6"
                                      className="text-center text-muted"
                                    >
                                      No appointments found.
                                    </td>
                                  </tr>
                                )}
                              </tbody>
                            </table>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div id="billing" className="tab-pane fade">
                      <div className="card card-table mb-0">
                        <div className="card-body">
                          <div className="table-responsive">
                            <table className="table table-hover table-center mb-0">
                              <thead>
                                <tr>
                                  <th>Invoice ID</th>
                                  <th>Appointment ID</th>
                                  <th>Date</th>
                                  <th>Amount</th>
                                  <th className="text-center">Status</th>
                                  <th className="text-right">Action</th>
                                </tr>
                              </thead>
                              <tbody>
                                {patientInvoices.length > 0 ? (
                                  patientInvoices.map((invoice) => (
                                    <tr key={invoice.id}>
                                      <td>INV-{invoice.id}</td>
                                      <td>APT-{invoice.appointmentId}</td>
                                      <td>
                                        {new Date(
                                          invoice.date,
                                        ).toLocaleDateString("en-GB")}
                                      </td>
                                      <td>₹{invoice.TotalAmount}</td>

                                      <td className="text-center">
                                        <span
                                          className={
                                            invoice.Status === "Paid"
                                              ? "paid-label"
                                              : invoice.Status === "Pending"
                                                ? "pending-label"
                                                : invoice.Status === "Failed"
                                                  ? "failed-label"
                                                  : ""
                                          }
                                        >
                                          {invoice.Status}
                                        </span>
                                      </td>
                                      <td className="text-right">
                                        <div className="table-action">
                                          <button
                                            className="i-btn-view"
                                            title="Invoice Report"
                                            onClick={() =>
                                              handleOpenInvoicePdf(invoice)
                                            }
                                          >
                                            {" "}
                                          </button>
                                        </div>
                                      </td>
                                    </tr>
                                  ))
                                ) : (
                                  <tr>
                                    <td
                                      colSpan="6"
                                      className="text-center text-muted"
                                    >
                                      No invoices found.
                                    </td>
                                  </tr>
                                )}
                              </tbody>
                            </table>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* --- PDF Viewer Modals --- */}
        {showInvoicePdfModal && viewingInvoice && (
          <div
            className="modal show d-block"
            style={{ backgroundColor: "rgba(0,0,0,0.5)", zIndex: 1060 }}
          >
            <div className="modal-dialog modal-dialog-centered modal-xl">
              <div className="modal-content">
                <div className="modal-header bg-info text-white no-print">
                  <h5 className="modal-title">Invoice Report</h5>
                  <button
                    type="button"
                    className="btn-close btn-close-white"
                    onClick={() => setShowInvoicePdfModal(false)}
                  ></button>
                </div>
                <div className="modal-body" style={{ height: "80vh" }}>
                  <PDFViewer width="100%" height="100%">
                    <InvoicePDF
                      invoice={viewingInvoice}
                      patient={patient}
                      doctor={currentDoctor}
                      settings={viewingInvoice.settings}
                    />
                  </PDFViewer>
                </div>
              </div>
            </div>
          </div>
        )}
        {showPrescriptionPdfModal && pdfData.prescriptions.length > 0 && (
          <div
            className="modal show d-block"
            style={{ backgroundColor: "rgba(0,0,0,0.5)", zIndex: 1060 }}
          >
            <div className="modal-dialog modal-dialog-centered modal-xl">
              <div className="modal-content">
                <div className="modal-header no-print">
                  <h5 className="modal-title">Prescription Report</h5>
                  <button
                    type="button"
                    className="btn-close"
                    onClick={() => setShowPrescriptionPdfModal(false)}
                  ></button>
                </div>
                <div className="modal-body" style={{ height: "80vh" }}>
                  <PDFViewer width="100%" height="100%">
                    <PrescriptionPDF
                      prescriptions={pdfData.prescriptions}
                      patient={patient}
                      doctor={currentDoctor}
                      appointmentId={pdfData.appointmentId}
                      settings={pdfData.settings}
                    />
                  </PDFViewer>
                </div>
              </div>
            </div>
          </div>
        )}
        {showMedicalRecordPdfModal && pdfData.record && (
          <div
            className="modal show d-block"
            style={{ backgroundColor: "rgba(0,0,0,0.5)", zIndex: 1060 }}
          >
            <div className="modal-dialog modal-dialog-centered modal-xl">
              <div className="modal-content">
                <div className="modal-header no-print  bg-info text-white">
                  <h5 className="modal-title">Medical Record Report</h5>
                  <button
                    type="button"
                    className="btn-close btn-close-white"
                    onClick={() => setShowMedicalRecordPdfModal(false)}
                  ></button>
                </div>
                <div className="modal-body" style={{ height: "80vh" }}>
                  <PDFViewer width="100%" height="100%">
                    <MedicalRecordPDF
                      record={pdfData.record}
                      patient={patient}
                      doctor={currentDoctor}
                      settings={pdfData.settings}
                    />
                  </PDFViewer>
                </div>
              </div>
            </div>
          </div>
        )}
     {/* --- EXERCISE PDF VIEWER MODAL --- */}
{showExercisePdfModal && pdfData.exercises && (
  <div className="modal show d-block" style={{ backgroundColor: "rgba(0,0,0,0.5)", zIndex: 1060 }}>
    <div className="modal-dialog modal-dialog-centered modal-xl">
      <div className="modal-content">
        <div className="modal-header bg-primary text-white">
          <h5 className="modal-title">Exercise Chart Report</h5>
          <button type="button" className="btn-close btn-close-white" onClick={() => setShowExercisePdfModal(false)}></button>
        </div>
        <div className="modal-body" style={{ height: "80vh" }}>
          {/* Force Refresh using key={new Date().getTime()} */}
          <PDFViewer width="100%" height="100%" key={new Date().getTime()}> 
            <ExerciseChartPDF
              exercises={pdfData.exercises}
              patient={patient}
              doctor={currentDoctor}
              appointmentId={pdfData.appointmentId}
              settings={pdfData.settings}
            />
          </PDFViewer>
        </div>
      </div>
    </div>
  </div>
)}
        
        {/* --- Add & Edit Modals --- */}
        
        {editModalOpen && editingPrescription && (
  <div className="modal show d-block bg-opacity-50" style={{ zIndex: 1057, backgroundColor: 'rgba(0,0,0,0.5)' }}>
    <div className="modal-dialog modal-lg modal-dialog-centered">
      <div className="modal-content border-0 shadow-lg">
        {/* Modal Header */}
        <div className="modal-header bg-info text-white">
          <h5 className="modal-title">
            {editingPrescription.viewOnly ? "Prescription Details " : `Edit Medicine #${editingPrescription.id}`}
          </h5>
          <button type="button" className="btn-close btn-close-white" onClick={() => setEditModalOpen(false)}></button>
        </div>

        <div className="modal-body p-4">
          {editingPrescription.viewOnly ? (
            /* --- VIEW ONLY FORMAT: Table of Medicines --- */
            <div className="table-responsive rounded">
              <table className="table table-hover table-bordered align-middle">
                <thead className="table-secondary small text-uppercase">
                  <tr>
                    <th>Medicine Name</th>
                    <th>Quantity/Freq</th>
                    <th>Duration</th>
                    <th>Timing</th>
                  </tr>
                </thead>
                <tbody>
                  {/* Agar aap ek appointment ki sari medicines dikhana chahte hain */}
                  {editingPrescription.allMedicines ? (
                    editingPrescription.allMedicines.map((med, idx) => (
                      <tr key={idx}>
                        <td className="fw-bold">{med.name}</td>
                        <td>{med.quantity}</td>
                        <td>{med.days} Days</td>
                        <td>
                          {med.time && med.time.split(',').map((t, i) => (
                            <span key={i} className="badge bg-light text-info border me-1">{t.trim()}</span>
                          ))}
                        </td>
                      </tr>
                    ))
                  ) : (
                    /* Default single view if allMedicines is not passed */
                    <tr>
                      <td className="fw-bold">{editingPrescription.name}</td>
                      <td>{editingPrescription.quantity}</td>
                      <td>{editingPrescription.days} Days</td>
                      <td>
                        {editingPrescription.time?.map((t, i) => (
                          <span key={i} className="badge bg-light text-info border me-1">{t}</span>
                        ))}
                      </td>
                    </tr>
                  )}
                </tbody>
              </table>
            </div>
          ) : (
            /* --- EDIT FORMAT: Original Form --- */
            <div className="row">
              <div className="col-12 col-md-6 form-group">
                <label className="fw-bold">Medicine Name</label>
                <input type="text" className="form-control" value={editingPrescription.name} onChange={(e) => handleEditFormChange("name", e.target.value)} />
              </div>
              <div className="col-12 col-md-6 form-group">
                <label className="fw-bold">Quantity</label>
                <input type="text" className="form-control" value={editingPrescription.quantity} onChange={(e) => handleEditFormChange("quantity", e.target.value)} />
              </div>
              <div className="col-12 col-md-6 form-group">
                <label className="fw-bold">Days</label>
                <input type="text" className="form-control" value={editingPrescription.days} onChange={(e) => handleEditFormChange("days", e.target.value)} />
              </div>
              <div className="col-12 form-group">
                <label className="fw-bold d-block">Time</label>
                {["Morning", "Afternoon", "Evening", "Night"].map((time) => (
                  <div key={time} className="form-check form-check-inline">
                    <input className="form-check-input" type="checkbox" id={`edit-time-${time}`} checked={editingPrescription.time.includes(time)} onChange={() => handleEditTimeToggle(time)} />
                    <label className="form-check-label" htmlFor={`edit-time-${time}`}>{time}</label>
                  </div>
                ))}
              </div>
            </div>
          )}

          {/* Signature Section (View Only mein upload hide rahega) */}
          <div className="mt-4 border-top pt-3">
            {!editingPrescription.viewOnly && (
              <div className="form-group">
                <label className="form-label fw-bold text-primary">Update Signature (Optional)</label>
                <input type="file" accept="image/*" className="form-control form-control-sm" onChange={(e) => setEditSignature(e.target.files[0])} />
              </div>
            )}
            
            <div className="d-flex justify-content-between align-items-end mt-2">
              <div>
                <label className="small text-muted d-block">Authorized Signature</label>
                {editSignature ? (
                  <img src={URL.createObjectURL(editSignature)} alt="New" style={{ height: 50 }} className="border rounded p-1" />
                ) : editingPrescription.signature ? (
                  <img src={`${imgUrl}${editingPrescription.signature}`} alt="Current" style={{ height: 50 }} className="border rounded p-1 bg-white" />
                ) : <span className="text-muted small italic">No signature available</span>}
              </div>
              <div className="text-end">
            <p className="mt-2 mb-0 fw-bold">
                                      Dr. {currentDoctor?.firstName}{" "}
                                      {currentDoctor?.lastName}
                                    </p>              
                                       <span className="small text-muted">
                          Authorized Medical Professional
                        </span>
              </div>
            </div>
          </div>
        </div>

        <div className="modal-footer bg-light">
          <button type="button" className="btn btn-secondary rounded-pill px-4" onClick={() => setEditModalOpen(false)}>
            {editingPrescription.viewOnly ? "Close" : "Cancel"}
          </button>
          {!editingPrescription.viewOnly && (
            <button type="button" className="btn btn-info rounded-pill px-4 text-white shadow-sm" disabled={isSaving} onClick={handleUpdatePrescription}>
              {isSaving ? "Saving..." : "Save Changes"}
            </button>
          )}
        </div>
      </div>
    </div>
  </div>
)}
        {showMedicalRecordModal && (
          <div
            className="modal show d-block"
            style={{ backgroundColor: "rgba(0,0,0,0.5)", zIndex: 1056 }}
          >
            <div className="modal-dialog modal-dialog-centered modal-lg modal-dialog-scrollable">
              <div className="modal-content">
                <div className="modal-header bg-info text-white ">
                  <h5 className="modal-title">
                    Add Medical Record for Appt #{currentAppointmentId}
                  </h5>
                  <button
                    type="button"
                    className="btn-close btn-close-white"
                    onClick={() => setShowMedicalRecordModal(false)}
                  ></button>
                </div>

                <div className="modal-body">
                  {/* Date Section */}
                  <div className="row">
                    <div className="col-12 col-md-6">
                      <div className="form-group">
                        <label htmlFor="date">Date</label>
                        <input
                          type="date"
                          id="date"
                          name="date"
                          className="form-control"
                          value={newRecordData.date}
                          onChange={handleRecordInputChange}
                        />
                      </div>
                    </div>
                    <div className="col-12 col-md-6">
                      <div className="form-group">
                        <label htmlFor="follow_up_date">Follow-up Date</label>
                        <input
                          type="date"
                          id="follow_up_date"
                          name="follow_up_date"
                          className="form-control"
                          value={newRecordData.follow_up_date}
                          onChange={handleRecordInputChange}
                          min={
                            newRecordData.date ||
                            new Date().toISOString().split("T")[0]
                          }
                        />
                        <div className="form-text text-muted small">
                          Optional: Set a follow-up appointment date
                        </div>
                      </div>
                    </div>
                  </div>

                  <hr />

                  {/* Vitals Section */}
                  <label className="mb-2 fw-bold">Vitals</label>
                  <div className="row">
                    <div className="col-md-4 col-sm-6">
                      <div className="form-group">
                        <label htmlFor="BP" className="small">
                          Blood Pressure
                        </label>
                        <input
                          type="text"
                          id="BP"
                          name="BP"
                          className="form-control form-control-sm"
                          placeholder="e.g., 120/80"
                          value={newRecordData.BP}
                          onChange={handleRecordInputChange}
                        />
                      </div>
                    </div>
                    <div className="col-md-4 col-sm-6">
                      <div className="form-group">
                        <label htmlFor="heartRate" className="small">
                          Heart Rate (BPM)
                        </label>
                        <input
                          type="text"
                          id="heartRate"
                          name="heartRate"
                          className="form-control form-control-sm"
                          placeholder="e.g., 72"
                          value={newRecordData.heartRate}
                          onChange={handleRecordInputChange}
                        />
                      </div>
                    </div>
                    <div className="col-md-4 col-sm-6">
                      <div className="form-group">
                        <label htmlFor="SPO" className="small">
                          SPO (%)
                        </label>
                        <input
                          type="text"
                          id="SPO"
                          name="SPO"
                          className="form-control form-control-sm"
                          placeholder="e.g., 98"
                          value={newRecordData.SPO}
                          onChange={handleRecordInputChange}
                        />
                      </div>
                    </div>
                    <div className="col-md-4 col-sm-6">
                      <div className="form-group">
                        <label htmlFor="sugar" className="small">
                          Blood Sugar
                        </label>
                        <input
                          type="text"
                          id="sugar"
                          name="sugar"
                          className="form-control form-control-sm"
                          placeholder="e.g., 100 mg/dL"
                          value={newRecordData.sugar}
                          onChange={handleRecordInputChange}
                        />
                      </div>
                    </div>
                    <div className="col-md-4 col-sm-6">
                      <div className="form-group">
                        <label htmlFor="height" className="small">
                          Height
                        </label>
                        <input
                          type="text"
                          id="height"
                          name="height"
                          className="form-control form-control-sm"
                          placeholder="e.g., 175 cm"
                          value={newRecordData.height}
                          onChange={handleRecordInputChange}
                        />
                      </div>
                    </div>
                    <div className="col-md-4 col-sm-6">
                      <div className="form-group">
                        <label htmlFor="weight" className="small">
                          Weight
                        </label>
                        <input
                          type="text"
                          id="weight"
                          name="weight"
                          className="form-control form-control-sm"
                          placeholder="e.g., 70 kg"
                          value={newRecordData.weight}
                          onChange={handleRecordInputChange}
                        />
                      </div>
                    </div>
                  </div>

                  <hr />

                  {/* Diagnosis, Treatment and File Upload Section */}
                  <div className="row">
                    <div className="col-12">
                      <div className="form-group">
                        <label htmlFor="diagnosis">Diagnosis</label>
                        <textarea
                          id="diagnosis"
                          name="diagnosis"
                          rows="3"
                          className="form-control"
                          value={newRecordData.diagnosis}
                          onChange={handleRecordInputChange}
                        ></textarea>
                      </div>
                    </div>
                    <div className="col-12">
                      <div className="form-group">
                        <label htmlFor="treatment">Treatment</label>
                        <textarea
                          id="treatment"
                          name="treatment"
                          rows="3"
                          className="form-control"
                          value={newRecordData.treatment}
                          onChange={handleRecordInputChange}
                        ></textarea>
                      </div>
                    </div>
                    <div className="col-12">
                      <div className="form-group mb-0">
                        <label htmlFor="uploadFile">
                          Upload File (Optional)
                        </label>
                        <input
                          type="file"
                          id="uploadFile"
                          name="uploadFile"
                          className="form-control"
                          onChange={(e) => setNewRecordFile(e.target.files[0])}
                        />
                        {newRecordFile && (
                          <p className="text-muted mt-1 small">
                            Selected: {newRecordFile.name}
                          </p>
                        )}
                      </div>
                    </div>
                  </div>
                </div>

                <div className="modal-footer">
                  <button
                    type="button"
                    className="btn btn-secondary rounded-pill"
                    disabled={isSaving}
                    onClick={() => setShowMedicalRecordModal(false)}
                  >
                    Cancel
                  </button>
                  <button
                    type="button"
                    className="btn btn-info rounded-pill"
                    disabled={isSaving}
                    onClick={handleSaveMedicalRecord}
                  >
                    {isSaving ? (
                      <>
                        <span
                          className="spinner-border spinner-border-sm"
                          role="status"
                          aria-hidden="true"
                        ></span>
                        Saving...
                      </>
                    ) : (
                      "Save Record"
                    )}
                  </button>
                </div>
              </div>
            </div>
          </div>
        )}
        {showEditMedicalRecordModal && viewingRecord && (
          <div
            className="modal show d-block"
            style={{ backgroundColor: "rgba(0,0,0,0.5)", zIndex: 1056 }}
          >
            <div className="modal-dialog modal-dialog-centered modal-lg modal-dialog-scrollable">
              <div className="modal-content border-0 shadow">
                <div className="modal-header bg-info btn-close-white ">
                  <h5 className="modal-title">
                    Medical Record Details #{viewingRecord.id}
                  </h5>
                  <button
                    type="button"
                    className="btn-close"
                    onClick={() => setShowEditMedicalRecordModal(false)}
                  ></button>
                </div>

                <div className="modal-body">
                  <div className="row">
                    <div className="col-12 col-md-6">
                      <div className="form-group">
                        <label className="fw-bold small text-muted">Date</label>
                        <input
                          type="date"
                          className="form-control bg-white"
                          value={
                            viewingRecord.date
                              ? viewingRecord.date.split("T")[0]
                              : ""
                          }
                          readOnly
                        />
                      </div>
                    </div>
                    <div className="col-12 col-md-6">
                      <div className="form-group">
                        <label className="fw-bold small text-muted">
                          Follow-up Date
                        </label>
                        <input
                          type="date"
                          className="form-control bg-white"
                          value={
                            viewingRecord.follow_up_date
                              ? viewingRecord.follow_up_date.split("T")[0]
                              : ""
                          }
                          readOnly
                        />
                      </div>
                    </div>
                  </div>

                  <hr />

                  <label className="mb-2 fw-bold">Vitals</label>
                  <div className="row g-3">
                    {[
                      { label: "Blood Pressure", value: viewingRecord.BP },
                      {
                        label: "Heart Rate (BPM)",
                        value: viewingRecord.heartRate,
                      },
                      { label: "SPO (%)", value: viewingRecord.SPO },
                      { label: "Blood Sugar", value: viewingRecord.sugar },
                      { label: "Height (cm)", value: viewingRecord.height },
                      { label: "Weight (kg)", value: viewingRecord.weight },
                    ].map((vital, idx) => (
                      <div className="col-md-4 col-6" key={idx}>
                        <div className="form-group">
                          <label className="small text-muted">
                            {vital.label}
                          </label>
                          <input
                            type="text"
                            className="form-control form-control-sm bg-white"
                            value={vital.value || "N/A"}
                            readOnly
                          />
                        </div>
                      </div>
                    ))}
                  </div>

                  <hr />

                  <div className="row">
                    <div className="col-12 mb-3">
                      <div className="form-group">
                        <label className="fw-bold small text-muted">
                          Diagnosis
                        </label>
                        <textarea
                          rows="3"
                          className="form-control bg-white"
                          value={
                            viewingRecord.diagnosis || "No diagnosis recorded."
                          }
                          readOnly
                        ></textarea>
                      </div>
                    </div>
                    <div className="col-12 mb-3">
                      <div className="form-group">
                        <label className="fw-bold small text-muted">
                          Treatment
                        </label>
                        <textarea
                          rows="3"
                          className="form-control bg-white"
                          value={
                            viewingRecord.treatment || "No treatment recorded."
                          }
                          readOnly
                        ></textarea>
                      </div>
                    </div>
                  </div>

                  <div className="row mt-4">
                    <div className="col-md-6 offset-md-6 text-center">
                      <div className="d-flex flex-column align-items-center">
                        <label className="small fw-bold text-muted mb-2">
                          Doctor's Signature / Attachment
                        </label>
                        <div
                          style={{
                            width: "180px",
                            height: "150px",
                            border: "1px solid #ddd",
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                            padding: "5px",
                            backgroundColor: "#f9f9f9",
                            borderRadius: "8px",
                          }}
                        >
                          {viewingRecord.uploadFile ? (
                            <img
                              src={`${imgUrl}${viewingRecord.uploadFile}`}
                              alt="Record Attachment"
                              style={{
                                maxWidth: "100%",
                                maxHeight: "100%",
                                objectFit: "contain",
                              }}
                            />
                          ) : (
                            <span className="text-muted small">
                              No Image Attached
                            </span>
                          )}
                        </div>
                        <p className="mt-2 mb-0 fw-bold">
                          Dr. {currentDoctor?.firstName}{" "}
                          {currentDoctor?.lastName}
                        </p>
                        <span className="small text-muted">
                          Authorized Medical Professional
                        </span>
                      </div>
                    </div>
                  </div>
                </div>

                <div className="modal-footer bg-white">
                  <button
                    type="button"
                    className="btn btn-secondary rounded-pill px-4"
                    onClick={() => setShowEditMedicalRecordModal(false)}
                  >
                    Close
                  </button>
                </div>
              </div>
            </div>
          </div>
        )}
  
{showExerciseModal && (
  <div className="modal show d-block" style={{ backgroundColor: "rgba(0,0,0,0.7)", zIndex: 1056 }}>
    <div className="modal-dialog modal-xl modal-dialog-centered">
      <div className="modal-content border-0 shadow-lg" style={{ borderRadius: '15px', overflow: 'hidden' }}>
        
        {/* --- MODAL HEADER --- */}
        <div className="modal-header border-0 bg-info text-white p-4">
          <div className="d-flex align-items-center">
            <div className="bg-white text-info rounded-circle d-flex align-items-center justify-content-center me-3" style={{ width: '45px', height: '45px' }}>
              <i className="fas fa-file-medical-alt fa-lg"></i>
            </div>
            <div>
              <h5 className="modal-title fw-bold mb-0" style={{ fontSize: '1.4rem' }}>Design Rehab Plan</h5>
              <small className="opacity-75">Assign individual exercises or medical templates</small>
            </div>
          </div>
          <button type="button" className="btn-close btn-close-white shadow-none" onClick={() => setShowExerciseModal(false)}></button>
        </div>

        {/* --- MODAL BODY --- */}
        <div className="modal-body p-0" style={{ backgroundColor: "#f4f7f6" }}>
          
          {/* STICKY TOP: NAVIGATION & SEARCH */}
          <div className="sticky-top bg-white shadow-sm px-4 py-3" style={{ zIndex: 1020 }}>
            <div className="row align-items-center">
              <div className="col-md-6">
                <div className="nav nav-pills gap-2">
                  <button 
                    className={`nav-link rounded-pill px-4 fw-bold d-flex align-items-center ${assignmentMode === 'individual' ? 'active bg-info shadow-sm' : 'text-secondary bg-light border'}`}
                    onClick={() => setAssignmentMode('individual')}
                  >
                    <i className="fas fa-dumbbell me-2"></i> Individual
                  </button>
                  <button 
                    className={`nav-link rounded-pill px-4 fw-bold d-flex align-items-center ${assignmentMode === 'template' ? 'active bg-info shadow-sm' : 'text-secondary bg-light border'}`}
                    onClick={() => setAssignmentMode('template')}
                  >
                    <i className="fas fa-layer-group me-2"></i> Templates
                  </button>
                </div>
              </div>
              <div className="col-md-6 text-end">
                <div className="input-group">
                  <span className="input-group-text bg-light border-end-0 text-muted rounded-start-pill">
                    <i className="fas fa-search"></i>
                  </span>
                  <input
                    type="text"
                    className="form-control bg-light border-start-0 rounded-end-pill shadow-none"
                    placeholder="Search by name or category..."
                    value={exerciseSearchTerm}
                    onChange={(e) => setExerciseSearchTerm(e.target.value)}
                  />
                </div>
              </div>
            </div>
          </div>

          <div style={{ maxHeight: "60vh", overflowY: "auto", padding: "25px" }} className="hide-scrollbar">
            
            {/* --- TAB 1: INDIVIDUAL EXERCISES --- */}
            {assignmentMode === "individual" && (
              <div className="table-responsive rounded-4 shadow-sm border-0 bg-white overflow-hidden">
                <table className="table table-hover align-middle mb-0">
                  <thead className="bg-light">
                    <tr style={{ height: '50px' }}>
                      <th width="50" className="ps-4">
                        <div className="form-check m-0">
                          <input type="checkbox" className="form-check-input" checked={isAllVisibleSelected} onChange={handleSelectAll} style={{ width: '1.2rem', height: '1.2rem' }} />
                        </div>
                      </th>
                      <th className="text-uppercase small fw-bold text-muted">Exercise Detail</th>
                      <th className="text-uppercase small fw-bold text-muted">Duration (Start - End)</th>
                      <th className="text-uppercase small fw-bold text-muted">Schedule</th>
                      <th className="text-center text-uppercase small fw-bold text-muted">Action</th>
                    </tr>
                  </thead>
                  <tbody>
                    {filteredExercises.map((ex) => {
                      const settings = individualSettings[ex.id] || {};
                      const isSelected = selectedExerciseIds.includes(ex.id);
                      return (
                        <tr key={ex.id} className={isSelected ? "table-light border-start border-info border-3" : ""}>
                          <td className="ps-4">
                            <div className="form-check">
                              <input type="checkbox" className="form-check-input" checked={isSelected}
                                onChange={() => {
                                  const newIds = isSelected ? selectedExerciseIds.filter(id => id !== ex.id) : [...selectedExerciseIds, ex.id];
                                  setSelectedExerciseIds(newIds);
                                }}
                                style={{ width: '1.1rem', height: '1.1rem' }}
                              />
                            </div>
                          </td>
                          <td>
                            <div className="fw-bold text-dark mb-0">{ex.title}</div>
                            <span className="badge bg-info-light text-info rounded-pill px-2" style={{fontSize: '10px'}}>{ex.exercise_type || 'General'}</span>
                          </td>
                          <td>
                            <div className="d-flex align-items-center gap-2">
                              <input type="date" className="form-control form-control-sm border-0 bg-light rounded" value={settings.start_date || new Date().toISOString().split("T")[0]}
                                onChange={(e) => handleSettingChange(ex.id, "start_date", e.target.value)} style={{fontSize: '12px'}} />
                              <span className="text-muted">→</span>
                              <input type="date" className="form-control form-control-sm border-0 bg-light rounded" value={settings.end_date || ""}
                                onChange={(e) => handleSettingChange(ex.id, "end_date", e.target.value)} style={{fontSize: '12px'}} />
                            </div>
                          </td>
                          <td>
                            <div className="d-flex gap-1">
                              <select className="form-select form-select-sm border-0 bg-light rounded" style={{fontSize: '12px'}} value={settings.frequency || "Daily"}
                                onChange={(e) => handleSettingChange(ex.id, "frequency", e.target.value)}>
                                <option value="Daily">Daily</option>
                                <option value="Twice">2x Daily</option>
                              </select>
                              <select className="form-select form-select-sm border-0 bg-light rounded" style={{fontSize: '12px'}} value={settings.time_of_day || "Morning"}
                                onChange={(e) => handleSettingChange(ex.id, "time_of_day", e.target.value)}>
                                <option value="Morning">Morning</option>
                                <option value="Evening">Evening</option>
                              </select>
                            </div>
                          </td>
                          <td className="text-center">
                            <button className="btn btn-sm btn-info text-white rounded-circle shadow-sm" onClick={() => handleOpenExercisePreview(ex.id)}>
                              <i className="fas fa-eye small"></i>
                            </button>
                          </td>
                        </tr>
                      );
                    })}
                  </tbody>
                </table>
              </div>
            )}

            {/* --- TAB 2: TEMPLATE CARDS --- */}
            {assignmentMode === "template" && (
              <div className="row row-cols-1 row-cols-md-2 g-4">
                {templates?.map((temp) => {
                  const isTemplateSelected = selectedTemplateIds.includes(temp.id);
                  return (
                    <div className="col" key={temp.id}>
                      <div className={`card h-100 border-0 shadow-sm transition-all rounded-4 overflow-hidden ${isTemplateSelected ? 'ring-active' : ''}`} 
                        style={{ border: isTemplateSelected ? '2px solid #0dcaf0' : '2px solid transparent' }}>
                        
                        <div className={`card-header p-3 border-0 d-flex justify-content-between align-items-center ${isTemplateSelected ? 'bg-info text-white' : 'bg-white'}`}>
                          <div className="form-check d-flex align-items-center mb-0">
                            <input 
                              type="checkbox" 
                              className="form-check-input" 
                              style={{ width: '1.2rem', height: '1.2rem' }}
                              checked={isTemplateSelected}
                              onChange={() => handleSelectTemplate(temp)}
                            />
                            <label className="fw-bold ms-3 mb-0" style={{ fontSize: '1rem' }}>{temp.template_name}</label>
                          </div>
                          <span className={`badge rounded-pill ${isTemplateSelected ? 'bg-white text-info' : 'bg-light text-muted border'}`}>{temp.exercises?.length || 0} Steps</span>
                        </div>

                        {isTemplateSelected ? (
                          <div className="card-body p-0 animate__animated animate__fadeIn">
                            <div className="px-3 py-2 bg-warning-light small text-dark border-bottom">
                              <i className="fas fa-info-circle me-1"></i> Deselect specific steps for this patient if needed.
                            </div>
                            <div className="list-group list-group-flush" style={{ maxHeight: "250px", overflowY: "auto" }}>
                              {temp.exercises?.map((ex) => (
                                <div key={ex.id || ex.exercise_id} className="list-group-item d-flex align-items-center justify-content-between py-2 px-3 border-bottom-light">
                                  <div className="form-check small d-flex align-items-center">
                                    <input 
                                      type="checkbox" 
                                      className="form-check-input me-2"
                                      checked={templateExerciseSelections[temp.id]?.includes(Number(ex.exercise_id || ex.id))}
                                      onChange={() => toggleExerciseInTemplate(temp.id, ex.exercise_id || ex.id)}
                                    />
                                    <span className="text-dark fw-medium">{ex.exercise_title || ex.title}</span>
                                  </div>
                                  <button className="btn btn-xs btn-outline-info border-0 p-1 rounded-circle" onClick={() => handleOpenExercisePreview(ex.exercise_id || ex.id)}>
                                    <i className="fas fa-eye" style={{fontSize: '10px'}}></i>
                                  </button>
                                </div>
                              ))}
                            </div>
                          </div>
                        ) : (
                          <div className="card-body text-center py-5">
                            <p className="text-muted small italic mb-0">Click the header checkbox to customize this plan</p>
                          </div>
                        )}
                      </div>
                    </div>
                  );
                })}
              </div>
            )}
          </div>
        </div>

        {/* --- MODAL FOOTER --- */}
        <div className="modal-footer bg-white border-top-0 px-4 py-3">
          <div className="me-auto d-flex align-items-center">
             <div className="bg-secondary bg-opacity-10 text-secondary fw-bold rounded-pill px-4 py-2 small">
               <i className="fas fa-check-circle me-2"></i>
               {new Set([...selectedExerciseIds, ...(Object.values(templateExerciseSelections).flat())]).size} Exercises Ready
             </div>
          </div>
          <button className="btn btn-outline-secondary rounded-pill px-4 border-0" onClick={() => setShowExerciseModal(false)}>
            Close
          </button>
          <button 
            className="btn btn-info text-white rounded-pill px-5 shadow-lg fw-bold" 
            onClick={handleFinalAssignment} 
            disabled={isSaving}
          >
            {isSaving ? (
              <><span className="spinner-border spinner-border-sm me-2"></span>Processing...</>
            ) : (
              "Confirm Assignment"
            )}
          </button>
        </div>
      </div>
    </div>
  </div>
)}

<style>{`
  .bg-info-light { background-color: #e0f7fa; }
  .bg-warning-light { background-color: #fff8e1; }
  .border-bottom-light { border-bottom: 1px solid #f1f3f5; }
  .hover-bg-light:hover { background-color: #f8f9fa; }
  .transition-all { transition: all 0.2s ease-in-out; }
  .ring-active { box-shadow: 0 0 0 3px rgba(13, 202, 240, 0.2); }
  .nav-pills .nav-link.active { background-color: #0dcaf0 !important; }
  .hide-scrollbar::-webkit-scrollbar { display: none; }
  .hide-scrollbar { -ms-overflow-style: none; scrollbar-width: none; }
`}</style>
        {/* --- EXERCISE PDF VIEWER MODAL --- */}
        {showExercisePdfModal && pdfData.exercises && (
          <div
            className="modal show d-block"
            style={{ backgroundColor: "rgba(0,0,0,0.5)", zIndex: 1060 }}
          >
            <div className="modal-dialog modal-dialog-centered modal-xl">
              <div className="modal-content">
                <div className="modal-header bg-primary text-white">
                  <h5 className="modal-title">Exercise Chart Report</h5>
                  <button
                    type="button"
                    className="btn-close btn-close-white"
                    onClick={() => setShowExercisePdfModal(false)}
                  ></button>
                </div>
                <div className="modal-body" style={{ height: "80vh" }}>
                  <PDFViewer width="100%" height="100%">
                    <ExerciseChartPDF
                      exercises={pdfData.exercises}
                      patient={patient}
                      doctor={currentDoctor}
                      appointmentId={pdfData.appointmentId}
                      settings={pdfData.settings}
                      exerciseList={exerciseList}
                    />
                  </PDFViewer>
                </div>
              </div>
            </div>
          </div>
        )}

        {exercisePreview && (
          <div
            className="modal show d-block"
            style={{ backgroundColor: "rgba(0,0,0,0.7)", zIndex: 1100 }}
          >
            <div className="modal-dialog modal-lg modal-dialog-centered">
              <div className="modal-content border-0 shadow-lg">
                <div className="modal-header bg-info text-white">
                  <h5 className="modal-title">
                    <i className="fas fa-running me-2"></i> Exercise Preview:{" "}
                    {exercisePreview.title}
                  </h5>
                  <button
                    type="button"
                    className="btn-close btn-close-white"
                    onClick={() => setExercisePreview(null)}
                  ></button>
                </div>
                <div
                  className="modal-body p-4"
                  style={{ maxHeight: "70vh", overflowY: "auto" }}
                >
                  <p className="text-muted">{exercisePreview.description}</p>
                  <div className="row g-3">
                    {exercisePreview.steps?.map((step) => (
                      <div className="col-md-4" key={step.id}>
                        <div className="card h-100 shadow-none border">
                          <img
                            src={
                              step.image && step.image !== "null"
                                ? `${imgUrl}${step.image}`
                                : "/assets/img/placeholder.jpg"
                            }
                            className="card-img-top p-2"
                            style={{ height: "140px", objectFit: "contain" }}
                            alt={step.step_title}
                          />
                          <div className="card-body p-2 text-center small">
                            <strong className="text-info">
                              Step {step.step_number}
                            </strong>
                            <br />
                            <span className="fw-bold">{step.step_title}</span>
                          </div>
                        </div>
                      </div>
                    ))}
                  </div>
                </div>
                <div className="modal-footer">
                  <button
                    type="button"
                    className="btn btn-secondary rounded-pill px-4"
                    onClick={() => setExercisePreview(null)}
                  >
                    Close Preview
                  </button>
                </div>
              </div>
            </div>
          </div>
        )}
        {showViewPlanModal && viewingAssignmentPlan && (
  <div className="modal show d-block" style={{ backgroundColor: "rgba(0,0,0,0.7)", zIndex: 1100 }}>
    <div className="modal-dialog modal-lg modal-dialog-centered modal-dialog-scrollable">
      <div className="modal-content border-0 shadow-lg">
        
        <div className="modal-header bg-info text-white">
          <h5 className="modal-title">
            <i className="fas fa-eye me-2"></i> Plan Details (ID: #{viewingAssignmentPlan.id})
          </h5>
          <button type="button" className="btn-close btn-close-white" onClick={() => setShowViewPlanModal(false)}></button>
        </div>

        <div className="modal-body p-4 bg-light">
          {/* Quick Stats Overlay */}
          <div className="row g-2 mb-4">
            <div className="col-md-4">
               <div className="p-2 bg-white border rounded text-center shadow-sm">
                 <div className="text-muted x-small">Frequency</div>
                 <div className="fw-bold text-primary">{viewingAssignmentPlan.frequency}</div>
               </div>
            </div>
            <div className="col-md-4">
               <div className="p-2 bg-white border rounded text-center shadow-sm">
                 <div className="text-muted x-small">Timing</div>
                 <div className="fw-bold text-primary">{viewingAssignmentPlan.time_of_day}</div>
               </div>
            </div>
            <div className="col-md-4">
               <div className="p-2 bg-white border rounded text-center shadow-sm">
                 <div className="text-muted x-small">Assigned Date</div>
                 <div className="fw-bold text-secondary">{viewingAssignmentPlan.assigned_date}</div>
               </div>
            </div>
          </div>

          {/* Exercise List with Steps */}
          {viewingAssignmentPlan.assigned_exercises?.map((ex, i) => (
            <div key={`view-ex-${i}`} className="card mb-4 border-0 shadow-sm overflow-hidden rounded-3">
              <div className="card-header bg-white border-bottom py-2 px-3 d-flex justify-content-between align-items-center">
                <h6 className="mb-0 fw-bold text-dark">
                  <span className="badge bg-secondary me-2">{i+1}</span> {ex.exercise_title}
                </h6>
                <span className="badge bg-info bg-opacity-10 text-info border border-info border-opacity-25 px-2">
                  {ex.exercise_type || 'Exercise'}
                </span>
              </div>
              <div className="card-body p-3">
                <p className="text-muted small italic mb-3">{ex.description}</p>
                
                {/* Steps Horizontal Row */}
                <div className="row row-cols-1 row-cols-md-2 g-3">
                  {ex.steps?.map((step, j) => (
                    <div className="col" key={`step-${j}`}>
                      <div className="d-flex align-items-center p-2 bg-white border rounded h-100">
                        <img 
                          src={step.image ? `${imgUrl}${step.image}` : "/assets/img/placeholder.jpg"} 
                          className="rounded border" 
                          style={{ width: '70px', height: '70px', objectFit: 'cover' }} 
                          alt="exercise step"
                          onError={(e) => e.target.src = "/assets/img/placeholder.jpg"}
                        />
                        <div className="ms-3">
                          <div className="fw-bold small text-info">Step {step.step_number}</div>
                          <div className="fw-bold mb-1" style={{fontSize: '12px'}}>{step.step_title}</div>
                          <div className="text-primary small fw-bold">
                             <i className="far fa-clock me-1"></i>{step.duration_seconds}s
                          </div>
                        </div>
                      </div>
                    </div>
                  ))}
                </div>
              </div>
            </div>
          ))}
        </div>

        <div className="modal-footer bg-white border-top">
          <button className="btn btn-outline-secondary rounded-pill px-4" onClick={() => setShowViewPlanModal(false)}>Close</button>
          <button className="btn btn-success rounded-pill px-4" onClick={() => {
              // Same print logic but for single assignment
              const singleItem = { 
                exercises: [viewingAssignmentPlan], 
                appointmentId: currentAppointmentId,
                prescriptions: [], medicalRecord: null 
              };
              handleOpenPdf("exercise", singleItem);
          }}>
            <i className="fas fa-print me-2"></i>Print This Plan
          </button>
        </div>
      </div>
    </div>
  </div>
)}
{showDietPdfModal && pdfData.dietAssignments && (
  <div className="modal show d-block" style={{ backgroundColor: "rgba(0,0,0,0.5)", zIndex: 1060 }}>
    <div className="modal-dialog modal-dialog-centered modal-xl">
      <div className="modal-content">
        <div className="modal-header bg-warning text-white">
          <h5 className="modal-title">Diet Chart Report</h5>
          <button type="button" className="btn-close btn-close-white" onClick={() => setShowDietPdfModal(false)}></button>
        </div>
        <div className="modal-body" style={{ height: "80vh" }}>
          <PDFViewer width="100%" height="100%">
            <DietChartPDF
              diets={pdfData.dietAssignments}
              patient={patient}
              doctor={currentDoctor}
              appointmentId={pdfData.appointmentId}
              settings={pdfData.settings}
            />
          </PDFViewer>
        </div>
      </div>
    </div>
  </div>
)}
{/* --- VIEW DIET DETAILS MODAL --- */}
{/* {showViewDietModal && viewingDietPlan && (
  <div className="modal show d-block" style={{ backgroundColor: "rgba(0,0,0,0.7)", zIndex: 1100 }}>
    <div className="modal-dialog modal-lg modal-dialog-centered">
      <div className="modal-content border-0 shadow-lg">
        <div className="modal-header bg-warning text-white">
          <h5 className="modal-title"><i className="fas fa-utensils me-2"></i> Diet Plan Details</h5>
          <button type="button" className="btn-close btn-close-white" onClick={() => setShowViewDietModal(false)}></button>
        </div>
        <div className="modal-body p-4">
          <h6 className="fw-bold">{viewingDietPlan.assigned_diet_details?.title}</h6>
          <p className="text-muted small">Period: {viewingDietPlan.start_date} to {viewingDietPlan.end_date}</p>
          <div className="table-responsive">
            <table className="table table-sm border">
              <thead className="table-light">
                <tr>
                  <th>Meal</th>
                  <th>Food Items</th>
                </tr>
              </thead>
              <tbody>
                {viewingDietPlan.assigned_diet_details?.meals?.map((meal, idx) => (
                  <tr key={idx}>
                    <td className="fw-bold">{meal.meal_type}</td>
                    <td>{meal.food_items}<br/><small className="text-muted">{meal.instructions}</small></td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
        <div className="modal-footer">
          <button className="btn btn-secondary rounded-pill" onClick={() => setShowViewDietModal(false)}>Close</button>
        </div>
      </div>
    </div>
  </div>
)} */}
{showViewDietModal && viewingDietPlan && (
  <div className="modal show d-block" style={{ backgroundColor: "rgba(0,0,0,0.7)", zIndex: 1100 }}>
    <div className="modal-dialog modal-lg modal-dialog-centered modal-dialog-scrollable">
      <div className="modal-content border-0 shadow-lg">
        <div className="modal-header bg-warning text-white">
          <h5 className="modal-title"><i className="fas fa-utensils me-2"></i> Diet Plan Details</h5>
          <button type="button" className="btn-close btn-close-white" onClick={() => setShowViewDietModal(false)}></button>
        </div>
        <div className="modal-body p-4">
          <p className="text-muted small">Validity Period: <b>{viewingDietPlan.start_date}</b> to <b>{viewingDietPlan.end_date}</b></p>
          
          {/* Loop through all plans inside the assignment */}
          {viewingDietPlan.assigned_diets?.map((diet, idx) => (
            <div key={idx} className="mb-4 border rounded p-3 bg-white">
               <h6 className="fw-bold text-warning border-bottom pb-2">{diet.title} ({diet.diet_type})</h6>
               <p className="small text-muted">{diet.description}</p>
               <div className="table-responsive">
                <table className="table table-sm table-bordered">
                  <thead className="table-light">
                    <tr>
                      <th width="30%">Meal Type</th>
                      <th>Food & Instructions</th>
                    </tr>
                  </thead>
                  <tbody>
                    {diet.meals?.map((meal, mIdx) => (
                      <tr key={mIdx}>
                        <td className="fw-bold">{meal.meal_type}</td>
                        <td>
                          <div>{meal.food_items}</div>
                          <small className="text-muted italic">{meal.instructions}</small>
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            </div>
          ))}
        </div>
        <div className="modal-footer">
          <button className="btn btn-secondary rounded-pill" onClick={() => setShowViewDietModal(false)}>Close</button>
        </div>
      </div>
    </div>
  </div>
)}
        {playingVideoUrl && (
          <div
            className="modal show d-block"
            style={{ backgroundColor: "rgba(0,0,0,0.5)", zIndex: 1060 }}
          >
            <div className="modal-dialog modal-dialog-centered modal-lg">
              <div className="modal-content">
                <div className="modal-header">
                  <h5 className="modal-title">Video Recording</h5>
                  <button
                    type="button"
                    className="btn-close"
                    onClick={() => setPlayingVideoUrl(null)}
                  ></button>
                </div>
                <div
                  className="modal-body"
                  style={{
                    height: "70vh",
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                  }}
                >
                  <video
                    controls
                    autoPlay
                    style={{ maxWidth: "100%", maxHeight: "100%" }}
                  >
                    <source src={playingVideoUrl} type="video/mp4" />
                    Your browser does not support the video tag.
                  </video>
                </div>
                <div className="modal-footer">
                  <button
                    type="button"
                    className="btn btn-secondary"
                    onClick={() => setPlayingVideoUrl(null)}
                  >
                    Close
                  </button>
                </div>
              </div>
            </div>
          </div>
        )}
        <MessageModal
          show={modalShow}
          onClose={() => setModalShow(false)}
          title={modalTitle}
          message={modalMessage}
          variant={modalVariant}
        />
      </div>
    </>
  );
};

// --- Redux Connection ---
const mapStateToProps = (state) => ({
  // All existing state mappings
  profileData: state.doctorProfile.profileData,
  doctorLoading: state.doctorProfile.loading,
  profiles: state.patientProfile?.profiles || [],
  appointments: state.appointment?.all || [],
  prescriptionsList: state.prescription?.prescriptions || [],
  medicalRecords: state.medicalRecord?.records || [],
  invoices: state.invoice?.invoices || [],
  reportSettings: state.reportSettings?.settings || {},
  smsLoading: state.sms.loading,
  // Add video state to props
  video: state.video,
});

const mapDispatchToProps = {
  // All existing action mappings
  getAllAppointments,
  getAllPatientProfiles,
  createPrescription,
  getAllPrescriptions,
  updatePrescription,
  deletePrescription,
  createMedicalRecord,
  getAllMedicalRecords,
  deleteMedicalRecord,
  updateMedicalRecord,
  getDoctorProfileById,
  listAllInvoices,
   sendConfirmationSms,
  getReportSettings,
  updateAppointment,
  provisionVideoSession,
  patientGenerateToken,
  doctorRejoinSession,
  getExercise,
  
  getExerciseAssignments,
  createExerciseAssignment,
  updateExerciseAssignment,
  deleteExerciseAssignment,
};

// Wrap the export with withRouter to inject the history prop
export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(PatientProfilePage),
);
